import { isPlatformBrowser, isPlatformServer, CommonModule } from '@angular/common';
import { Subject, timer } from 'rxjs';
import { filter, map, switchMap, takeUntil } from 'rxjs/operators';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Directive, EventEmitter, HostListener, Input, Output, ElementRef, Renderer2, ChangeDetectionStrategy, Component, Inject, Injectable, InjectionToken, NgModule, ChangeDetectorRef, HostBinding, NgZone, PLATFORM_ID, ViewChild, defineInjectable } from '@angular/core';
import { DomSanitizer, HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Directive to close the modal gallery clicking on the semi-transparent background.
 * In fact, it listens for a click on all elements that aren't 'inside' and it emits
 * an event using `\@Output clickOutside`.
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/platform-browser';
import * as ɵngcc3 from '@angular/cdk/layout';

function BackgroundComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 1);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("title", ctx_r0.accessibilityConfig == null ? null : ctx_r0.accessibilityConfig.backgroundTitle);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r0.accessibilityConfig == null ? null : ctx_r0.accessibilityConfig.backgroundAriaLabel);
} }
const _c0 = function (a0, a1) { return { width: a0, height: a1 }; };
function CurrentImageComponent_ng_container_4_ng_container_1_img_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "img", 11);
    ɵngcc0.ɵɵlistener("click", function CurrentImageComponent_ng_container_4_ng_container_1_img_1_Template_img_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(3); return ctx_r9.onNavigationEvent("left", $event, ctx_r9.clickAction); })("keyup", function CurrentImageComponent_ng_container_4_ng_container_1_img_1_Template_img_keyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(3); return ctx_r11.onNavigationEvent("left", $event, ctx_r11.keyboardAction); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const leftPreview_r5 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("alt", leftPreview_r5.modal.alt ? leftPreview_r5.modal.alt : ctx_r6.getAltDescriptionByImage(leftPreview_r5));
    ɵngcc0.ɵɵproperty("src", (leftPreview_r5.plain == null ? null : leftPreview_r5.plain.img) ? leftPreview_r5.plain.img : leftPreview_r5.modal.img, ɵngcc0.ɵɵsanitizeUrl)("hidden", ctx_r6.loading)("sizeConfig", ɵngcc0.ɵɵpureFunction2(7, _c0, ctx_r6.configSlide.sidePreviews == null ? null : ctx_r6.configSlide.sidePreviews.size.width, ctx_r6.configSlide.sidePreviews == null ? null : ctx_r6.configSlide.sidePreviews.size.height))("title", leftPreview_r5.modal.title ? leftPreview_r5.modal.title : ctx_r6.getDescriptionToDisplay(leftPreview_r5))("tabindex", 0);
    ɵngcc0.ɵɵattribute("aria-label", leftPreview_r5.modal.ariaLabel);
} }
function CurrentImageComponent_ng_container_4_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 12);
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("sizeConfig", ɵngcc0.ɵɵpureFunction2(1, _c0, ctx_r8.configSlide.sidePreviews == null ? null : ctx_r8.configSlide.sidePreviews.size.width, ctx_r8.configSlide.sidePreviews == null ? null : ctx_r8.configSlide.sidePreviews.size.height));
} }
function CurrentImageComponent_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CurrentImageComponent_ng_container_4_ng_container_1_img_1_Template, 1, 10, "img", 9);
    ɵngcc0.ɵɵtemplate(2, CurrentImageComponent_ng_container_4_ng_container_1_ng_template_2_Template, 1, 4, "ng-template", null, 10, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r7 = ɵngcc0.ɵɵreference(3);
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.isFirstImage)("ngIfElse", _r7);
} }
function CurrentImageComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CurrentImageComponent_ng_container_4_ng_container_1_Template, 4, 2, "ng-container", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.getLeftPreviewImage());
} }
function CurrentImageComponent_figcaption_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "figcaption", 13);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("description", ctx_r1.configCurrentImage == null ? null : ctx_r1.configCurrentImage.description)("innerHTML", ctx_r1.getDescriptionToDisplay(), ɵngcc0.ɵɵsanitizeHtml);
} }
function CurrentImageComponent_ng_container_9_ng_container_1_img_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "img", 16);
    ɵngcc0.ɵɵlistener("click", function CurrentImageComponent_ng_container_9_ng_container_1_img_1_Template_img_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(3); return ctx_r18.onNavigationEvent("right", $event, ctx_r18.clickAction); })("keyup", function CurrentImageComponent_ng_container_9_ng_container_1_img_1_Template_img_keyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r20 = ɵngcc0.ɵɵnextContext(3); return ctx_r20.onNavigationEvent("right", $event, ctx_r20.keyboardAction); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const rightPreview_r14 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("alt", rightPreview_r14.modal.alt ? rightPreview_r14.modal.alt : ctx_r15.getAltDescriptionByImage(rightPreview_r14));
    ɵngcc0.ɵɵproperty("src", (rightPreview_r14.plain == null ? null : rightPreview_r14.plain.img) ? rightPreview_r14.plain.img : rightPreview_r14.modal.img, ɵngcc0.ɵɵsanitizeUrl)("hidden", ctx_r15.loading)("sizeConfig", ɵngcc0.ɵɵpureFunction2(7, _c0, ctx_r15.slideConfig.sidePreviews == null ? null : ctx_r15.slideConfig.sidePreviews.size.width, ctx_r15.slideConfig.sidePreviews == null ? null : ctx_r15.slideConfig.sidePreviews.size.height))("title", rightPreview_r14.modal.title ? rightPreview_r14.modal.title : ctx_r15.getDescriptionToDisplay(rightPreview_r14))("tabindex", 0);
    ɵngcc0.ɵɵattribute("aria-label", rightPreview_r14.modal.ariaLabel);
} }
function CurrentImageComponent_ng_container_9_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 17);
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("sizeConfig", ɵngcc0.ɵɵpureFunction2(1, _c0, ctx_r17.slideConfig.sidePreviews == null ? null : ctx_r17.slideConfig.sidePreviews.size.width, ctx_r17.slideConfig.sidePreviews == null ? null : ctx_r17.slideConfig.sidePreviews.size.height));
} }
function CurrentImageComponent_ng_container_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CurrentImageComponent_ng_container_9_ng_container_1_img_1_Template, 1, 10, "img", 14);
    ɵngcc0.ɵɵtemplate(2, CurrentImageComponent_ng_container_9_ng_container_1_ng_template_2_Template, 1, 4, "ng-template", null, 15, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r16 = ɵngcc0.ɵɵreference(3);
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r13.isLastImage)("ngIfElse", _r16);
} }
function CurrentImageComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CurrentImageComponent_ng_container_9_ng_container_1_Template, 4, 2, "ng-container", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.getRightPreviewImage());
} }
function CurrentImageComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "ks-loading-spinner", 18);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("loadingConfig", ctx_r3.configCurrentImage == null ? null : ctx_r3.configCurrentImage.loadingConfig)("accessibilityConfig", ctx_r3.accessibilityConfig);
} }
function ModalGalleryComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵlistener("clickOutside", function ModalGalleryComponent_div_2_Template_div_clickOutside_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.onClickOutside($event); });
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "div", 5);
    ɵngcc0.ɵɵelementStart(3, "ks-upper-buttons", 6);
    ɵngcc0.ɵɵlistener("delete", function ModalGalleryComponent_div_2_Template_ks_upper_buttons_delete_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onDelete($event); })("navigate", function ModalGalleryComponent_div_2_Template_ks_upper_buttons_navigate_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onNavigate($event); })("download", function ModalGalleryComponent_div_2_Template_ks_upper_buttons_download_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onDownload($event); })("close", function ModalGalleryComponent_div_2_Template_ks_upper_buttons_close_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onCloseGallery($event); })("fullscreen", function ModalGalleryComponent_div_2_Template_ks_upper_buttons_fullscreen_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onFullScreen($event); })("customEmit", function ModalGalleryComponent_div_2_Template_ks_upper_buttons_customEmit_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onCustomEmit($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "ks-current-image", 7);
    ɵngcc0.ɵɵlistener("loadImage", function ModalGalleryComponent_div_2_Template_ks_current_image_loadImage_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onImageLoad($event); })("changeImage", function ModalGalleryComponent_div_2_Template_ks_current_image_changeImage_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.onChangeCurrentImage($event); })("close", function ModalGalleryComponent_div_2_Template_ks_current_image_close_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onCloseGallery($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div");
    ɵngcc0.ɵɵelementStart(6, "ks-dots", 8);
    ɵngcc0.ɵɵlistener("clickDot", function ModalGalleryComponent_div_2_Template_ks_dots_clickDot_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onClickDot($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "ks-previews", 9);
    ɵngcc0.ɵɵlistener("clickPreview", function ModalGalleryComponent_div_2_Template_ks_previews_clickPreview_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.onClickPreview($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("title", ctx_r0.accessibilityConfig.modalGalleryContentTitle)("clickOutsideEnable", ctx_r0.enableCloseOutside);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r0.accessibilityConfig.modalGalleryContentAriaLabel);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("currentImage", ctx_r0.currentImage)("buttonsConfig", ctx_r0.buttonsConfig);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", ctx_r0.id)("images", ctx_r0.images)("currentImage", ctx_r0.currentImage)("isOpen", ctx_r0.opened)("slideConfig", ctx_r0.configSlide)("keyboardConfig", ctx_r0.keyboardConfig)("accessibilityConfig", ctx_r0.accessibilityConfig)("currentImageConfig", ctx_r0.currentImageConfig);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("images", ctx_r0.images)("currentImage", ctx_r0.currentImage)("dotsConfig", ctx_r0.dotsConfig)("accessibilityConfig", ctx_r0.accessibilityConfig);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("images", ctx_r0.images)("currentImage", ctx_r0.currentImage)("previewConfig", ctx_r0.previewConfig)("accessibilityConfig", ctx_r0.accessibilityConfig);
} }
function CarouselComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function CarouselComponent_figure_3_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 14);
    ɵngcc0.ɵɵlistener("click", function CarouselComponent_figure_3_a_1_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.onNavigationEvent("left", $event, ctx_r9.clickAction); })("keyup", function CarouselComponent_figure_3_a_1_Template_a_keyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.onNavigationEvent("left", $event, ctx_r11.keyboardAction); });
    ɵngcc0.ɵɵelement(1, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("tabindex", ctx_r5.isLastImage && !ctx_r5.infinite ? -1 : 0);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r5.accessibilityConfig.carouselPrevImageAriaLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("inside ", ctx_r5.isFirstImage && !ctx_r5.infinite || !ctx_r5.configCarousel.showArrows ? "empty-arrow-image" : "left-arrow-image", "");
    ɵngcc0.ɵɵproperty("title", ctx_r5.accessibilityConfig.carouselPrevImageTitle);
} }
function CarouselComponent_figure_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CarouselComponent_figure_3_figcaption_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "figcaption", 16);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("description", ctx_r7.configCurrentImageCarousel == null ? null : ctx_r7.configCurrentImageCarousel.description)("innerHTML", ctx_r7.getDescriptionToDisplay(), ɵngcc0.ɵɵsanitizeHtml);
} }
function CarouselComponent_figure_3_a_5_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 17);
    ɵngcc0.ɵɵlistener("click", function CarouselComponent_figure_3_a_5_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.onNavigationEvent("right", $event, ctx_r12.clickAction); })("keyup", function CarouselComponent_figure_3_a_5_Template_a_keyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.onNavigationEvent("right", $event, ctx_r14.keyboardAction); });
    ɵngcc0.ɵɵelement(1, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("tabindex", ctx_r8.isLastImage && !ctx_r8.infinite ? -1 : 0);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r8.accessibilityConfig.carouselNextImageAriaLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("inside ", ctx_r8.isLastImage && !ctx_r8.infinite || !ctx_r8.configCarousel.showArrows ? "empty-arrow-image" : "right-arrow-image", "");
    ɵngcc0.ɵɵproperty("title", ctx_r8.accessibilityConfig.carouselNextImageTitle);
} }
const _c1 = function (a0) { return { width: a0, height: "" }; };
const _c2 = function (a0, a1) { return { maxWidth: a0, maxHeight: a1 }; };
function CarouselComponent_figure_3_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "figure", 6);
    ɵngcc0.ɵɵtemplate(1, CarouselComponent_figure_3_a_1_Template, 2, 6, "a", 7);
    ɵngcc0.ɵɵtemplate(2, CarouselComponent_figure_3_ng_container_2_Template, 1, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementStart(3, "img", 9);
    ɵngcc0.ɵɵlistener("click", function CarouselComponent_figure_3_Template_img_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onClickCurrentImage(); })("swipeleft", function CarouselComponent_figure_3_Template_img_swipeleft_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.swipe($event.type); })("swiperight", function CarouselComponent_figure_3_Template_img_swiperight_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.swipe($event.type); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, CarouselComponent_figure_3_figcaption_4_Template, 1, 2, "figcaption", 10);
    ɵngcc0.ɵɵtemplate(5, CarouselComponent_figure_3_a_5_Template, 2, 6, "a", 11);
    ɵngcc0.ɵɵelementStart(6, "div", 12);
    ɵngcc0.ɵɵelementStart(7, "ks-dots", 13);
    ɵngcc0.ɵɵlistener("clickDot", function CarouselComponent_figure_3_Template_ks_dots_clickDot_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.onClickDot($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵproperty("sizeConfig", ɵngcc0.ɵɵpureFunction1(17, _c1, ctx_r2.configCarousel == null ? null : ctx_r2.configCarousel.maxWidth));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.configCarousel == null ? null : ctx_r2.configCarousel.showArrows);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("object-fit", ctx_r2.configCarousel == null ? null : ctx_r2.configCarousel.objectFit);
    ɵngcc0.ɵɵpropertyInterpolate("alt", ctx_r2.currentImage.modal.alt ? ctx_r2.currentImage.modal.alt : ctx_r2.getAltDescriptionByImage());
    ɵngcc0.ɵɵproperty("sizeConfig", ɵngcc0.ɵɵpureFunction2(19, _c2, ctx_r2.configCarousel == null ? null : ctx_r2.configCarousel.maxWidth, ctx_r2.configCarousel == null ? null : ctx_r2.configCarousel.maxHeight))("src", ctx_r2.currentImage.modal.img, ɵngcc0.ɵɵsanitizeUrl)("title", ctx_r2.currentImage.modal.title ? ctx_r2.currentImage.modal.title : ctx_r2.getTitleToDisplay())("tabindex", 0);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.currentImage.modal.ariaLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.getDescriptionToDisplay() !== "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.configCarousel == null ? null : ctx_r2.configCarousel.showArrows);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("currentImage", ctx_r2.currentImage)("dotsConfig", ctx_r2.configDots)("accessibilityConfig", ctx_r2.accessibilityConfig)("images", ctx_r2.images);
} }
function CarouselComponent_ng_template_4_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 14);
    ɵngcc0.ɵɵlistener("click", function CarouselComponent_ng_template_4_a_1_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.onNavigationEvent("left", $event, ctx_r24.clickAction); })("keyup", function CarouselComponent_ng_template_4_a_1_Template_a_keyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.onNavigationEvent("left", $event, ctx_r26.keyboardAction); });
    ɵngcc0.ɵɵelement(1, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("tabindex", ctx_r20.isLastImage && !ctx_r20.infinite ? -1 : 0);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r20.accessibilityConfig.carouselPrevImageAriaLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("inside ", ctx_r20.isFirstImage && !ctx_r20.infinite || !ctx_r20.configCarousel.showArrows ? "empty-arrow-image" : "left-arrow-image", "");
    ɵngcc0.ɵɵproperty("title", ctx_r20.accessibilityConfig.carouselPrevImageTitle);
} }
function CarouselComponent_ng_template_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CarouselComponent_ng_template_4_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 21);
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("description", ctx_r22.configCurrentImageCarousel == null ? null : ctx_r22.configCurrentImageCarousel.description)("innerHTML", ctx_r22.getDescriptionToDisplay(), ɵngcc0.ɵɵsanitizeHtml);
} }
function CarouselComponent_ng_template_4_a_5_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 17);
    ɵngcc0.ɵɵlistener("click", function CarouselComponent_ng_template_4_a_5_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ctx_r27.onNavigationEvent("right", $event, ctx_r27.clickAction); })("keyup", function CarouselComponent_ng_template_4_a_5_Template_a_keyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r29 = ɵngcc0.ɵɵnextContext(2); return ctx_r29.onNavigationEvent("right", $event, ctx_r29.keyboardAction); });
    ɵngcc0.ɵɵelement(1, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("tabindex", ctx_r23.isLastImage && !ctx_r23.infinite ? -1 : 0);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r23.accessibilityConfig.carouselNextImageAriaLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("inside ", ctx_r23.isLastImage && !ctx_r23.infinite || !ctx_r23.configCarousel.showArrows ? "empty-arrow-image" : "right-arrow-image", "");
    ɵngcc0.ɵɵproperty("title", ctx_r23.accessibilityConfig.carouselNextImageTitle);
} }
const _c3 = function (a1) { return { width: "100%", height: a1 }; };
const _c4 = function (a0) { return { maxWidth: a0 }; };
function CarouselComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtemplate(1, CarouselComponent_ng_template_4_a_1_Template, 2, 6, "a", 7);
    ɵngcc0.ɵɵtemplate(2, CarouselComponent_ng_template_4_ng_container_2_Template, 1, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementStart(3, "div", 18);
    ɵngcc0.ɵɵlistener("click", function CarouselComponent_ng_template_4_Template_div_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r30 = ɵngcc0.ɵɵnextContext(); return ctx_r30.onClickCurrentImage(); })("swipeleft", function CarouselComponent_ng_template_4_Template_div_swipeleft_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r32 = ɵngcc0.ɵɵnextContext(); return ctx_r32.swipe($event.type); })("swiperight", function CarouselComponent_ng_template_4_Template_div_swiperight_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r33 = ɵngcc0.ɵɵnextContext(); return ctx_r33.swipe($event.type); });
    ɵngcc0.ɵɵtemplate(4, CarouselComponent_ng_template_4_div_4_Template, 1, 2, "div", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, CarouselComponent_ng_template_4_a_5_Template, 2, 6, "a", 11);
    ɵngcc0.ɵɵelementStart(6, "div", 20);
    ɵngcc0.ɵɵelementStart(7, "ks-dots", 13);
    ɵngcc0.ɵɵlistener("clickDot", function CarouselComponent_ng_template_4_Template_ks_dots_clickDot_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r34 = ɵngcc0.ɵɵnextContext(); return ctx_r34.onClickDot($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵproperty("sizeConfig", ɵngcc0.ɵɵpureFunction1(26, _c1, ctx_r4.configCarousel == null ? null : ctx_r4.configCarousel.maxWidth));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.configCarousel == null ? null : ctx_r4.configCarousel.showArrows);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("background-color", "transparent")("background-image", ctx_r4.sanitizeUrlBgStyle(ctx_r4.currentImage.modal.img + ""))("background-position", "center center")("background-size", "cover")("background-repeat", "no-repeat")("background-attachment", "scroll");
    ɵngcc0.ɵɵproperty("sizeConfig", ɵngcc0.ɵɵpureFunction1(28, _c3, ctx_r4.configCarousel == null ? null : ctx_r4.configCarousel.maxHeight))("sizeConfig", ɵngcc0.ɵɵpureFunction1(30, _c4, ctx_r4.configCarousel == null ? null : ctx_r4.configCarousel.maxWidth))("title", ctx_r4.currentImage.modal.title ? ctx_r4.currentImage.modal.title : ctx_r4.getTitleToDisplay())("tabindex", 0);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r4.currentImage.modal.ariaLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.getDescriptionToDisplay() !== "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.configCarousel == null ? null : ctx_r4.configCarousel.showArrows);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("currentImage", ctx_r4.currentImage)("dotsConfig", ctx_r4.configDots)("accessibilityConfig", ctx_r4.accessibilityConfig)("images", ctx_r4.images);
} }
const _c5 = function (a0) { return { maxWidth: a0, maxHeight: "" }; };
const _c6 = ["*"];
const _c7 = ".arrow-image[_ngcontent-%COMP%], .empty-arrow-image[_ngcontent-%COMP%], .left-arrow-image[_ngcontent-%COMP%], .right-arrow-image[_ngcontent-%COMP%]{width:30px;height:30px;background-size:30px}.empty-arrow-image[_ngcontent-%COMP%]{background:#000;opacity:0}.left-arrow-image[_ngcontent-%COMP%]{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3Ny4xNzUgNDc3LjE3NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDc3LjE3NSA0NzcuMTc1OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij48Zz48cGF0aCBkPSJNMTQ1LjE4OCwyMzguNTc1bDIxNS41LTIxNS41YzUuMy01LjMsNS4zLTEzLjgsMC0xOS4xcy0xMy44LTUuMy0xOS4xLDBsLTIyNS4xLDIyNS4xYy01LjMsNS4zLTUuMywxMy44LDAsMTkuMWwyMjUuMSwyMjUgICBjMi42LDIuNiw2LjEsNCw5LjUsNHM2LjktMS4zLDkuNS00YzUuMy01LjMsNS4zLTEzLjgsMC0xOS4xTDE0NS4xODgsMjM4LjU3NXoiIGZpbGw9IiNGRkZGRkYiLz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+);opacity:.8;transition:.5s}.left-arrow-image[_ngcontent-%COMP%]:hover{transform:scale(1.2)}.right-arrow-image[_ngcontent-%COMP%]{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3Ny4xNzUgNDc3LjE3NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDc3LjE3NSA0NzcuMTc1OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij48Zz48cGF0aCBkPSJNMzYwLjczMSwyMjkuMDc1bC0yMjUuMS0yMjUuMWMtNS4zLTUuMy0xMy44LTUuMy0xOS4xLDBzLTUuMywxMy44LDAsMTkuMWwyMTUuNSwyMTUuNWwtMjE1LjUsMjE1LjUgICBjLTUuMyw1LjMtNS4zLDEzLjgsMCwxOS4xYzIuNiwyLjYsNi4xLDQsOS41LDRjMy40LDAsNi45LTEuMyw5LjUtNGwyMjUuMS0yMjUuMUMzNjUuOTMxLDI0Mi44NzUsMzY1LjkzMSwyMzQuMjc1LDM2MC43MzEsMjI5LjA3NXogICAiIGZpbGw9IiNGRkZGRkYiLz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+);opacity:.8;transition:.5s}.right-arrow-image[_ngcontent-%COMP%]:hover{transform:scale(1.2)}";
function CarouselPreviewsComponent_nav_0_ng_container_4_ng_container_1_img_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "img", 10);
    ɵngcc0.ɵɵlistener("click", function CarouselPreviewsComponent_nav_0_ng_container_4_ng_container_1_img_1_Template_img_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const preview_r2 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.onImageEvent(preview_r2, $event, ctx_r8.clickAction); })("keyup", function CarouselPreviewsComponent_nav_0_ng_container_4_ng_container_1_img_1_Template_img_keyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const preview_r2 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.onImageEvent(preview_r2, $event, ctx_r11.keyboardAction); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const preview_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMapInterpolate2("inside preview-image", ctx_r7.isActive(preview_r2) ? " active" : "", "", !ctx_r7.configPreview.clickable ? " unclickable" : "", "");
    ɵngcc0.ɵɵpropertyInterpolate("alt", ctx_r7.getAlt(preview_r2));
    ɵngcc0.ɵɵproperty("src", (preview_r2.plain == null ? null : preview_r2.plain.img) ? preview_r2.plain.img : preview_r2.modal.img, ɵngcc0.ɵɵsanitizeUrl)("sizeConfig", ɵngcc0.ɵɵpureFunction2(10, _c0, ctx_r7.configPreview == null ? null : ctx_r7.configPreview.width, ctx_r7.configPreview == null ? null : ctx_r7.configPreview.maxHeight))("title", ctx_r7.getTitle(preview_r2))("tabindex", 0);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r7.getAriaLabel(preview_r2));
} }
function CarouselPreviewsComponent_nav_0_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CarouselPreviewsComponent_nav_0_ng_container_4_ng_container_1_img_1_Template, 1, 13, "img", 9);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const preview_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", preview_r2 == null ? null : preview_r2.modal == null ? null : preview_r2.modal.img);
} }
function CarouselPreviewsComponent_nav_0_ng_container_4_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵlistener("click", function CarouselPreviewsComponent_nav_0_ng_container_4_ng_template_2_div_0_Template_div_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const preview_r2 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.onImageEvent(preview_r2, $event, ctx_r16.clickAction); })("keyup", function CarouselPreviewsComponent_nav_0_ng_container_4_ng_template_2_div_0_Template_div_keyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const preview_r2 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.onImageEvent(preview_r2, $event, ctx_r19.keyboardAction); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const preview_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMapInterpolate2("inside preview-ie11-image", ctx_r15.isActive(preview_r2) ? " active" : "", "", !ctx_r15.configPreview.clickable ? " unclickable" : "", "");
    ɵngcc0.ɵɵstyleProp("background-color", "transparent")("background-image", ctx_r15.sanitizeUrlBgStyle((preview_r2.plain == null ? null : preview_r2.plain.img) ? preview_r2.plain.img : preview_r2.modal.img))("background-position", "center center")("background-size", ctx_r15.getIE11LegacyBgSize())("background-repeat", "no-repeat")("background-attachment", "scroll");
    ɵngcc0.ɵɵproperty("sizeConfig", ɵngcc0.ɵɵpureFunction2(20, _c0, ctx_r15.configPreview == null ? null : ctx_r15.configPreview.width, ctx_r15.configPreview == null ? null : ctx_r15.configPreview.maxHeight))("title", ctx_r15.getTitle(preview_r2))("tabindex", 0);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r15.getAriaLabel(preview_r2));
} }
function CarouselPreviewsComponent_nav_0_ng_container_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, CarouselPreviewsComponent_nav_0_ng_container_4_ng_template_2_div_0_Template, 1, 23, "div", 11);
} if (rf & 2) {
    const preview_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngIf", preview_r2 == null ? null : preview_r2.modal == null ? null : preview_r2.modal.img);
} }
function CarouselPreviewsComponent_nav_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CarouselPreviewsComponent_nav_0_ng_container_4_ng_container_1_Template, 2, 1, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(2, CarouselPreviewsComponent_nav_0_ng_container_4_ng_template_2_Template, 1, 1, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r5 = ɵngcc0.ɵɵreference(3);
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r1.carouselConfig == null ? null : ctx_r1.carouselConfig.legacyIE11Mode))("ngIfElse", _r5);
} }
function CarouselPreviewsComponent_nav_0_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "nav", 1);
    ɵngcc0.ɵɵelementStart(1, "a", 2);
    ɵngcc0.ɵɵlistener("click", function CarouselPreviewsComponent_nav_0_Template_a_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.onNavigationEvent("left", $event); })("keyup", function CarouselPreviewsComponent_nav_0_Template_a_keyup_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.onNavigationEvent("left", $event); });
    ɵngcc0.ɵɵelement(2, "div", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵtemplate(4, CarouselPreviewsComponent_nav_0_ng_container_4_Template, 4, 2, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "a", 6);
    ɵngcc0.ɵɵlistener("click", function CarouselPreviewsComponent_nav_0_Template_a_click_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.onNavigationEvent("right", $event); })("keyup", function CarouselPreviewsComponent_nav_0_Template_a_keyup_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.onNavigationEvent("right", $event); });
    ɵngcc0.ɵɵelement(6, "div", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("title", ctx_r0.accessibilityConfig == null ? null : ctx_r0.accessibilityConfig.carouselPreviewsContainerTitle);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r0.accessibilityConfig == null ? null : ctx_r0.accessibilityConfig.carouselPreviewsContainerAriaLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("tabindex", ctx_r0.configPreview.arrows && ctx_r0.start > 0 ? 0 : -1);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r0.accessibilityConfig == null ? null : ctx_r0.accessibilityConfig.carouselPreviewScrollPrevAriaLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("inside ", ctx_r0.configPreview.arrows && ctx_r0.start > 0 ? "left-arrow-preview-image" : "empty-arrow-preview-image", "");
    ɵngcc0.ɵɵproperty("title", ctx_r0.accessibilityConfig == null ? null : ctx_r0.accessibilityConfig.carouselPreviewScrollPrevTitle);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.previews)("ngForTrackBy", ctx_r0.trackById);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("tabindex", ctx_r0.configPreview.arrows && ctx_r0.end < ctx_r0.images.length ? 0 : -1);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r0.accessibilityConfig == null ? null : ctx_r0.accessibilityConfig.carouselPreviewScrollNextAriaLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("inside ", ctx_r0.configPreview.arrows && ctx_r0.end < ctx_r0.images.length ? "right-arrow-preview-image" : "empty-arrow-preview-image", "");
    ɵngcc0.ɵɵproperty("title", ctx_r0.accessibilityConfig == null ? null : ctx_r0.accessibilityConfig.carouselPreviewScrollNextTitle);
} }
const _c8 = function (a0) { return { "font-size": a0 }; };
function UpperButtonsComponent_ng_container_1_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 3);
    ɵngcc0.ɵɵlistener("click", function UpperButtonsComponent_ng_container_1_a_1_Template_a_click_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const btn_r2 = restoredCtx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.onEvent(btn_r2, $event); })("keyup", function UpperButtonsComponent_ng_container_1_a_1_Template_a_keyup_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const btn_r2 = restoredCtx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.onEvent(btn_r2, $event); });
    ɵngcc0.ɵɵelement(1, "div", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("sizeConfig", ɵngcc0.ɵɵpureFunction2(8, _c0, btn_r2.size == null ? null : btn_r2.size.width, btn_r2.size == null ? null : btn_r2.size.height))("ngStyle", ɵngcc0.ɵɵpureFunction1(11, _c8, btn_r2.fontSize))("tabindex", 0);
    ɵngcc0.ɵɵattribute("aria-label", btn_r2.ariaLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("inside ", btn_r2.className, "");
    ɵngcc0.ɵɵpropertyInterpolate("title", btn_r2.title);
} }
function UpperButtonsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, UpperButtonsComponent_ng_container_1_a_1_Template, 2, 13, "a", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.buttons)("ngForTrackBy", ctx_r0.trackById);
} }
const _c9 = function (a0) { return { "active": a0 }; };
function DotsComponent_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵlistener("click", function DotsComponent_ng_container_1_div_1_Template_div_click_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const index_r3 = restoredCtx.index; const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.onDotEvent(index_r3, $event); })("keyup", function DotsComponent_ng_container_1_div_1_Template_div_keyup_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const index_r3 = restoredCtx.index; const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.onDotEvent(index_r3, $event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const index_r3 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c9, ctx_r1.isActive(index_r3)))("tabindex", 0);
    ɵngcc0.ɵɵattribute("aria-label", (ctx_r1.accessibilityConfig == null ? null : ctx_r1.accessibilityConfig.dotAriaLabel) + " " + (index_r3 + 1));
} }
function DotsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DotsComponent_ng_container_1_div_1_Template, 1, 5, "div", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.images)("ngForTrackBy", ctx_r0.trackById);
} }
function PreviewsComponent_ng_container_1_ng_container_3_img_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "img", 7);
    ɵngcc0.ɵɵlistener("click", function PreviewsComponent_ng_container_1_ng_container_3_img_1_Template_img_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const preview_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.onImageEvent(preview_r2, $event, ctx_r5.clickAction); })("keyup", function PreviewsComponent_ng_container_1_ng_container_3_img_1_Template_img_keyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const preview_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.onImageEvent(preview_r2, $event, ctx_r8.keyboardAction); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const preview_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMapInterpolate2("inside preview-image ", ctx_r4.isActive(preview_r2) ? "active" : "", "", !ctx_r4.configPreview.clickable ? " unclickable" : "", "");
    ɵngcc0.ɵɵpropertyInterpolate("alt", preview_r2.modal.alt ? preview_r2.modal.alt : "");
    ɵngcc0.ɵɵproperty("src", (preview_r2.plain == null ? null : preview_r2.plain.img) ? preview_r2.plain.img : preview_r2.modal.img, ɵngcc0.ɵɵsanitizeUrl)("sizeConfig", ɵngcc0.ɵɵpureFunction2(10, _c0, ctx_r4.configPreview.size ? ctx_r4.configPreview.size.width : ctx_r4.defaultPreviewSize.width, ctx_r4.configPreview.size ? ctx_r4.configPreview.size.height : ctx_r4.defaultPreviewSize.height))("title", preview_r2.modal.title ? preview_r2.modal.title : "")("tabindex", 0);
    ɵngcc0.ɵɵattribute("aria-label", preview_r2.modal.ariaLabel ? preview_r2.modal.ariaLabel : "");
} }
function PreviewsComponent_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PreviewsComponent_ng_container_1_ng_container_3_img_1_Template, 1, 13, "img", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const preview_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", preview_r2 == null ? null : preview_r2.modal == null ? null : preview_r2.modal.img);
} }
function PreviewsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a", 2);
    ɵngcc0.ɵɵlistener("click", function PreviewsComponent_ng_container_1_Template_a_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onNavigationEvent("left", $event); })("keyup", function PreviewsComponent_ng_container_1_Template_a_keyup_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.onNavigationEvent("left", $event); });
    ɵngcc0.ɵɵelement(2, "div", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, PreviewsComponent_ng_container_1_ng_container_3_Template, 2, 1, "ng-container", 4);
    ɵngcc0.ɵɵelementStart(4, "a", 5);
    ɵngcc0.ɵɵlistener("click", function PreviewsComponent_ng_container_1_Template_a_click_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onNavigationEvent("right", $event); })("keyup", function PreviewsComponent_ng_container_1_Template_a_keyup_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onNavigationEvent("right", $event); });
    ɵngcc0.ɵɵelement(5, "div", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("tabindex", ctx_r0.configPreview.arrows && ctx_r0.start > 0 ? 0 : -1);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r0.accessibilityConfig == null ? null : ctx_r0.accessibilityConfig.previewScrollPrevAriaLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("inside ", ctx_r0.configPreview.arrows && ctx_r0.start > 0 ? "left-arrow-preview-image" : "empty-arrow-preview-image", "");
    ɵngcc0.ɵɵproperty("title", ctx_r0.accessibilityConfig == null ? null : ctx_r0.accessibilityConfig.previewScrollPrevTitle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.previews)("ngForTrackBy", ctx_r0.trackById);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("tabindex", ctx_r0.configPreview.arrows && ctx_r0.end < ctx_r0.images.length ? 0 : -1);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r0.accessibilityConfig == null ? null : ctx_r0.accessibilityConfig.previewScrollNextAriaLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("inside ", ctx_r0.configPreview.arrows && ctx_r0.end < ctx_r0.images.length ? "right-arrow-preview-image" : "empty-arrow-preview-image", "");
    ɵngcc0.ɵɵproperty("title", ctx_r0.accessibilityConfig == null ? null : ctx_r0.accessibilityConfig.previewScrollNextTitle);
} }
const _c10 = ".arrow-preview-image[_ngcontent-%COMP%], .empty-arrow-preview-image[_ngcontent-%COMP%], .left-arrow-preview-image[_ngcontent-%COMP%], .right-arrow-preview-image[_ngcontent-%COMP%]{width:15px;height:15px;opacity:.5}.empty-arrow-preview-image[_ngcontent-%COMP%]{background:#000;opacity:0}.left-arrow-preview-image[_ngcontent-%COMP%]{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3Ny4xNzUgNDc3LjE3NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDc3LjE3NSA0NzcuMTc1OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij48Zz48cGF0aCBkPSJNMTQ1LjE4OCwyMzguNTc1bDIxNS41LTIxNS41YzUuMy01LjMsNS4zLTEzLjgsMC0xOS4xcy0xMy44LTUuMy0xOS4xLDBsLTIyNS4xLDIyNS4xYy01LjMsNS4zLTUuMywxMy44LDAsMTkuMWwyMjUuMSwyMjUgICBjMi42LDIuNiw2LjEsNCw5LjUsNHM2LjktMS4zLDkuNS00YzUuMy01LjMsNS4zLTEzLjgsMC0xOS4xTDE0NS4xODgsMjM4LjU3NXoiIGZpbGw9IiNGRkZGRkYiLz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+);background-size:15px;transition:.5s}.left-arrow-preview-image[_ngcontent-%COMP%]:hover{transform:scale(1.2)}.right-arrow-preview-image[_ngcontent-%COMP%]{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3Ny4xNzUgNDc3LjE3NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDc3LjE3NSA0NzcuMTc1OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij48Zz48cGF0aCBkPSJNMzYwLjczMSwyMjkuMDc1bC0yMjUuMS0yMjUuMWMtNS4zLTUuMy0xMy44LTUuMy0xOS4xLDBzLTUuMywxMy44LDAsMTkuMWwyMTUuNSwyMTUuNWwtMjE1LjUsMjE1LjUgICBjLTUuMyw1LjMtNS4zLDEzLjgsMCwxOS4xYzIuNiwyLjYsNi4xLDQsOS41LDRjMy40LDAsNi45LTEuMyw5LjUtNGwyMjUuMS0yMjUuMUMzNjUuOTMxLDI0Mi44NzUsMzY1LjkzMSwyMzQuMjc1LDM2MC43MzEsMjI5LjA3NXogICAiIGZpbGw9IiNGRkZGRkYiLz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+);background-size:15px;transition:.5s}.right-arrow-preview-image[_ngcontent-%COMP%]:hover{transform:scale(1.2)}";
function LoadingSpinnerComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelement(2, "div", 4);
    ɵngcc0.ɵɵelement(3, "div", 5);
    ɵngcc0.ɵɵelement(4, "div", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function LoadingSpinnerComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function LoadingSpinnerComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 8);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function LoadingSpinnerComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 9);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function LoadingSpinnerComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "div", 11);
    ɵngcc0.ɵɵelement(3, "span", 12);
    ɵngcc0.ɵɵelement(4, "span", 13);
    ɵngcc0.ɵɵelement(5, "span", 14);
    ɵngcc0.ɵɵelement(6, "span", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function LoadingSpinnerComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵelement(2, "div", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function LoadingSpinnerComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 18);
    ɵngcc0.ɵɵelement(2, "span");
    ɵngcc0.ɵɵelement(3, "span");
    ɵngcc0.ɵɵelement(4, "span");
    ɵngcc0.ɵɵelement(5, "span");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function PlainGalleryComponent_div_0_ng_container_1_ng_container_1_ng_container_1_img_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "img", 6);
    ɵngcc0.ɵɵlistener("click", function PlainGalleryComponent_div_0_ng_container_1_ng_container_1_ng_container_1_img_1_Template_img_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const imgCol_r5 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(3); return ctx_r11.showModalGalleryByImage(imgCol_r5); })("keyup", function PlainGalleryComponent_div_0_ng_container_1_ng_container_1_ng_container_1_img_1_Template_img_keyup_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const imgCol_r5 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r14 = ɵngcc0.ɵɵnextContext(3); return ctx_r14.showModalGalleryByImage(imgCol_r5); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const imgCol_r5 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵpropertyInterpolate("alt", (imgCol_r5.plain == null ? null : imgCol_r5.plain.alt) ? imgCol_r5.plain.alt : ctx_r10.getAltPlainDescriptionByImage(imgCol_r5));
    ɵngcc0.ɵɵproperty("src", (imgCol_r5.plain == null ? null : imgCol_r5.plain.img) ? imgCol_r5.plain.img : imgCol_r5.modal.img, ɵngcc0.ɵɵsanitizeUrl)("sizeConfig", ɵngcc0.ɵɵpureFunction2(6, _c0, ctx_r10.size == null ? null : ctx_r10.size.width, ctx_r10.size == null ? null : ctx_r10.size.height))("title", (imgCol_r5.plain == null ? null : imgCol_r5.plain.title) ? imgCol_r5.plain.title : ctx_r10.getTitleDisplay(imgCol_r5))("tabindex", 0);
    ɵngcc0.ɵɵattribute("aria-label", imgCol_r5.plain == null ? null : imgCol_r5.plain.ariaLabel);
} }
function PlainGalleryComponent_div_0_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PlainGalleryComponent_div_0_ng_container_1_ng_container_1_ng_container_1_img_1_Template, 1, 9, "img", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const imgCol_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", imgCol_r5 == null ? null : imgCol_r5.modal == null ? null : imgCol_r5.modal.img);
} }
function PlainGalleryComponent_div_0_ng_container_1_ng_container_1_ng_template_2_a_0_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 8);
    ɵngcc0.ɵɵlistener("click", function PlainGalleryComponent_div_0_ng_container_1_ng_container_1_ng_template_2_a_0_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r21); const j_r6 = ɵngcc0.ɵɵnextContext(2).index; const ctx_r19 = ɵngcc0.ɵɵnextContext(3); return ctx_r19.showModalGallery(j_r6); })("keyup", function PlainGalleryComponent_div_0_ng_container_1_ng_container_1_ng_template_2_a_0_Template_a_keyup_0_listener() { ɵngcc0.ɵɵrestoreView(_r21); const j_r6 = ɵngcc0.ɵɵnextContext(2).index; const ctx_r22 = ɵngcc0.ɵɵnextContext(3); return ctx_r22.showModalGallery(j_r6); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const imgCol_r5 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r18 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵstyleMap(ctx_r18.configPlainGallery.advanced == null ? null : ctx_r18.configPlainGallery.advanced.additionalBackground);
    ɵngcc0.ɵɵproperty("image", imgCol_r5)("sizeConfig", ɵngcc0.ɵɵpureFunction2(7, _c0, ctx_r18.size == null ? null : ctx_r18.size.width, ctx_r18.size == null ? null : ctx_r18.size.height))("title", (imgCol_r5.plain == null ? null : imgCol_r5.plain.title) ? imgCol_r5.plain.title : ctx_r18.getTitleDisplay(imgCol_r5))("tabindex", 0);
    ɵngcc0.ɵɵattribute("aria-label", imgCol_r5.plain == null ? null : imgCol_r5.plain.ariaLabel);
} }
function PlainGalleryComponent_div_0_ng_container_1_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, PlainGalleryComponent_div_0_ng_container_1_ng_container_1_ng_template_2_a_0_Template, 1, 10, "a", 7);
} if (rf & 2) {
    const imgCol_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngIf", imgCol_r5 == null ? null : imgCol_r5.modal == null ? null : imgCol_r5.modal.img);
} }
function PlainGalleryComponent_div_0_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PlainGalleryComponent_div_0_ng_container_1_ng_container_1_ng_container_1_Template, 2, 1, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(2, PlainGalleryComponent_div_0_ng_container_1_ng_container_1_ng_template_2_Template, 1, 1, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r8 = ɵngcc0.ɵɵreference(3);
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r4.configPlainGallery.advanced == null ? null : ctx_r4.configPlainGallery.advanced.aTags))("ngIfElse", _r8);
} }
function PlainGalleryComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PlainGalleryComponent_div_0_ng_container_1_ng_container_1_Template, 4, 2, "ng-container", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const imgRow_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", imgRow_r2);
} }
function PlainGalleryComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, PlainGalleryComponent_div_0_ng_container_1_Template, 2, 1, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("wrap", ctx_r0.wrapStyle)("width", ctx_r0.widthStyle)("direction", ctx_r0.directionStyle)("justify", ctx_r0.justifyStyle)("title", ctx_r0.accessibilityConfig == null ? null : ctx_r0.accessibilityConfig.plainGalleryContentTitle);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r0.accessibilityConfig == null ? null : ctx_r0.accessibilityConfig.plainGalleryContentAriaLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.imageGrid);
} }
class ClickOutsideDirective {
    constructor() {
        /**
         * Output to emit an event if the clicked element class doesn't contain 'inside' or it is 'hidden'. The payload is a boolean.
         */
        this.clickOutside = new EventEmitter();
    }
    /**
     * Method called by Angular itself every click thanks to `\@HostListener`.
     * @param {?} event
     * @return {?}
     */
    onClick(event) {
        event.stopPropagation();
        /** @type {?} */
        const targetElement = event.target;
        if (!this.clickOutsideEnable || !targetElement) {
            return;
        }
        /** @type {?} */
        let isInside = false;
        /** @type {?} */
        let isHidden = false;
        if (typeof targetElement.className !== 'string') {
            // it happens with @fortawesome/fontawesome 5
            // for some reasons className is an object with 2 empty properties inside
            isInside = true;
        }
        else {
            // in normal scenarios, use classname, because it's a simple string
            isInside = targetElement.className && targetElement.className.startsWith('inside');
            isHidden = targetElement.className.includes('hidden');
        }
        // if inside => don't close modal gallery
        // if hidden => close modal gallery
        /*
            i i' h | close
            0 1  0 |   1 => close modal gallery
            0 1  1 |   1 => close modal gallery
            1 0  0 |   0
            1 0  1 |   1 => close modal gallery
         */
        if (!isInside || isHidden) {
            // close modal gallery
            this.clickOutside.emit(true);
        }
    }
}
ClickOutsideDirective.ɵfac = function ClickOutsideDirective_Factory(t) { return new (t || ClickOutsideDirective)(); };
ClickOutsideDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ClickOutsideDirective, selectors: [["", "ksClickOutside", ""]], hostBindings: function ClickOutsideDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function ClickOutsideDirective_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } }, inputs: { clickOutsideEnable: "clickOutsideEnable" }, outputs: { clickOutside: "clickOutside" } });
ClickOutsideDirective.propDecorators = {
    clickOutsideEnable: [{ type: Input }],
    clickOutside: [{ type: Output }],
    onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ClickOutsideDirective, [{
        type: Directive,
        args: [{
                selector: '[ksClickOutside]'
            }]
    }], function () { return []; }, { clickOutside: [{
            type: Output
        }], 
    /**
     * Method called by Angular itself every click thanks to `\@HostListener`.
     * @param {?} event
     * @return {?}
     */
    onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], clickOutsideEnable: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Directive to change the size of an element.
 */
class SizeDirective {
    /**
     * @param {?} renderer
     * @param {?} el
     */
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
    }
    /**
     * Method ´ngOnInit´ to apply the style of this directive.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called only one time!!!
     * @return {?}
     */
    ngOnInit() {
        this.applyStyle();
    }
    /**
     * Method ´ngOnChanges´ to apply the style of this directive.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called when any data-bound property of a directive changes!!!
     * @return {?}
     */
    ngOnChanges() {
        this.applyStyle();
    }
    /**
     * Private method to change both width and height of an element.
     * @private
     * @return {?}
     */
    applyStyle() {
        if (!this.sizeConfig) {
            return;
        }
        // apply [style.width]
        this.renderer.setStyle(this.el.nativeElement, 'width', this.sizeConfig.width);
        this.renderer.setStyle(this.el.nativeElement, 'height', this.sizeConfig.height);
    }
}
SizeDirective.ɵfac = function SizeDirective_Factory(t) { return new (t || SizeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SizeDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SizeDirective, selectors: [["", "ksSize", ""]], inputs: { sizeConfig: "sizeConfig" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/** @nocollapse */
SizeDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
SizeDirective.propDecorators = {
    sizeConfig: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SizeDirective, [{
        type: Directive,
        args: [{
                selector: '[ksSize]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { sizeConfig: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class KeyboardNavigationDirective {
    constructor() {
        this.keyPress = new EventEmitter();
    }
    /**
     * Listener to catch keyboard's events and call the right method based on the key.
     * For instance, pressing esc, this will call `closeGallery(Action.KEYBOARD)` and so on.
     * If you passed a valid `keyboardConfig` esc, right and left buttons will be customized based on your data.
     * @param {?} e KeyboardEvent caught by the listener.
     * @return {?}
     */
    onKeyDown(e) {
        if (!this.isOpen) {
            return;
        }
        this.keyPress.emit(e.keyCode);
    }
}
KeyboardNavigationDirective.ɵfac = function KeyboardNavigationDirective_Factory(t) { return new (t || KeyboardNavigationDirective)(); };
KeyboardNavigationDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: KeyboardNavigationDirective, selectors: [["", "ksKeyboardNavigation", ""]], hostBindings: function KeyboardNavigationDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function KeyboardNavigationDirective_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { isOpen: "isOpen" }, outputs: { keyPress: "keyPress" } });
KeyboardNavigationDirective.propDecorators = {
    isOpen: [{ type: Input }],
    keyPress: [{ type: Output }],
    onKeyDown: [{ type: HostListener, args: ['window:keydown', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(KeyboardNavigationDirective, [{
        type: Directive,
        args: [{
                selector: '[ksKeyboardNavigation]'
            }]
    }], function () { return []; }, { keyPress: [{
            type: Output
        }], 
    /**
     * Listener to catch keyboard's events and call the right method based on the key.
     * For instance, pressing esc, this will call `closeGallery(Action.KEYBOARD)` and so on.
     * If you passed a valid `keyboardConfig` esc, right and left buttons will be customized based on your data.
     * @param {?} e KeyboardEvent caught by the listener.
     * @return {?}
     */
    onKeyDown: [{
            type: HostListener,
            args: ['window:keydown', ['$event']]
        }], isOpen: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Directive to change the flex-wrap css property of an element.
 */
class WrapDirective {
    /**
     * @param {?} renderer
     * @param {?} el
     */
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
    }
    /**
     * Method ´ngOnInit´ to apply the style of this directive.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called only one time!!!
     * @return {?}
     */
    ngOnInit() {
        this.applyStyle();
    }
    /**
     * Method ´ngOnChanges´ to apply the style of this directive.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called when any data-bound property of a directive changes!!!
     * @return {?}
     */
    ngOnChanges() {
        this.applyStyle();
    }
    /**
     * Private method to change both widht and flex-wrap css properties.
     * @private
     * @return {?}
     */
    applyStyle() {
        // TODO is this right???? If wrap os false I cannot apply width and flex-wrap
        if (!this.wrap) {
            return;
        }
        this.renderer.setStyle(this.el.nativeElement, 'width', this.width);
        this.renderer.setStyle(this.el.nativeElement, 'flex-wrap', this.wrap ? 'wrap' : 'nowrap');
    }
}
WrapDirective.ɵfac = function WrapDirective_Factory(t) { return new (t || WrapDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
WrapDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: WrapDirective, selectors: [["", "ksWrap", ""]], inputs: { wrap: "wrap", width: "width" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/** @nocollapse */
WrapDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
WrapDirective.propDecorators = {
    wrap: [{ type: Input }],
    width: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WrapDirective, [{
        type: Directive,
        args: [{
                selector: '[ksWrap]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { wrap: [{
            type: Input
        }], width: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Directive to change the flex-direction of an element, based on two inputs (`direction` and `justify`).
 */
class DirectionDirective {
    /**
     * @param {?} renderer
     * @param {?} el
     */
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
    }
    /**
     * Method ´ngOnInit´ to apply the style of this directive.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called only one time!!!
     * @return {?}
     */
    ngOnInit() {
        this.applyStyle();
    }
    /**
     * Method ´ngOnChanges´ to apply the style of this directive.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called when any data-bound property of a directive changes!!!
     * @return {?}
     */
    ngOnChanges() {
        this.applyStyle();
    }
    /**
     * Private method to change both direction and justify of an element.
     * @private
     * @return {?}
     */
    applyStyle() {
        if (!this.direction || !this.justify) {
            return;
        }
        this.renderer.setStyle(this.el.nativeElement, 'flex-direction', this.direction);
        this.renderer.setStyle(this.el.nativeElement, 'justify-content', this.justify);
    }
}
DirectionDirective.ɵfac = function DirectionDirective_Factory(t) { return new (t || DirectionDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DirectionDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DirectionDirective, selectors: [["", "ksDirection", ""]], inputs: { direction: "direction", justify: "justify" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/** @nocollapse */
DirectionDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
DirectionDirective.propDecorators = {
    direction: [{ type: Input }],
    justify: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DirectionDirective, [{
        type: Directive,
        args: [{
                selector: '[ksDirection]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { direction: [{
            type: Input
        }], justify: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/*
 The MIT License (MIT)

 Copyright (c) 2017-2018 Stefano Cappa (Ks89)

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NON INFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
 */
/**
 * Class `Image` that represents an image with both `modal` and `plain` configurations.
 * Both image `id` and `modal` are mandatory, instead `plain` is optional.
 */
class Image {
    /**
     * @param {?} id
     * @param {?} modal
     * @param {?=} plain
     */
    constructor(id, modal, plain) {
        this.id = id;
        this.modal = modal;
        this.plain = plain;
    }
}
/**
 * Class `ImageEvent` that represents the event payload with the result and the triggered action.
 */
class ImageEvent {
    /**
     * @param {?} action
     * @param {?} result
     */
    constructor(action, result) {
        this.action = action;
        this.result = result;
    }
}
/**
 * Class `ImageModalEvent` that represents the event payload with the result and the triggered action.
 */
class ImageModalEvent extends ImageEvent {
    /**
     * @param {?} action
     * @param {?} result
     */
    constructor(action, result) {
        super(action, result);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Directive to add an image to an `<a>` tag with some additional custom properties.
 */
class ATagBgImageDirective {
    /**
     * @param {?} renderer
     * @param {?} el
     */
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
    }
    /**
     * Method ´ngOnInit´ to apply the style of this directive.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called only one time!!!
     * @return {?}
     */
    ngOnInit() {
        this.applyStyle();
    }
    /**
     * Method ´ngOnChanges´ to apply the style of this directive.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called when any data-bound property of a directive changes!!!
     * @return {?}
     */
    ngOnChanges() {
        this.applyStyle();
    }
    /**
     * Private method to add an image as background of an `<a>` tag.
     * @private
     * @return {?}
     */
    applyStyle() {
        if (!this.image || (!this.image.plain && !this.image.modal)) {
            return;
        }
        /** @type {?} */
        const imgPath = this.image.plain && this.image.plain.img ? this.image.plain.img : this.image.modal.img;
        this.renderer.setStyle(this.el.nativeElement, 'background', `url("${imgPath}") ${this.style}`);
    }
}
ATagBgImageDirective.ɵfac = function ATagBgImageDirective_Factory(t) { return new (t || ATagBgImageDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ATagBgImageDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ATagBgImageDirective, selectors: [["", "ksATagBgImage", ""]], inputs: { image: "image", style: "style" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/** @nocollapse */
ATagBgImageDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
ATagBgImageDirective.propDecorators = {
    image: [{ type: Input }],
    style: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ATagBgImageDirective, [{
        type: Directive,
        args: [{
                selector: '[ksATagBgImage]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { image: [{
            type: Input
        }], style: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Directive to customize the description.
 */
class DescriptionDirective {
    /**
     * @param {?} renderer
     * @param {?} el
     */
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
    }
    /**
     * Method ´ngOnInit´ to apply the style of this directive.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called only one time!!!
     * @return {?}
     */
    ngOnInit() {
        this.applyStyle();
    }
    /**
     * Method ´ngOnChanges´ to apply the style of this directive.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called when any data-bound property of a directive changes!!!
     * @return {?}
     */
    ngOnChanges() {
        this.applyStyle();
    }
    /**
     * Private method to change description's style.
     * @private
     * @return {?}
     */
    applyStyle() {
        if (!this.description) {
            return;
        }
        if (this.description.style) {
            this.renderer.setStyle(this.el.nativeElement, 'background', this.description.style.bgColor);
            this.renderer.setStyle(this.el.nativeElement, 'color', this.description.style.textColor);
            if (this.description.style.width) {
                this.renderer.setStyle(this.el.nativeElement, 'width', this.description.style.width);
            }
            if (this.description.style.height) {
                this.renderer.setStyle(this.el.nativeElement, 'height', this.description.style.height);
            }
            if (this.description.style.position) {
                this.renderer.setStyle(this.el.nativeElement, 'position', this.description.style.position);
            }
            if (this.description.style.top) {
                this.renderer.setStyle(this.el.nativeElement, 'top', this.description.style.top);
            }
            if (this.description.style.bottom) {
                this.renderer.setStyle(this.el.nativeElement, 'bottom', this.description.style.bottom);
            }
            if (this.description.style.left) {
                this.renderer.setStyle(this.el.nativeElement, 'left', this.description.style.left);
            }
            if (this.description.style.right) {
                this.renderer.setStyle(this.el.nativeElement, 'right', this.description.style.right);
            }
            this.renderer.setStyle(this.el.nativeElement, 'margin-top', this.description.style.marginTop ? this.description.style.marginTop : '0px');
            this.renderer.setStyle(this.el.nativeElement, 'margin-bottom', this.description.style.marginBottom ? this.description.style.marginBottom : '0px');
            this.renderer.setStyle(this.el.nativeElement, 'margin-left', this.description.style.marginLeft ? this.description.style.marginLeft : '0px');
            this.renderer.setStyle(this.el.nativeElement, 'margin-right', this.description.style.marginRight ? this.description.style.marginRight : '0px');
        }
    }
}
DescriptionDirective.ɵfac = function DescriptionDirective_Factory(t) { return new (t || DescriptionDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DescriptionDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DescriptionDirective, selectors: [["", "ksDescription", ""]], inputs: { description: "description" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/** @nocollapse */
DescriptionDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
DescriptionDirective.propDecorators = {
    description: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DescriptionDirective, [{
        type: Directive,
        args: [{
                selector: '[ksDescription]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { description: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Directive to change margins of an element.
 */
class MarginDirective {
    /**
     * @param {?} renderer
     * @param {?} el
     */
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
    }
    /**
     * Method ´ngOnInit´ to apply the style of this directive.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called only one time!!!
     * @return {?}
     */
    ngOnInit() {
        this.applyStyle();
    }
    /**
     * Method ´ngOnChanges´ to apply the style of this directive.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called when any data-bound property of a directive changes!!!
     * @return {?}
     */
    ngOnChanges() {
        this.applyStyle();
    }
    /**
     * Private method to change both width and height of an element.
     * @private
     * @return {?}
     */
    applyStyle() {
        if (this.marginLeft) {
            this.renderer.setStyle(this.el.nativeElement, 'margin-left', this.marginLeft);
        }
        if (this.marginRight) {
            this.renderer.setStyle(this.el.nativeElement, 'margin-right', this.marginRight);
        }
        if (this.marginTop) {
            this.renderer.setStyle(this.el.nativeElement, 'margin-top', this.marginTop);
        }
        if (this.marginBottom) {
            this.renderer.setStyle(this.el.nativeElement, 'margin-bottom', this.marginBottom);
        }
    }
}
MarginDirective.ɵfac = function MarginDirective_Factory(t) { return new (t || MarginDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MarginDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: MarginDirective, selectors: [["", "ksMargin", ""]], inputs: { marginLeft: "marginLeft", marginRight: "marginRight", marginTop: "marginTop", marginBottom: "marginBottom" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/** @nocollapse */
MarginDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
MarginDirective.propDecorators = {
    marginLeft: [{ type: Input }],
    marginRight: [{ type: Input }],
    marginTop: [{ type: Input }],
    marginBottom: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarginDirective, [{
        type: Directive,
        args: [{
                selector: '[ksMargin]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { marginLeft: [{
            type: Input
        }], marginRight: [{
            type: Input
        }], marginTop: [{
            type: Input
        }], marginBottom: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Directive to change the max size of an element.
 */
class MaxSizeDirective {
    /**
     * @param {?} renderer
     * @param {?} el
     */
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
    }
    /**
     * Method ´ngOnInit´ to apply the style of this directive.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called only one time!!!
     * @return {?}
     */
    ngOnInit() {
        this.applyStyle();
    }
    /**
     * Method ´ngOnChanges´ to apply the style of this directive.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called when any data-bound property of a directive changes!!!
     * @return {?}
     */
    ngOnChanges() {
        this.applyStyle();
    }
    /**
     * Private method to change both max-width and max-height of an element.
     * @private
     * @return {?}
     */
    applyStyle() {
        if (!this.sizeConfig) {
            return;
        }
        if (this.sizeConfig.maxWidth) {
            this.renderer.setStyle(this.el.nativeElement, 'max-width', this.sizeConfig.maxWidth);
        }
        if (this.sizeConfig.maxHeight) {
            this.renderer.setStyle(this.el.nativeElement, 'max-height', this.sizeConfig.maxHeight);
        }
    }
}
MaxSizeDirective.ɵfac = function MaxSizeDirective_Factory(t) { return new (t || MaxSizeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MaxSizeDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: MaxSizeDirective, selectors: [["", "ksMaxSize", ""]], inputs: { sizeConfig: "sizeConfig" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/** @nocollapse */
MaxSizeDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
MaxSizeDirective.propDecorators = {
    sizeConfig: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MaxSizeDirective, [{
        type: Directive,
        args: [{
                selector: '[ksMaxSize]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { sizeConfig: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Array of all directives.
 * @type {?}
 */
const DIRECTIVES = [
    ClickOutsideDirective,
    SizeDirective,
    KeyboardNavigationDirective,
    WrapDirective,
    DirectionDirective,
    ATagBgImageDirective,
    DescriptionDirective,
    MarginDirective,
    MaxSizeDirective
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Component with the semi-transparent background.
 */
class BackgroundComponent {
}
BackgroundComponent.ɵfac = function BackgroundComponent_Factory(t) { return new (t || BackgroundComponent)(); };
BackgroundComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BackgroundComponent, selectors: [["ks-background"]], inputs: { isOpen: "isOpen", accessibilityConfig: "accessibilityConfig" }, decls: 1, vars: 1, consts: [["class", "ng-overlay", 3, "title", 4, "ngIf"], [1, "ng-overlay", 3, "title"]], template: function BackgroundComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BackgroundComponent_div_0_Template, 1, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isOpen);
    } }, directives: [ɵngcc1.NgIf], styles: [".ng-overlay[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100vw;height:100vh;background:#000;opacity:.8;z-index:9999}"], changeDetection: 0 });
BackgroundComponent.propDecorators = {
    isOpen: [{ type: Input }],
    accessibilityConfig: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BackgroundComponent, [{
        type: Component,
        args: [{
                selector: 'ks-background',
                template: "<div class=\"ng-overlay\" *ngIf=\"isOpen\"\n     [attr.aria-label]=\"accessibilityConfig?.backgroundAriaLabel\"\n     [title]=\"accessibilityConfig?.backgroundTitle\"></div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".ng-overlay{position:fixed;top:0;left:0;width:100vw;height:100vh;background:#000;opacity:.8;z-index:9999}"]
            }]
    }], null, { isOpen: [{
            type: Input
        }], accessibilityConfig: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/*
 The MIT License (MIT)

 Copyright (c) 2017-2018 Stefano Cappa (Ks89)

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NON INFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
 */
/** @enum {number} */
const Action = {
    NORMAL: 0,
    CLICK: 1,
    KEYBOARD: 2,
    SWIPE: 3,
    LOAD: 4,
    AUTOPLAY: 5,
};
Action[Action.NORMAL] = 'NORMAL';
Action[Action.CLICK] = 'CLICK';
Action[Action.KEYBOARD] = 'KEYBOARD';
Action[Action.SWIPE] = 'SWIPE';
Action[Action.LOAD] = 'LOAD';
Action[Action.AUTOPLAY] = 'AUTOPLAY';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const KEYBOARD_CONFIGURATION = new InjectionToken('KEYBOARD_CONFIGURATION');
/**
 * Service to intercept ctrl+s (or cmd+s on macOS) using a third-party library, called Mousetrap.
 */
class KeyboardService {
    /**
     * Constructor of `KeyboardService` to init `mousetrap` and `shortcuts` private variables.
     * @param {?} config
     */
    constructor(config) {
        // this.config is always defined, because forced by forRoot inside the module
        // when empty, it's simply an empty object: {}
        this.config = config;
        this.shortcuts = this.config && this.config.shortcuts ? this.config.shortcuts : ['ctrl+s', 'meta+s'];
        // temporary workaround to fix this issue: https://github.com/Ks89/angular-modal-gallery/issues/142
        if (this.config && !this.config.disableSsrWorkaround) {
            // To prevent issues with angular-universal on server-side
            if (typeof window !== 'undefined') {
                require('mousetrap');
                this.mousetrap = new ((/** @type {?} */ (Mousetrap)))();
            }
        }
    }
    /**
     * Method to add a lister for ctrl+s/cmd+s keyboard events.
     * @param {?} onBind
     * @return {?}
     */
    add(onBind) {
        // temporary workaround to fix this issue: https://github.com/Ks89/angular-modal-gallery/issues/142
        if (this.config && !this.config.disableSsrWorkaround) {
            // To prevent issues with angular-universal on server-side
            if (typeof window !== 'undefined') {
                this.mousetrap.bind(this.shortcuts, (/**
                 * @param {?} event
                 * @param {?} combo
                 * @return {?}
                 */
                (event, combo) => {
                    if (event.preventDefault) {
                        event.preventDefault();
                    }
                    else {
                        // internet explorer
                        event.returnValue = false;
                    }
                    onBind(event, combo);
                }));
            }
        }
    }
    /**
     * Method to reset all listeners. Please, call this function when needed
     * to free resources ad prevent leaks.
     * @return {?}
     */
    reset() {
        // temporary workaround to fix this issue: https://github.com/Ks89/angular-modal-gallery/issues/142
        if (this.config && !this.config.disableSsrWorkaround) {
            // To prevent issues with angular-universal on server-side
            if (typeof window !== 'undefined') {
                this.mousetrap.reset();
            }
        }
    }
}
KeyboardService.ɵfac = function KeyboardService_Factory(t) { return new (t || KeyboardService)(ɵngcc0.ɵɵinject(KEYBOARD_CONFIGURATION)); };
KeyboardService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: KeyboardService, factory: KeyboardService.ɵfac });
/** @nocollapse */
KeyboardService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [KEYBOARD_CONFIGURATION,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(KeyboardService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [KEYBOARD_CONFIGURATION]
            }] }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Service to call methods on a gallery by its galleryId.
 */
class GalleryService {
    constructor() {
        this.navigate = new EventEmitter();
        this.close = new EventEmitter();
        this.update = new EventEmitter();
        this.autoPlay = new EventEmitter();
    }
    /**
     * Method to open the modal gallery with the galleryId passed as parameter.
     * It will automatically shows the image at position index.
     * @throws a error with a message if galleryId is either undefined, < 0 or index is < 0
     * @param {?} galleryId number or undefined that represents the unique id of the gallery.
     * @param {?} index number of the image that you want to open.
     * @return {?}
     */
    openGallery(galleryId, index) {
        if (galleryId === undefined || galleryId < 0 || index < 0) {
            throw new Error('Cannot open gallery via GalleryService with either index<0 or galleryId<0 or galleryId===undefined');
        }
        this.navigate.emit({
            galleryId: galleryId,
            index: index
        });
    }
    /**
     * Method to navigate to a specific index of the modal gallery with the galleryId passed as parameter.
     * At the moment, it's like openGallery, but in upcoming releases it will change the behaviour.
     * @throws a error with a message if galleryId is either undefined, < 0 or index is < 0
     * @param {?} galleryId number or undefined that represents the unique id of the gallery.
     * @param {?} index number of the image that you want to open.
     * @return {?}
     */
    navigateGallery(galleryId, index) {
        if (galleryId === undefined || galleryId < 0 || index < 0) {
            throw new Error('Cannot navigate via GalleryService with either index<0 or galleryId<0 or galleryId===undefined');
        }
        this.navigate.emit({
            galleryId: galleryId,
            index: index
        });
    }
    /**
     * Method to close the modal gallery with the galleryId passed as parameter.
     * @throws a error with a message if galleryId is either undefined or < 0
     * @param {?} galleryId number or undefined that represents the unique id of the gallery.
     * @return {?}
     */
    closeGallery(galleryId) {
        if (galleryId === undefined || galleryId < 0) {
            throw new Error('Cannot close gallery via GalleryService with galleryId<0 or galleryId===undefined');
        }
        this.close.emit(galleryId);
    }
    /**
     * Service to update an image with a new object
     * @throws a error with a message if galleryId is either undefined, < 0 or index is < 0
     *
     * \@since 6.3.0
     * @param {?} galleryId number or undefined that represents the unique id of the gallery.
     * @param {?} index number of the image that you want to update.
     * @param {?} image
     * @return {?}
     */
    updateGallery(galleryId, index, image) {
        if (galleryId === undefined || galleryId < 0 || index < 0) {
            throw new Error('Cannot update gallery via GalleryService with either index<0 or galleryId<0 or galleryId===undefined');
        }
        if (!image) {
            throw new Error('Cannot update gallery via GalleryService, because image is not valid');
        }
        this.update.emit({
            galleryId: galleryId,
            index: index,
            image: image
        });
    }
    /**
     * Service to play modal-gallery
     * @throws a error with a message if galleryId is either undefined or < 0
     *
     * \@since 7.2.0
     * @param {?} galleryId number or undefined that represents the unique id of the gallery.
     * @return {?}
     */
    play(galleryId) {
        if (galleryId === undefined || galleryId < 0) {
            throw new Error('Cannot play gallery via GalleryService with galleryId<0 or galleryId===undefined');
        }
        this.autoPlay.emit({
            galleryId: galleryId,
            result: true
        });
    }
    /**
     * Service to stop modal-gallery
     * @throws a error with a message if galleryId is either undefined or < 0
     *
     * \@since 7.2.0
     * @param {?} galleryId number or undefined that represents the unique id of the gallery.
     * @return {?}
     */
    stop(galleryId) {
        if (galleryId === undefined || galleryId < 0) {
            throw new Error('Cannot stop gallery via GalleryService with galleryId<0 or galleryId===undefined');
        }
        this.autoPlay.emit({
            galleryId: galleryId,
            result: false
        });
    }
}
GalleryService.ɵfac = function GalleryService_Factory(t) { return new (t || GalleryService)(); };
GalleryService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: GalleryService, factory: GalleryService.ɵfac, providedIn: 'root' });
/** @nocollapse */ GalleryService.ngInjectableDef = defineInjectable({ factory: function GalleryService_Factory() { return new GalleryService(); }, token: GalleryService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GalleryService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Code of the keyboard's key `enter`
 * @type {?}
 */
const ENTER_CODE = 'Enter';
/**
 * Code of the keyboard's key `space`
 * @type {?}
 */
const SPACE_CODE = 'Space';
/**
 * KeyCode of the main mouse button
 * @type {?}
 */
const MOUSE_MAIN_BUTTON_CLICK = 0;
/**
 * Const NEXT
 * @type {?}
 */
const NEXT = 1;
/**
 * Const PREV
 * @type {?}
 */
const PREV = -1;
/**
 * Const NOTHING to represents a situation when it isn't both NEXT and PREV
 * @type {?}
 */
const NOTHING = 0;
/**
 * Const to represent the right direction
 * @type {?}
 */
const DIRECTION_RIGHT = 'right';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Provides some useful methods to add accessibility features to subclasses.
 * In particular, it exposes a method to handle navigation event with both Keyboard and Mouse
 * and another with also the direction (right or left).
 */
class AccessibleComponent {
    constructor() { }
    /**
     * Method to handle navigation events with both Keyboard and Mouse.
     * @param {?} direction
     * @param {?} event
     * @return {?} number -1 for PREV, 1 for NEXT and 0 for NOTHING
     */
    handleNavigationEvent(direction, event) {
        if (!event) {
            return NOTHING;
        }
        if (event instanceof KeyboardEvent) {
            return this.handleKeyboardNavigationEvent(direction, event);
        }
        else if (event instanceof MouseEvent) {
            return this.handleMouseNavigationEvent(direction, event);
        }
        return NOTHING;
    }
    /**
     * Method to handle events over an image, for instance a keypress with the Keyboard or a Mouse click.
     * @param {?} event
     * @return {?} number 1 for NEXT and 0 for NOTHING
     */
    handleImageEvent(event) {
        if (!event) {
            return NOTHING;
        }
        if (event instanceof KeyboardEvent) {
            return this.handleImageKeyboardEvent(event);
        }
        else if (event instanceof MouseEvent) {
            return this.handleImageMouseEvent(event);
        }
        return NOTHING;
    }
    /**
     * Private method to handle keyboard events over an image.
     * @private
     * @param {?} event
     * @return {?} number 1 for NEXT and 0 for NOTHING
     */
    handleImageKeyboardEvent(event) {
        /** @type {?} */
        const key = event.code;
        if (key === SPACE_CODE || key === ENTER_CODE) {
            return NEXT;
        }
        return NOTHING;
    }
    /**
     * Private method to handle mouse events over an image.
     * @private
     * @param {?} event
     * @return {?} number 1 for NEXT and 0 for NOTHING
     */
    handleImageMouseEvent(event) {
        /** @type {?} */
        const mouseBtn = event.button;
        if (mouseBtn === MOUSE_MAIN_BUTTON_CLICK) {
            return NEXT;
        }
        return NOTHING;
    }
    /**
     * Method to handle events over an image, for instance a keypress with the Keyboard or a Mouse click.
     * @private
     * @param {?} direction
     * @param {?} event
     * @return {?} number -1 for PREV, 1 for NEXT and 0 for NOTHING
     */
    handleKeyboardNavigationEvent(direction, event) {
        /** @type {?} */
        const key = event.code;
        if (key === SPACE_CODE || key === ENTER_CODE) {
            return direction === DIRECTION_RIGHT ? NEXT : PREV;
        }
        return NOTHING;
    }
    /**
     * Method to handle events over an image, for instance a keypress with the Keyboard or a Mouse click.
     * @private
     * @param {?} direction
     * @param {?} event
     * @return {?} number -1 for PREV, 1 for NEXT and 0 for NOTHING
     */
    handleMouseNavigationEvent(direction, event) {
        /** @type {?} */
        const mouseBtn = event.button;
        if (mouseBtn === MOUSE_MAIN_BUTTON_CLICK) {
            return direction === DIRECTION_RIGHT ? NEXT : PREV;
        }
        return NOTHING;
    }
}
AccessibleComponent.ɵfac = function AccessibleComponent_Factory(t) { return new (t || AccessibleComponent)(); };
AccessibleComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AccessibleComponent, selectors: [["ks-accessible"]], decls: 0, vars: 0, template: function AccessibleComponent_Template(rf, ctx) { }, encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
AccessibleComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccessibleComponent, [{
        type: Component,
        args: [{
                selector: 'ks-accessible',
                template: ``,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const DescriptionStrategy = {
    ALWAYS_HIDDEN: 1,
    ALWAYS_VISIBLE: 2,
    HIDE_IF_EMPTY: 3,
};
DescriptionStrategy[DescriptionStrategy.ALWAYS_HIDDEN] = 'ALWAYS_HIDDEN';
DescriptionStrategy[DescriptionStrategy.ALWAYS_VISIBLE] = 'ALWAYS_VISIBLE';
DescriptionStrategy[DescriptionStrategy.HIDE_IF_EMPTY] = 'HIDE_IF_EMPTY';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/*
 The MIT License (MIT)

 Copyright (c) 2017-2018 Stefano Cappa (Ks89)

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NON INFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
 */
/** @enum {number} */
const Keyboard = {
    ESC: 27,
    LEFT_ARROW: 37,
    RIGHT_ARROW: 39,
    UP_ARROW: 38,
    DOWN_ARROW: 40,
};
Keyboard[Keyboard.ESC] = 'ESC';
Keyboard[Keyboard.LEFT_ARROW] = 'LEFT_ARROW';
Keyboard[Keyboard.RIGHT_ARROW] = 'RIGHT_ARROW';
Keyboard[Keyboard.UP_ARROW] = 'UP_ARROW';
Keyboard[Keyboard.DOWN_ARROW] = 'DOWN_ARROW';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const LoadingType = {
    STANDARD: 1,
    CIRCULAR: 2,
    BARS: 3,
    DOTS: 4,
    CUBE_FLIPPING: 5,
    CIRCLES: 6,
    EXPLOSING_SQUARES: 7,
};
LoadingType[LoadingType.STANDARD] = 'STANDARD';
LoadingType[LoadingType.CIRCULAR] = 'CIRCULAR';
LoadingType[LoadingType.BARS] = 'BARS';
LoadingType[LoadingType.DOTS] = 'DOTS';
LoadingType[LoadingType.CUBE_FLIPPING] = 'CUBE_FLIPPING';
LoadingType[LoadingType.CIRCLES] = 'CIRCLES';
LoadingType[LoadingType.EXPLOSING_SQUARES] = 'EXPLOSING_SQUARES';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/*
 The MIT License (MIT)

 Copyright (c) 2017-2018 Stefano Cappa (Ks89)

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NON INFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
 */
/**
 * Utility function to get the index of the input `image` from `arrayOfImages`
 * @throws an Error if either image or arrayOfImages are not valid,
 *  or if the input image doesn't contain an 'id', or the 'id' is < 0
 * @param {?} image
 * @param {?} arrayOfImages
 * @return {?} number the index of the image. -1 if not found.
 */
function getIndex(image, arrayOfImages) {
    if (!image) {
        throw new Error('image must be a valid Image object');
    }
    if (!arrayOfImages) {
        throw new Error('arrayOfImages must be a valid Image[]');
    }
    if (!image.id && image.id !== 0) {
        // id = 0 is admitted
        throw new Error(`A numeric Image 'id' is mandatory`);
    }
    if (image.id < 0) {
        throw new Error(`Image 'id' must be >= 0`);
    }
    return arrayOfImages.findIndex((/**
     * @param {?} val
     * @return {?}
     */
    (val) => val.id === image.id));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Component with the current image with some additional elements like arrows and side previews.
 */
class CurrentImageComponent extends AccessibleComponent {
    /**
     * @param {?} _platformId
     * @param {?} _ngZone
     * @param {?} ref
     */
    constructor(_platformId, _ngZone, ref) {
        super();
        this._platformId = _platformId;
        this._ngZone = _ngZone;
        this.ref = ref;
        /**
         * Output to emit an event when images are loaded. The payload contains an `ImageLoadEvent`.
         */
        this.loadImage = new EventEmitter();
        /**
         * Output to emit any changes of the current image. The payload contains an `ImageModalEvent`.
         */
        this.changeImage = new EventEmitter();
        /**
         * Output to emit an event when the modal gallery is closed. The payload contains an `ImageModalEvent`.
         */
        this.close = new EventEmitter();
        /**
         * Subject to play modal-gallery.
         */
        this.start$ = new Subject();
        /**
         * Subject to stop modal-gallery.
         */
        this.stop$ = new Subject();
        /**
         * Enum of type `Action` that represents a normal action.
         * Declared here to be used inside the template.
         */
        this.normalAction = Action.NORMAL;
        /**
         * Enum of type `Action` that represents a mouse click on a button.
         * Declared here to be used inside the template.
         */
        this.clickAction = Action.CLICK;
        /**
         * Enum of type `Action` that represents a keyboard action.
         * Declared here to be used inside the template.
         */
        this.keyboardAction = Action.KEYBOARD;
        /**
         * Boolean that it's true when you are watching the first image (currently visible).
         * False by default
         */
        this.isFirstImage = false;
        /**
         * Boolean that it's true when you are watching the last image (currently visible).
         * False by default
         */
        this.isLastImage = false;
        /**
         * Boolean that it's true if an image of the modal gallery is still loading.
         * True by default
         */
        this.loading = true;
        /**
         * Private object without type to define all swipe actions used by hammerjs.
         */
        this.SWIPE_ACTION = {
            LEFT: 'swipeleft',
            RIGHT: 'swiperight',
            UP: 'swipeup',
            DOWN: 'swipedown'
        };
    }
    /**
     * Listener to stop the gallery when the mouse pointer is over the current image.
     * @return {?}
     */
    onMouseEnter() {
        // if carousel feature is disable, don't do anything in any case
        if (!this.configSlide || !this.configSlide.playConfig) {
            return;
        }
        if (!this.configSlide.playConfig.pauseOnHover) {
            return;
        }
        this.stopCarousel();
    }
    /**
     * Listener to play the gallery when the mouse pointer leave the current image.
     * @return {?}
     */
    onMouseLeave() {
        // if carousel feature is disable, don't do anything in any case
        if (!this.configSlide || !this.configSlide.playConfig) {
            return;
        }
        if (!this.configSlide.playConfig.pauseOnHover || !this.configSlide.playConfig.autoPlay) {
            return;
        }
        this.playCarousel();
    }
    /**
     * Method ´ngOnInit´ to build `configCurrentImage` applying default values.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called only one time!!!
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        const defaultLoading = { enable: true, type: LoadingType.STANDARD };
        /** @type {?} */
        const defaultDescriptionStyle = {
            bgColor: 'rgba(0, 0, 0, .5)',
            textColor: 'white',
            marginTop: '0px',
            marginBottom: '0px',
            marginLeft: '0px',
            marginRight: '0px'
        };
        /** @type {?} */
        const defaultDescription = {
            strategy: DescriptionStrategy.ALWAYS_VISIBLE,
            imageText: 'Image ',
            numberSeparator: '/',
            beforeTextDescription: ' - ',
            style: defaultDescriptionStyle
        };
        /** @type {?} */
        const defaultCurrentImageConfig = {
            navigateOnClick: true,
            loadingConfig: defaultLoading,
            description: defaultDescription,
            downloadable: false,
            invertSwipe: false
        };
        this.configCurrentImage = Object.assign({}, defaultCurrentImageConfig, this.currentImageConfig);
        this.configCurrentImage.description = Object.assign({}, defaultDescription, this.configCurrentImage.description);
        this.configSlide = Object.assign({}, this.slideConfig);
    }
    /**
     * Method ´ngOnChanges´ to update `loading` status and emit events.
     * If the gallery is open, then it will also manage boundary arrows and sliding.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called when any data-bound property of a directive changes!!!
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        /** @type {?} */
        const images = changes.images;
        /** @type {?} */
        const currentImage = changes.currentImage;
        if (currentImage && currentImage.previousValue !== currentImage.currentValue) {
            this.updateIndexes();
        }
        else if (images && images.previousValue !== images.currentValue) {
            this.updateIndexes();
        }
        /** @type {?} */
        const slideConfig = changes.slideConfig;
        if (slideConfig && slideConfig.previousValue !== slideConfig.currentValue) {
            this.configSlide = Object.assign({}, this.slideConfig);
        }
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        // interval doesn't play well with SSR and protractor,
        // so we should run it in the browser and outside Angular
        if (isPlatformBrowser(this._platformId)) {
            this._ngZone.runOutsideAngular((/**
             * @return {?}
             */
            () => {
                this.start$
                    .pipe(map((/**
                 * @return {?}
                 */
                () => this.configSlide && this.configSlide.playConfig && this.configSlide.playConfig.autoPlay && this.configSlide.playConfig.interval)), filter((/**
                 * @param {?} interval
                 * @return {?}
                 */
                interval => interval > 0)), switchMap((/**
                 * @param {?} interval
                 * @return {?}
                 */
                interval => timer(interval).pipe(takeUntil(this.stop$)))))
                    .subscribe((/**
                 * @return {?}
                 */
                () => this._ngZone.run((/**
                 * @return {?}
                 */
                () => {
                    if (!this.isLastImage) {
                        this.nextImage(Action.AUTOPLAY);
                    }
                    this.ref.markForCheck();
                }))));
                this.start$.next();
            }));
        }
    }
    /**
     * Method to handle keypress based on the `keyboardConfig` input. It gets the keyCode of
     * the key that triggered the keypress event to navigate between images or to close the modal gallery.
     * @param {?} keyCode
     * @return {?}
     */
    onKeyPress(keyCode) {
        /** @type {?} */
        const esc = this.keyboardConfig && this.keyboardConfig.esc ? this.keyboardConfig.esc : Keyboard.ESC;
        /** @type {?} */
        const right = this.keyboardConfig && this.keyboardConfig.right ? this.keyboardConfig.right : Keyboard.RIGHT_ARROW;
        /** @type {?} */
        const left = this.keyboardConfig && this.keyboardConfig.left ? this.keyboardConfig.left : Keyboard.LEFT_ARROW;
        switch (keyCode) {
            case esc:
                this.close.emit(new ImageModalEvent(Action.KEYBOARD, true));
                break;
            case right:
                this.nextImage(Action.KEYBOARD);
                break;
            case left:
                this.prevImage(Action.KEYBOARD);
                break;
        }
    }
    /**
     * Method to get the image description based on input params.
     * If you provide a full description this will be the visible description, otherwise,
     * it will be built using the `Description` object, concatenating its fields.
     * @throws an Error if description isn't available
     * @param {?=} image
     * @return {?} String description of the image (or the current image if not provided)
     */
    getDescriptionToDisplay(image = this.currentImage) {
        if (!this.configCurrentImage || !this.configCurrentImage.description) {
            throw new Error('Description input must be a valid object implementing the Description interface');
        }
        /** @type {?} */
        const imageWithoutDescription = !image.modal || !image.modal.description || image.modal.description === '';
        switch (this.configCurrentImage.description.strategy) {
            case DescriptionStrategy.HIDE_IF_EMPTY:
                return imageWithoutDescription ? '' : image.modal.description + '';
            case DescriptionStrategy.ALWAYS_HIDDEN:
                return '';
            default:
                // ----------- DescriptionStrategy.ALWAYS_VISIBLE -----------------
                return this.buildTextDescription(image, imageWithoutDescription);
        }
    }
    /**
     * Method to get `alt attribute`.
     * `alt` specifies an alternate text for an image, if the image cannot be displayed.
     * @param {?=} image
     * @return {?} String alt description of the image (or the current image if not provided)
     */
    getAltDescriptionByImage(image = this.currentImage) {
        if (!image) {
            return '';
        }
        return image.modal && image.modal.description ? image.modal.description : `Image ${getIndex(image, this.images) + 1}`;
    }
    /**
     * Method to get the title attributes based on descriptions.
     * This is useful to prevent accessibility issues, because if DescriptionStrategy is ALWAYS_HIDDEN,
     * it prevents an empty string as title.
     * @throws an Error if description isn't available
     * @param {?=} image
     * @return {?} String title of the image based on descriptions
     */
    getTitleToDisplay(image = this.currentImage) {
        if (!this.configCurrentImage || !this.configCurrentImage.description) {
            throw new Error('Description input must be a valid object implementing the Description interface');
        }
        /** @type {?} */
        const imageWithoutDescription = !image.modal || !image.modal.description || image.modal.description === '';
        /** @type {?} */
        const description = this.buildTextDescription(image, imageWithoutDescription);
        return description;
    }
    /**
     * Method to get the left side preview image.
     * @return {?} Image the image to show as size preview on the left
     */
    getLeftPreviewImage() {
        /** @type {?} */
        const currentIndex = getIndex(this.currentImage, this.images);
        if (currentIndex === 0 && this.configSlide.infinite) {
            // the current image is the first one,
            // so the previous one is the last image
            // because infinite is true
            return this.images[this.images.length - 1];
        }
        this.handleBoundaries(currentIndex);
        return this.images[Math.max(currentIndex - 1, 0)];
    }
    /**
     * Method to get the right side preview image.
     * @return {?} Image the image to show as size preview on the right
     */
    getRightPreviewImage() {
        /** @type {?} */
        const currentIndex = getIndex(this.currentImage, this.images);
        if (currentIndex === this.images.length - 1 && this.configSlide.infinite) {
            // the current image is the last one,
            // so the next one is the first image
            // because infinite is true
            return this.images[0];
        }
        this.handleBoundaries(currentIndex);
        return this.images[Math.min(currentIndex + 1, this.images.length - 1)];
    }
    /**
     * Method called by events from both keyboard and mouse on an image.
     * This will invoke the nextImage method.
     * @param {?} event
     * @param {?=} action
     * @return {?}
     */
    onImageEvent(event, action = Action.NORMAL) {
        // check if triggered by a mouse click
        // If yes, It should block navigation when navigateOnClick is false
        if (action === Action.CLICK && !this.configCurrentImage.navigateOnClick) {
            // a user has requested to block navigation via configCurrentImage.navigateOnClick property
            return;
        }
        /** @type {?} */
        const result = super.handleImageEvent(event);
        if (result === NEXT) {
            this.nextImage(action);
        }
    }
    /**
     * Method called by events from both keyboard and mouse on a navigation arrow.
     * @param {?} direction
     * @param {?} event
     * @param {?=} action
     * @param {?=} disable
     * @return {?}
     */
    onNavigationEvent(direction, event, action = Action.NORMAL, disable = false) {
        if (disable) {
            return;
        }
        /** @type {?} */
        const result = super.handleNavigationEvent(direction, event);
        if (result === NEXT) {
            this.nextImage(action);
        }
        else if (result === PREV) {
            this.prevImage(action);
        }
    }
    /**
     * Method to go back to the previous image.
     * @param {?=} action Enum of type `Action` that represents the source
     *  action that moved back to the previous image. `Action.NORMAL` by default.
     * @return {?}
     */
    prevImage(action = Action.NORMAL) {
        // check if prevImage should be blocked
        if (this.isPreventSliding(0)) {
            return;
        }
        /** @type {?} */
        const prevImage = this.getPrevImage();
        this.loading = !prevImage.previouslyLoaded;
        this.changeImage.emit(new ImageModalEvent(action, getIndex(prevImage, this.images)));
        this.start$.next();
    }
    /**
     * Method to go back to the previous image.
     * @param {?=} action Enum of type `Action` that represents the source
     *  action that moved to the next image. `Action.NORMAL` by default.
     * @return {?}
     */
    nextImage(action = Action.NORMAL) {
        // check if nextImage should be blocked
        if (this.isPreventSliding(this.images.length - 1)) {
            return;
        }
        /** @type {?} */
        const nextImage = this.getNextImage();
        this.loading = !nextImage.previouslyLoaded;
        this.changeImage.emit(new ImageModalEvent(action, getIndex(nextImage, this.images)));
        this.start$.next();
    }
    /**
     * Method to emit an event as loadImage output to say that the requested image if loaded.
     * This method is invoked by the javascript's 'load' event on an img tag.
     * @param {?} event
     * @return {?}
     */
    onImageLoad(event) {
        /** @type {?} */
        const loadImageData = {
            status: true,
            index: getIndex(this.currentImage, this.images),
            id: this.currentImage.id
        };
        this.loadImage.emit(loadImageData);
        this.loading = false;
    }
    /**
     * Method used by Hammerjs to support touch gestures (you can also invert the swipe direction with configCurrentImage.invertSwipe).
     * @param {?=} action String that represent the direction of the swipe action. 'swiperight' by default.
     * @return {?}
     */
    swipe(action = this.SWIPE_ACTION.RIGHT) {
        switch (action) {
            case this.SWIPE_ACTION.RIGHT:
                if (this.configCurrentImage.invertSwipe) {
                    this.prevImage(Action.SWIPE);
                }
                else {
                    this.nextImage(Action.SWIPE);
                }
                break;
            case this.SWIPE_ACTION.LEFT:
                if (this.configCurrentImage.invertSwipe) {
                    this.nextImage(Action.SWIPE);
                }
                else {
                    this.prevImage(Action.SWIPE);
                }
                break;
            // case this.SWIPE_ACTION.UP:
            //   break;
            // case this.SWIPE_ACTION.DOWN:
            //   break;
        }
    }
    /**
     * Method used in `modal-gallery.component` to get the index of an image to delete.
     * @param {?=} image
     * @return {?} number the index of the image
     */
    getIndexToDelete(image = this.currentImage) {
        return getIndex(image, this.images);
    }
    /**
     * Method to play modal gallery.
     * @return {?}
     */
    playCarousel() {
        this.start$.next();
    }
    /**
     * Stops modal gallery from cycling through items.
     * @return {?}
     */
    stopCarousel() {
        this.stop$.next();
    }
    /**
     * Method to cleanup resources. In fact, this will stop the modal gallery.
     * This is an Angular's lifecycle hook that is called when this component is destroyed.
     * @return {?}
     */
    ngOnDestroy() {
        this.stopCarousel();
    }
    /**
     * Private method to update both `isFirstImage` and `isLastImage` based on
     * the index of the current image.
     * @private
     * @param {?} currentIndex
     * @return {?}
     */
    handleBoundaries(currentIndex) {
        if (this.images.length === 1) {
            this.isFirstImage = true;
            this.isLastImage = true;
            return;
        }
        if (!this.configSlide || this.configSlide.infinite === true) {
            // infinite sliding enabled
            this.isFirstImage = false;
            this.isLastImage = false;
        }
        else {
            switch (currentIndex) {
                case 0:
                    // execute this only if infinite sliding is disabled
                    this.isFirstImage = true;
                    this.isLastImage = false;
                    break;
                case this.images.length - 1:
                    // execute this only if infinite sliding is disabled
                    this.isFirstImage = false;
                    this.isLastImage = true;
                    break;
                default:
                    this.isFirstImage = false;
                    this.isLastImage = false;
                    break;
            }
        }
    }
    /**
     * Private method to check if next/prev actions should be blocked.
     * It checks if configSlide.infinite === false and if the image index is equals to the input parameter.
     * If yes, it returns true to say that sliding should be blocked, otherwise not.
     * @private
     * @param {?} boundaryIndex
     * @return {?} boolean true if configSlide.infinite === false and the current index is
     *  either the first or the last one.
     */
    isPreventSliding(boundaryIndex) {
        return !!this.configSlide && this.configSlide.infinite === false && getIndex(this.currentImage, this.images) === boundaryIndex;
    }
    /**
     * Private method to get the next index.
     * This is necessary because at the end, when you call next again, you'll go to the first image.
     * That happens because all modal images are shown like in a circle.
     * @private
     * @return {?}
     */
    getNextImage() {
        /** @type {?} */
        const currentIndex = getIndex(this.currentImage, this.images);
        /** @type {?} */
        let newIndex = 0;
        if (currentIndex >= 0 && currentIndex < this.images.length - 1) {
            newIndex = currentIndex + 1;
        }
        else {
            newIndex = 0; // start from the first index
        }
        return this.images[newIndex];
    }
    /**
     * Private method to get the previous index.
     * This is necessary because at index 0, when you call prev again, you'll go to the last image.
     * That happens because all modal images are shown like in a circle.
     * @private
     * @return {?}
     */
    getPrevImage() {
        /** @type {?} */
        const currentIndex = getIndex(this.currentImage, this.images);
        /** @type {?} */
        let newIndex = 0;
        if (currentIndex > 0 && currentIndex <= this.images.length - 1) {
            newIndex = currentIndex - 1;
        }
        else {
            newIndex = this.images.length - 1; // start from the last index
        }
        return this.images[newIndex];
    }
    /**
     * Private method to build a text description.
     * This is used also to create titles.
     * @private
     * @param {?} image
     * @param {?} imageWithoutDescription
     * @return {?} String description built concatenating image fields with a specific logic.
     */
    buildTextDescription(image, imageWithoutDescription) {
        if (!this.configCurrentImage || !this.configCurrentImage.description) {
            throw new Error('Description input must be a valid object implementing the Description interface');
        }
        // If customFullDescription use it, otherwise proceed to build a description
        if (this.configCurrentImage.description.customFullDescription && this.configCurrentImage.description.customFullDescription !== '') {
            return this.configCurrentImage.description.customFullDescription;
        }
        /** @type {?} */
        const currentIndex = getIndex(image, this.images);
        // If the current image hasn't a description,
        // prevent to write the ' - ' (or this.description.beforeTextDescription)
        /** @type {?} */
        const prevDescription = this.configCurrentImage.description.imageText ? this.configCurrentImage.description.imageText : '';
        /** @type {?} */
        const midSeparator = this.configCurrentImage.description.numberSeparator ? this.configCurrentImage.description.numberSeparator : '';
        /** @type {?} */
        const middleDescription = currentIndex + 1 + midSeparator + this.images.length;
        if (imageWithoutDescription) {
            return prevDescription + middleDescription;
        }
        /** @type {?} */
        const currImgDescription = image.modal && image.modal.description ? image.modal.description : '';
        /** @type {?} */
        const endDescription = this.configCurrentImage.description.beforeTextDescription + currImgDescription;
        return prevDescription + middleDescription + endDescription;
    }
    /**
     * Private method to call handleBoundaries when ngOnChanges is called.
     * @private
     * @return {?}
     */
    updateIndexes() {
        /** @type {?} */
        let index;
        try {
            index = getIndex(this.currentImage, this.images);
        }
        catch (err) {
            console.error('Cannot get the current image index in current-image');
            throw err;
        }
        if (this.isOpen) {
            this.handleBoundaries(index);
        }
    }
}
CurrentImageComponent.ɵfac = function CurrentImageComponent_Factory(t) { return new (t || CurrentImageComponent)(ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CurrentImageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CurrentImageComponent, selectors: [["ks-current-image"]], hostBindings: function CurrentImageComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mouseenter", function CurrentImageComponent_mouseenter_HostBindingHandler() { return ctx.onMouseEnter(); })("mouseleave", function CurrentImageComponent_mouseleave_HostBindingHandler() { return ctx.onMouseLeave(); });
    } }, inputs: { id: "id", currentImage: "currentImage", images: "images", isOpen: "isOpen", currentImageConfig: "currentImageConfig", slideConfig: "slideConfig", accessibilityConfig: "accessibilityConfig", keyboardConfig: "keyboardConfig" }, outputs: { loadImage: "loadImage", changeImage: "changeImage", close: "close" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 13, vars: 33, consts: [["ksKeyboardNavigation", "", 1, "main-image-container", 3, "isOpen", "title", "keyPress"], [1, "left-sub-container"], ["role", "button", 3, "tabindex", "click", "keyup"], ["aria-hidden", "true", 3, "title"], [4, "ngIf"], ["id", "current-figure"], ["id", "current-image", "role", "img", 1, "inside", 3, "ngClass", "src", "title", "alt", "tabindex", "load", "click", "keyup", "swipeleft", "swiperight"], ["class", "inside description", "ksDescription", "", 3, "description", "innerHTML", 4, "ngIf"], [1, "right-sub-container"], ["class", "inside current-image-previous", "ksSize", "", "role", "img", 3, "src", "hidden", "sizeConfig", "title", "alt", "tabindex", "click", "keyup", 4, "ngIf", "ngIfElse"], ["firstImage", ""], ["ksSize", "", "role", "img", 1, "inside", "current-image-previous", 3, "src", "hidden", "sizeConfig", "title", "alt", "tabindex", "click", "keyup"], ["ksSize", "", 1, "current-image-previous", "hidden", 3, "sizeConfig"], ["ksDescription", "", 1, "inside", "description", 3, "description", "innerHTML"], ["class", "inside current-image-next", "ksSize", "", "role", "img", 3, "src", "hidden", "sizeConfig", "title", "alt", "tabindex", "click", "keyup", 4, "ngIf", "ngIfElse"], ["lastImage", ""], ["ksSize", "", "role", "img", 1, "inside", "current-image-next", 3, "src", "hidden", "sizeConfig", "title", "alt", "tabindex", "click", "keyup"], ["ksSize", "", 1, "current-image-next", "hidden", 3, "sizeConfig"], [3, "loadingConfig", "accessibilityConfig"]], template: function CurrentImageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "main", 0);
        ɵngcc0.ɵɵlistener("keyPress", function CurrentImageComponent_Template_main_keyPress_0_listener($event) { return ctx.onKeyPress($event); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "a", 2);
        ɵngcc0.ɵɵlistener("click", function CurrentImageComponent_Template_a_click_2_listener($event) { return ctx.onNavigationEvent("left", $event, ctx.normalAction, ctx.isFirstImage); })("keyup", function CurrentImageComponent_Template_a_keyup_2_listener($event) { return ctx.onNavigationEvent("left", $event, ctx.normalAction, ctx.isFirstImage); });
        ɵngcc0.ɵɵelement(3, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, CurrentImageComponent_ng_container_4_Template, 2, 1, "ng-container", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "figure", 5);
        ɵngcc0.ɵɵelementStart(6, "img", 6);
        ɵngcc0.ɵɵlistener("load", function CurrentImageComponent_Template_img_load_6_listener($event) { return ctx.onImageLoad($event); })("click", function CurrentImageComponent_Template_img_click_6_listener($event) { return ctx.onImageEvent($event, ctx.clickAction); })("keyup", function CurrentImageComponent_Template_img_keyup_6_listener($event) { return ctx.onImageEvent($event, ctx.keyboardAction); })("swipeleft", function CurrentImageComponent_Template_img_swipeleft_6_listener($event) { return ctx.swipe($event.type); })("swiperight", function CurrentImageComponent_Template_img_swiperight_6_listener($event) { return ctx.swipe($event.type); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, CurrentImageComponent_figcaption_7_Template, 1, 2, "figcaption", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 8);
        ɵngcc0.ɵɵtemplate(9, CurrentImageComponent_ng_container_9_Template, 2, 1, "ng-container", 4);
        ɵngcc0.ɵɵtemplate(10, CurrentImageComponent_ng_container_10_Template, 2, 2, "ng-container", 4);
        ɵngcc0.ɵɵelementStart(11, "a", 2);
        ɵngcc0.ɵɵlistener("click", function CurrentImageComponent_Template_a_click_11_listener($event) { return ctx.onNavigationEvent("right", $event, ctx.normalAction, ctx.isLastImage); })("keyup", function CurrentImageComponent_Template_a_keyup_11_listener($event) { return ctx.onNavigationEvent("right", $event, ctx.normalAction, ctx.isLastImage); });
        ɵngcc0.ɵɵelement(12, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("isOpen", ctx.isOpen)("title", ctx.accessibilityConfig.mainContainerTitle);
        ɵngcc0.ɵɵattribute("aria-label", ctx.accessibilityConfig.mainContainerAriaLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMapInterpolate1("nav-left ", ctx.isFirstImage ? "no-pointer" : "", "");
        ɵngcc0.ɵɵproperty("tabindex", ctx.isFirstImage ? -1 : 0);
        ɵngcc0.ɵɵattribute("aria-label", ctx.accessibilityConfig.mainPrevImageAriaLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("inside ", ctx.isFirstImage ? "empty-arrow-image" : "left-arrow-image", "");
        ɵngcc0.ɵɵproperty("title", ctx.isFirstImage ? "" : ctx.accessibilityConfig.mainPrevImageTitle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.configSlide == null ? null : ctx.configSlide.sidePreviews == null ? null : ctx.configSlide.sidePreviews.show);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("display", ctx.loading ? "none" : "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("alt", ctx.currentImage.modal.alt ? ctx.currentImage.modal.alt : ctx.getAltDescriptionByImage());
        ɵngcc0.ɵɵproperty("ngClass", "rotate" + (ctx.currentImage.modal && ctx.currentImage.modal.angle ? ctx.currentImage.modal.angle : "0"))("src", ctx.currentImage.modal.img, ɵngcc0.ɵɵsanitizeUrl)("title", ctx.currentImage.modal.title ? ctx.currentImage.modal.title : ctx.getTitleToDisplay())("tabindex", 0);
        ɵngcc0.ɵɵattribute("aria-label", ctx.currentImage.modal.ariaLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.getDescriptionToDisplay() !== "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.slideConfig == null ? null : ctx.slideConfig.sidePreviews == null ? null : ctx.slideConfig.sidePreviews.show);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading && (ctx.configCurrentImage == null ? null : ctx.configCurrentImage.loadingConfig == null ? null : ctx.configCurrentImage.loadingConfig.enable));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("nav-right ", ctx.isFirstImage ? "no-pointer" : "", "");
        ɵngcc0.ɵɵproperty("tabindex", ctx.isLastImage ? -1 : 0);
        ɵngcc0.ɵɵattribute("aria-label", ctx.accessibilityConfig.mainNextImageAriaLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("inside ", ctx.isLastImage ? "empty-arrow-image" : "right-arrow-image", "");
        ɵngcc0.ɵɵproperty("title", ctx.isLastImage ? "" : ctx.accessibilityConfig.mainNextImageTitle);
    } }, directives: function () { return [KeyboardNavigationDirective, ɵngcc1.NgIf, ɵngcc1.NgClass, SizeDirective, DescriptionDirective, LoadingSpinnerComponent]; }, styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;justify-content:center}.main-image-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;justify-content:space-between}.main-image-container[_ngcontent-%COMP%]   .nav[_ngcontent-%COMP%], .main-image-container[_ngcontent-%COMP%] > .left-sub-container[_ngcontent-%COMP%] > .nav-left[_ngcontent-%COMP%], .main-image-container[_ngcontent-%COMP%] > .right-sub-container[_ngcontent-%COMP%] > .nav-right[_ngcontent-%COMP%]{-webkit-animation:1s animatezoom;animation:1s animatezoom;cursor:pointer;transition:.5s}.main-image-container[_ngcontent-%COMP%]   .nav[_ngcontent-%COMP%]:hover, .main-image-container[_ngcontent-%COMP%] > .left-sub-container[_ngcontent-%COMP%] > .nav-left[_ngcontent-%COMP%]:hover, .main-image-container[_ngcontent-%COMP%] > .right-sub-container[_ngcontent-%COMP%] > .nav-right[_ngcontent-%COMP%]:hover{transform:scale(1.1)}.main-image-container[_ngcontent-%COMP%] > .left-sub-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-around;align-items:center}.main-image-container[_ngcontent-%COMP%] > .left-sub-container[_ngcontent-%COMP%] > .nav-left[_ngcontent-%COMP%]{margin-right:5px;margin-left:15px}.main-image-container[_ngcontent-%COMP%] > .left-sub-container[_ngcontent-%COMP%] > .nav-left.no-pointer[_ngcontent-%COMP%]{cursor:default!important}.main-image-container[_ngcontent-%COMP%] > .right-sub-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-around;align-items:center}.main-image-container[_ngcontent-%COMP%] > .right-sub-container[_ngcontent-%COMP%] > .nav-right[_ngcontent-%COMP%]{margin-right:15px;margin-left:5px}.main-image-container[_ngcontent-%COMP%] > .right-sub-container[_ngcontent-%COMP%] > .nav-right.no-pointer[_ngcontent-%COMP%]{cursor:default!important}.main-image-container[_ngcontent-%COMP%]   #current-figure[_ngcontent-%COMP%]{-webkit-animation:.8s fadein-visible;animation:.8s fadein-visible;text-align:center;margin:0;position:relative}.main-image-container[_ngcontent-%COMP%]   #current-figure[_ngcontent-%COMP%] > #current-image[_ngcontent-%COMP%]{max-width:100%;height:auto;display:block}.main-image-container[_ngcontent-%COMP%]   #current-figure[_ngcontent-%COMP%]   figcaption[_ngcontent-%COMP%]{padding:10px;position:absolute;bottom:0;left:0;right:0}.main-image-container[_ngcontent-%COMP%]   #current-figure[_ngcontent-%COMP%]   figcaption[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{font-weight:700;text-align:center}#current-image[_ngcontent-%COMP%]{height:auto;max-width:80vw;max-height:60vh;cursor:pointer}@media screen and (min-width:70vw){#current-image[_ngcontent-%COMP%]{max-width:70vw}}@-webkit-keyframes fadein-visible{from{opacity:0}to{opacity:1}}@keyframes fadein-visible{from{opacity:0}to{opacity:1}}@-webkit-keyframes fadein-semi-visible05{from{opacity:0}to{opacity:.5}}@keyframes fadein-semi-visible05{from{opacity:0}to{opacity:.5}}@-webkit-keyframes fadein-semi-visible08{from{opacity:0}to{opacity:.8}}@keyframes fadein-semi-visible08{from{opacity:0}to{opacity:.8}}@-webkit-keyframes fadein-semi-visible09{from{opacity:0}to{opacity:.9}}@keyframes fadein-semi-visible09{from{opacity:0}to{opacity:.9}}", _c7, "@media only screen and (max-width:1024px),only screen and (max-device-width:1024px){.current-image-next[_ngcontent-%COMP%], .current-image-previous[_ngcontent-%COMP%]{display:none}}@media only screen and (min-device-width:1025px){.current-image-next[_ngcontent-%COMP%], .current-image-preview[_ngcontent-%COMP%], .current-image-previous[_ngcontent-%COMP%]{height:auto;cursor:pointer;opacity:.5;-webkit-animation:.8s fadein-semi-visible05;animation:.8s fadein-semi-visible05}.current-image-next[_ngcontent-%COMP%]:hover, .current-image-preview[_ngcontent-%COMP%]:hover, .current-image-previous[_ngcontent-%COMP%]:hover{opacity:1;transition:.5s}.current-image-previous[_ngcontent-%COMP%]{margin-left:10px;margin-right:5px}.current-image-next[_ngcontent-%COMP%]{margin-right:10px;margin-left:5px}}@-webkit-keyframes fadein-semi-visible05{from{opacity:0}to{opacity:.5}}@keyframes fadein-semi-visible05{from{opacity:0}to{opacity:.5}}"], changeDetection: 0 });
/** @nocollapse */
CurrentImageComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: NgZone },
    { type: ChangeDetectorRef }
];
CurrentImageComponent.propDecorators = {
    id: [{ type: Input }],
    currentImage: [{ type: Input }],
    images: [{ type: Input }],
    isOpen: [{ type: Input }],
    currentImageConfig: [{ type: Input }],
    slideConfig: [{ type: Input }],
    accessibilityConfig: [{ type: Input }],
    keyboardConfig: [{ type: Input }],
    loadImage: [{ type: Output }],
    changeImage: [{ type: Output }],
    close: [{ type: Output }],
    onMouseEnter: [{ type: HostListener, args: ['mouseenter',] }],
    onMouseLeave: [{ type: HostListener, args: ['mouseleave',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CurrentImageComponent, [{
        type: Component,
        args: [{
                selector: 'ks-current-image',
                template: "<main class=\"main-image-container\"\n      ksKeyboardNavigation [isOpen]=\"isOpen\" (keyPress)=\"onKeyPress($event)\"\n      [attr.aria-label]=\"accessibilityConfig.mainContainerAriaLabel\"\n      [title]=\"accessibilityConfig.mainContainerTitle\">\n\n  <div class=\"left-sub-container\">\n    <a class=\"nav-left {{isFirstImage ? 'no-pointer' : ''}}\"\n       [attr.aria-label]=\"accessibilityConfig.mainPrevImageAriaLabel\"\n       [tabindex]=\"isFirstImage ? -1 : 0\" role=\"button\"\n       (click)=\"onNavigationEvent('left', $event, normalAction, isFirstImage)\" (keyup)=\"onNavigationEvent('left', $event, normalAction, isFirstImage)\">\n      <div class=\"inside {{isFirstImage ? 'empty-arrow-image' : 'left-arrow-image'}}\"\n           aria-hidden=\"true\"\n           [title]=\"isFirstImage ? '' : accessibilityConfig.mainPrevImageTitle\"></div>\n    </a>\n\n    <ng-container *ngIf=\"configSlide?.sidePreviews?.show\">\n      <ng-container *ngIf=\"getLeftPreviewImage() as leftPreview\">\n        <img *ngIf=\"!isFirstImage; else firstImage\"\n             class=\"inside current-image-previous\"\n             [src]=\"leftPreview.plain?.img ? leftPreview.plain.img : leftPreview.modal.img\"\n             [hidden]=\"loading\"\n             ksSize [sizeConfig]=\"{width: configSlide.sidePreviews?.size.width, height: configSlide.sidePreviews?.size.height}\"\n             [attr.aria-label]=\"leftPreview.modal.ariaLabel\"\n             [title]=\"leftPreview.modal.title ? leftPreview.modal.title : getDescriptionToDisplay(leftPreview)\"\n             alt=\"{{leftPreview.modal.alt ? leftPreview.modal.alt : getAltDescriptionByImage(leftPreview)}}\"\n             [tabindex]=\"0\" role=\"img\"\n             (click)=\"onNavigationEvent('left', $event, clickAction)\" (keyup)=\"onNavigationEvent('left', $event, keyboardAction)\"/>\n        <ng-template #firstImage>\n          <div class=\"current-image-previous hidden\"\n               ksSize [sizeConfig]=\"{width: configSlide.sidePreviews?.size.width, height: configSlide.sidePreviews?.size.height}\"></div>\n        </ng-template>\n      </ng-container>\n    </ng-container>\n  </div>\n\n\n  <figure id=\"current-figure\" [style.display]=\"loading ? 'none' : ''\">\n    <img id=\"current-image\"\n         class=\"inside\"\n         [ngClass]=\"'rotate' + (currentImage.modal && currentImage.modal.angle ? currentImage.modal.angle : '0')\"\n         [src]=\"currentImage.modal.img\"\n         [attr.aria-label]=\"currentImage.modal.ariaLabel\"\n         [title]=\"currentImage.modal.title ? currentImage.modal.title : getTitleToDisplay()\"\n         alt=\"{{currentImage.modal.alt ? currentImage.modal.alt : getAltDescriptionByImage()}}\"\n         [tabindex]=\"0\" role=\"img\"\n         (load)=\"onImageLoad($event)\"\n         (click)=\"onImageEvent($event, clickAction)\" (keyup)=\"onImageEvent($event, keyboardAction)\"\n         (swipeleft)=\"swipe($event.type)\"\n         (swiperight)=\"swipe($event.type)\"/>\n    <figcaption *ngIf=\"getDescriptionToDisplay() !== ''\"\n                class=\"inside description\"\n                ksDescription [description]=\"configCurrentImage?.description\"\n                [innerHTML]=\"getDescriptionToDisplay()\">\n    </figcaption>\n  </figure>\n\n  <div class=\"right-sub-container\">\n    <ng-container *ngIf=\"slideConfig?.sidePreviews?.show\">\n      <ng-container *ngIf=\"getRightPreviewImage() as rightPreview\">\n        <img *ngIf=\"!isLastImage; else lastImage\"\n             class=\"inside current-image-next\"\n             [src]=\"rightPreview.plain?.img ? rightPreview.plain.img : rightPreview.modal.img\"\n             [hidden]=\"loading\"\n             ksSize [sizeConfig]=\"{width: slideConfig.sidePreviews?.size.width, height: slideConfig.sidePreviews?.size.height}\"\n             [attr.aria-label]=\"rightPreview.modal.ariaLabel\"\n             [title]=\"rightPreview.modal.title ? rightPreview.modal.title : getDescriptionToDisplay(rightPreview)\"\n             alt=\"{{rightPreview.modal.alt ? rightPreview.modal.alt : getAltDescriptionByImage(rightPreview)}}\"\n             [tabindex]=\"0\" role=\"img\"\n             (click)=\"onNavigationEvent('right', $event, clickAction)\" (keyup)=\"onNavigationEvent('right', $event, keyboardAction)\"/>\n        <ng-template #lastImage>\n          <div class=\"current-image-next hidden\"\n               ksSize [sizeConfig]=\"{width: slideConfig.sidePreviews?.size.width, height: slideConfig.sidePreviews?.size.height}\">\n          </div>\n        </ng-template>\n      </ng-container>\n    </ng-container>\n\n    <ng-container *ngIf=\"loading && configCurrentImage?.loadingConfig?.enable\">\n      <ks-loading-spinner [loadingConfig]=\"configCurrentImage?.loadingConfig\"\n                          [accessibilityConfig]=\"accessibilityConfig\"></ks-loading-spinner>\n    </ng-container>\n\n    <a class=\"nav-right {{isFirstImage ? 'no-pointer' : ''}}\"\n       [attr.aria-label]=\"accessibilityConfig.mainNextImageAriaLabel\"\n       [tabindex]=\"isLastImage ? -1 : 0\" role=\"button\"\n       (click)=\"onNavigationEvent('right', $event, normalAction, isLastImage)\" (keyup)=\"onNavigationEvent('right', $event, normalAction, isLastImage)\">\n      <div class=\"inside {{isLastImage ? 'empty-arrow-image' : 'right-arrow-image'}}\"\n           aria-hidden=\"true\"\n           [title]=\"isLastImage ? '' : accessibilityConfig.mainNextImageTitle\"></div>\n    </a>\n  </div>\n</main>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:flex;flex-direction:column;justify-content:center}.main-image-container{display:flex;flex-direction:row;align-items:center;justify-content:space-between}.main-image-container .nav,.main-image-container>.left-sub-container>.nav-left,.main-image-container>.right-sub-container>.nav-right{-webkit-animation:1s animatezoom;animation:1s animatezoom;cursor:pointer;transition:.5s}.main-image-container .nav:hover,.main-image-container>.left-sub-container>.nav-left:hover,.main-image-container>.right-sub-container>.nav-right:hover{transform:scale(1.1)}.main-image-container>.left-sub-container{display:flex;flex-direction:row;justify-content:space-around;align-items:center}.main-image-container>.left-sub-container>.nav-left{margin-right:5px;margin-left:15px}.main-image-container>.left-sub-container>.nav-left.no-pointer{cursor:default!important}.main-image-container>.right-sub-container{display:flex;flex-direction:row;justify-content:space-around;align-items:center}.main-image-container>.right-sub-container>.nav-right{margin-right:15px;margin-left:5px}.main-image-container>.right-sub-container>.nav-right.no-pointer{cursor:default!important}.main-image-container #current-figure{-webkit-animation:.8s fadein-visible;animation:.8s fadein-visible;text-align:center;margin:0;position:relative}.main-image-container #current-figure>#current-image{max-width:100%;height:auto;display:block}.main-image-container #current-figure figcaption{padding:10px;position:absolute;bottom:0;left:0;right:0}.main-image-container #current-figure figcaption .description{font-weight:700;text-align:center}#current-image{height:auto;max-width:80vw;max-height:60vh;cursor:pointer}@media screen and (min-width:70vw){#current-image{max-width:70vw}}@-webkit-keyframes fadein-visible{from{opacity:0}to{opacity:1}}@keyframes fadein-visible{from{opacity:0}to{opacity:1}}@-webkit-keyframes fadein-semi-visible05{from{opacity:0}to{opacity:.5}}@keyframes fadein-semi-visible05{from{opacity:0}to{opacity:.5}}@-webkit-keyframes fadein-semi-visible08{from{opacity:0}to{opacity:.8}}@keyframes fadein-semi-visible08{from{opacity:0}to{opacity:.8}}@-webkit-keyframes fadein-semi-visible09{from{opacity:0}to{opacity:.9}}@keyframes fadein-semi-visible09{from{opacity:0}to{opacity:.9}}", ".arrow-image,.empty-arrow-image,.left-arrow-image,.right-arrow-image{width:30px;height:30px;background-size:30px}.empty-arrow-image{background:#000;opacity:0}.left-arrow-image{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3Ny4xNzUgNDc3LjE3NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDc3LjE3NSA0NzcuMTc1OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij48Zz48cGF0aCBkPSJNMTQ1LjE4OCwyMzguNTc1bDIxNS41LTIxNS41YzUuMy01LjMsNS4zLTEzLjgsMC0xOS4xcy0xMy44LTUuMy0xOS4xLDBsLTIyNS4xLDIyNS4xYy01LjMsNS4zLTUuMywxMy44LDAsMTkuMWwyMjUuMSwyMjUgICBjMi42LDIuNiw2LjEsNCw5LjUsNHM2LjktMS4zLDkuNS00YzUuMy01LjMsNS4zLTEzLjgsMC0xOS4xTDE0NS4xODgsMjM4LjU3NXoiIGZpbGw9IiNGRkZGRkYiLz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+);opacity:.8;transition:.5s}.left-arrow-image:hover{transform:scale(1.2)}.right-arrow-image{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3Ny4xNzUgNDc3LjE3NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDc3LjE3NSA0NzcuMTc1OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij48Zz48cGF0aCBkPSJNMzYwLjczMSwyMjkuMDc1bC0yMjUuMS0yMjUuMWMtNS4zLTUuMy0xMy44LTUuMy0xOS4xLDBzLTUuMywxMy44LDAsMTkuMWwyMTUuNSwyMTUuNWwtMjE1LjUsMjE1LjUgICBjLTUuMyw1LjMtNS4zLDEzLjgsMCwxOS4xYzIuNiwyLjYsNi4xLDQsOS41LDRjMy40LDAsNi45LTEuMyw5LjUtNGwyMjUuMS0yMjUuMUMzNjUuOTMxLDI0Mi44NzUsMzY1LjkzMSwyMzQuMjc1LDM2MC43MzEsMjI5LjA3NXogICAiIGZpbGw9IiNGRkZGRkYiLz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+);opacity:.8;transition:.5s}.right-arrow-image:hover{transform:scale(1.2)}", "@media only screen and (max-width:1024px),only screen and (max-device-width:1024px){.current-image-next,.current-image-previous{display:none}}@media only screen and (min-device-width:1025px){.current-image-next,.current-image-preview,.current-image-previous{height:auto;cursor:pointer;opacity:.5;-webkit-animation:.8s fadein-semi-visible05;animation:.8s fadein-semi-visible05}.current-image-next:hover,.current-image-preview:hover,.current-image-previous:hover{opacity:1;transition:.5s}.current-image-previous{margin-left:10px;margin-right:5px}.current-image-next{margin-right:10px;margin-left:5px}}@-webkit-keyframes fadein-semi-visible05{from{opacity:0}to{opacity:.5}}@keyframes fadein-semi-visible05{from{opacity:0}to{opacity:.5}}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.ChangeDetectorRef }]; }, { loadImage: [{
            type: Output
        }], changeImage: [{
            type: Output
        }], close: [{
            type: Output
        }], 
    /**
     * Listener to stop the gallery when the mouse pointer is over the current image.
     * @return {?}
     */
    onMouseEnter: [{
            type: HostListener,
            args: ['mouseenter']
        }], 
    /**
     * Listener to play the gallery when the mouse pointer leave the current image.
     * @return {?}
     */
    onMouseLeave: [{
            type: HostListener,
            args: ['mouseleave']
        }], id: [{
            type: Input
        }], currentImage: [{
            type: Input
        }], images: [{
            type: Input
        }], isOpen: [{
            type: Input
        }], currentImageConfig: [{
            type: Input
        }], slideConfig: [{
            type: Input
        }], accessibilityConfig: [{
            type: Input
        }], keyboardConfig: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Class `LineLayout` to configure a linear plain gallery.
 */
class LineLayout {
    /**
     * @param {?} size
     * @param {?} breakConfig
     * @param {?} justify
     */
    constructor(size, breakConfig, justify) {
        this.size = size;
        this.breakConfig = breakConfig;
        this.justify = justify;
    }
}
/**
 * Class `GridLayout` to configure a grid plain gallery.
 */
class GridLayout {
    /**
     * @param {?} size
     * @param {?} breakConfig
     */
    constructor(size, breakConfig) {
        this.size = size;
        this.breakConfig = breakConfig;
    }
}
/**
 * Class `AdvancedLayout` to configure a fully custom plain gallery.
 */
class AdvancedLayout {
    /**
     * @param {?} modalOpenerByIndex
     * @param {?} hideDefaultPlainGallery
     */
    constructor(modalOpenerByIndex, hideDefaultPlainGallery) {
        this.modalOpenerByIndex = modalOpenerByIndex;
        this.hideDefaultPlainGallery = hideDefaultPlainGallery;
    }
}
/** @enum {number} */
const PlainGalleryStrategy = {
    // don't use 0 here
    // the first index is 1 and all of the following members are auto-incremented from that point on
    ROW: 1,
    COLUMN: 2,
    GRID: 3,
    CUSTOM: 4 // full custom strategy
    ,
};
PlainGalleryStrategy[PlainGalleryStrategy.ROW] = 'ROW';
PlainGalleryStrategy[PlainGalleryStrategy.COLUMN] = 'COLUMN';
PlainGalleryStrategy[PlainGalleryStrategy.GRID] = 'GRID';
PlainGalleryStrategy[PlainGalleryStrategy.CUSTOM] = 'CUSTOM';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Default accessibility configuration.
 * @type {?}
 */
const KS_DEFAULT_ACCESSIBILITY_CONFIG = {
    backgroundAriaLabel: 'Modal gallery full screen background',
    backgroundTitle: '',
    plainGalleryContentAriaLabel: 'Plain gallery content',
    plainGalleryContentTitle: '',
    modalGalleryContentAriaLabel: 'Modal gallery content',
    modalGalleryContentTitle: '',
    loadingSpinnerAriaLabel: 'The current image is loading. Please be patient.',
    loadingSpinnerTitle: 'The current image is loading. Please be patient.',
    mainContainerAriaLabel: 'Current image and navigation',
    mainContainerTitle: '',
    mainPrevImageAriaLabel: 'Previous image',
    mainPrevImageTitle: 'Previous image',
    mainNextImageAriaLabel: 'Next image',
    mainNextImageTitle: 'Next image',
    dotsContainerAriaLabel: 'Image navigation dots',
    dotsContainerTitle: '',
    dotAriaLabel: 'Navigate to image number',
    previewsContainerAriaLabel: 'Image previews',
    previewsContainerTitle: '',
    previewScrollPrevAriaLabel: 'Scroll previous previews',
    previewScrollPrevTitle: 'Scroll previous previews',
    previewScrollNextAriaLabel: 'Scroll next previews',
    previewScrollNextTitle: 'Scroll next previews',
    carouselContainerAriaLabel: 'Current image and navigation',
    carouselContainerTitle: '',
    carouselPrevImageAriaLabel: 'Previous image',
    carouselPrevImageTitle: 'Previous image',
    carouselNextImageAriaLabel: 'Next image',
    carouselNextImageTitle: 'Next image',
    carouselPreviewsContainerAriaLabel: 'Image previews',
    carouselPreviewsContainerTitle: '',
    carouselPreviewScrollPrevAriaLabel: 'Scroll previous previews',
    carouselPreviewScrollPrevTitle: 'Scroll previous previews',
    carouselPreviewScrollNextAriaLabel: 'Scroll next previews',
    carouselPreviewScrollNextTitle: 'Scroll next previews'
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Service to check if the provided id is unique
 */
class IdValidatorService {
    constructor() {
        this.ids = new Map();
    }
    /**
     * Method to check and reserve an id for the current instance of the library.
     * In this way, no other instances can use the same id.
     * @throws a error with a message if galleryId is neither unique, < 0 or an integer
     * @param {?} galleryId number or undefined that represents the unique id of the gallery.
     * @return {?} boolean true if success. false is never returned, instead an exception is thrown
     */
    checkAndAdd(galleryId) {
        if (!Number.isInteger(galleryId) || galleryId < 0) {
            throw new Error('You must provide a valid [id]="unique integer > 0 here" to the gallery/carousel in your template');
        }
        if (this.ids.get(galleryId)) {
            throw new Error(`Cannot create gallery with id=${galleryId} because already used in your application. This must be a unique integer >= 0`);
        }
        this.ids.set(galleryId, galleryId);
        return true;
    }
    /**
     * Method to remove a reserved id. In this way you are able to use the id again for another instance of the library.
     * @throws a error with a message if galleryId is neither integer or < 0
     * @param {?} galleryId number or undefined that represents the unique id of the gallery.
     * @return {?} boolean true if success. false is never returned, instead an exception is thrown
     */
    remove(galleryId) {
        if (!Number.isInteger(galleryId) || galleryId < 0) {
            throw new Error('You must provide a valid [id]="unique integer > 0 here" to the gallery/carousel in your template');
        }
        // if (this.ids.find(id => id === galleryId)) {
        //   throw new Error(`Cannot create gallery with id=${galleryId} because already used in your application. This must be a unique number >= 0.`);
        // }
        this.ids.delete(galleryId);
        return true;
    }
}
IdValidatorService.ɵfac = function IdValidatorService_Factory(t) { return new (t || IdValidatorService)(); };
IdValidatorService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: IdValidatorService, factory: IdValidatorService.ɵfac, providedIn: 'root' });
/** @nocollapse */ IdValidatorService.ngInjectableDef = defineInjectable({ factory: function IdValidatorService_Factory() { return new IdValidatorService(); }, token: IdValidatorService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IdValidatorService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Main Component of this library with both the plain and modal galleries.
 */
class ModalGalleryComponent {
    /**
     * Constructor with the injection of ´KeyboardService´, an object to support Server-Side Rendering and other useful services.
     * @param {?} keyboardService
     * @param {?} galleryService
     * @param {?} platformId
     * @param {?} changeDetectorRef
     * @param {?} idValidatorService
     */
    constructor(keyboardService, galleryService, platformId, changeDetectorRef, idValidatorService) {
        this.keyboardService = keyboardService;
        this.galleryService = galleryService;
        this.platformId = platformId;
        this.changeDetectorRef = changeDetectorRef;
        this.idValidatorService = idValidatorService;
        /**
         * Boolean to enable modal-gallery close behaviour when clicking
         * on the semi-transparent background. Enabled by default.
         */
        this.enableCloseOutside = true;
        /**
         * Object of type `AccessibilityConfig` to init custom accessibility features.
         * For instance, it contains titles, alt texts, aria-labels and so on.
         */
        this.accessibilityConfig = KS_DEFAULT_ACCESSIBILITY_CONFIG;
        /**
         * Output to emit an event when the modal gallery is closed.
         */
        this.close = new EventEmitter();
        /**
         * Output to emit an event when an image is changed.
         */
        this.show = new EventEmitter();
        /**
         * Output to emit an event when the current image is the first one.
         */
        this.firstImage = new EventEmitter();
        /**
         * Output to emit an event when the current image is the last one.
         */
        this.lastImage = new EventEmitter();
        /**
         * Output to emit an event when the modal gallery is closed.
         */
        this.hasData = new EventEmitter();
        /**
         * Output to emit an event when a button is clicked, but before that the action is triggered.
         */
        this.buttonBeforeHook = new EventEmitter();
        /**
         * Output to emit an event when a button is clicked, but after that the action is triggered.
         */
        this.buttonAfterHook = new EventEmitter();
        /**
         * Output to emit an event when someone clicks either an arrow of modal gallery or also in previews.
         */
        this.arrow = new EventEmitter();
        /**
         * Boolean that it is true if the modal gallery is visible. False by default.
         */
        this.opened = false;
        /**
         * Boolean to open the modal gallery. False by default.
         */
        this.showGallery = false;
    }
    /**
     * HostListener to catch browser's back button and destroy the gallery.
     * This prevents weired behaviour about scrolling.
     * Added to fix this issue: https://github.com/Ks89/angular-modal-gallery/issues/159
     * @param {?} e
     * @return {?}
     */
    onPopState(e) {
        this.closeGallery();
    }
    /**
     * Method ´ngOnChanges´ to re-init images if input is changed.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called before `ngOnInit()` and whenever one or more data-bound input properties change.
     * @param {?} changes `SimpleChanges` object of current and previous property values provided by Angular.
     * @return {?}
     */
    ngOnChanges(changes) {
        /** @type {?} */
        const imagesChange = changes.modalImages;
        /** @type {?} */
        const plainGalleryConfigChange = changes.plainGalleryConfig;
        if (imagesChange && !imagesChange.firstChange && imagesChange.previousValue !== imagesChange.currentValue) {
            this.initImages();
        }
        if (plainGalleryConfigChange) {
            // const prevPlainGalleryConfigChange: any = plainGalleryConfigChange.previousValue;
            /** @type {?} */
            const currPlainGalleryConfigChange = plainGalleryConfigChange.currentValue;
            if (currPlainGalleryConfigChange.layout &&
                currPlainGalleryConfigChange.layout instanceof AdvancedLayout &&
                currPlainGalleryConfigChange.layout.modalOpenerByIndex !== -1) {
                // console.log('opening modal gallery from custom plain gallery, index: ', currPlainGalleryConfigChange);
                this.showModalGallery(currPlainGalleryConfigChange.layout.modalOpenerByIndex);
            }
        }
    }
    /**
     * Method ´ngOnInit´ to init images calling `initImages()`.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called only one time!!!
     * @return {?}
     */
    ngOnInit() {
        this.idValidatorService.checkAndAdd(this.id);
        // id is a mandatory input and must a number > 0
        if ((!this.id && this.id !== 0) || this.id < 0) {
            throw new Error(`'[id]="a number >= 0"' is a mandatory input from 6.0.0 in angular-modal-gallery.` +
                `If you are using multiple instances of this library, please be sure to use different ids`);
        }
        // call initImages to init images and to emit `hasData` event
        this.initImages();
        /** @type {?} */
        const defaultSlideConfig = {
            infinite: false,
            playConfig: (/** @type {?} */ ({ autoPlay: false, interval: 5000, pauseOnHover: true })),
            sidePreviews: (/** @type {?} */ ({ show: true, size: { width: '100px', height: 'auto' } }))
        };
        this.configSlide = Object.assign({}, defaultSlideConfig, this.slideConfig);
        this.galleryServiceNavigateSubscription = this.galleryService.navigate.subscribe((/**
         * @param {?} payload
         * @return {?}
         */
        (payload) => {
            if (!payload) {
                return;
            }
            // if galleryId is not valid OR galleryId is related to another instance and not this one
            if (payload.galleryId === undefined || payload.galleryId < 0 || payload.galleryId !== this.id) {
                return;
            }
            // if image index is not valid
            if (payload.index < 0 || payload.index > this.images.length) {
                return;
            }
            this.showModalGallery(payload.index, true);
        }));
        this.galleryServiceCloseSubscription = this.galleryService.close.subscribe((/**
         * @param {?} galleryId
         * @return {?}
         */
        (galleryId) => {
            if (galleryId < 0 || this.id !== galleryId) {
                return;
            }
            this.closeGallery(Action.NORMAL, true);
        }));
        this.galleryServiceUpdateSubscription = this.galleryService.update.subscribe((/**
         * @param {?} payload
         * @return {?}
         */
        (payload) => {
            if (!payload) {
                return;
            }
            // if galleryId is not valid OR galleryId is related to another instance and not this one
            if (payload.galleryId === undefined || payload.galleryId < 0 || payload.galleryId !== this.id) {
                return;
            }
            // if either image index or image are not valid
            if (payload.index < 0 || payload.index > this.images.length || !payload.image) {
                return;
            }
            /** @type {?} */
            const currentIndex = getIndex(payload.image, this.images);
            this.images = this.images.map((/**
             * @param {?} image
             * @param {?} index
             * @return {?}
             */
            (image, index) => {
                if (image.id === payload.index) {
                    return (/** @type {?} */ (payload.image));
                }
                return image;
            }));
            if (currentIndex === payload.index) {
                this.currentImage = this.images[payload.index];
            }
            this.changeDetectorRef.markForCheck();
        }));
        this.galleryServiceAutoPlaySubscription = this.galleryService.autoPlay.subscribe((/**
         * @param {?} payload
         * @return {?}
         */
        (payload) => {
            // if galleryId is not valid OR galleryId is related to another instance and not this one
            if (payload.galleryId === undefined || payload.galleryId < 0 || payload.galleryId !== this.id) {
                return;
            }
            this.configSlide.playConfig.autoPlay = payload.result;
        }));
    }
    /**
     * Method called by custom upper buttons.
     * @param {?} event
     * @return {?}
     */
    onCustomEmit(event) {
        /** @type {?} */
        const eventToEmit = this.getButtonEventToEmit(event);
        this.buttonBeforeHook.emit(eventToEmit);
        // console.log('on onCustomEmit', eventToEmit);
        this.buttonAfterHook.emit(eventToEmit);
    }
    // TODO implement on refresh
    // /**
    //  * Method called by the refresh upper button.
    //  * STILL NOT IMPLEMENTED, SO DON'T USE IT
    //  * @param ButtonEvent event payload
    //  */
    // onRefresh(event: ButtonEvent) {
    //   const eventToEmit: ButtonEvent = this.getButtonEventToEmit(event);
    //
    //   this.buttonBeforeHook.emit(eventToEmit);
    //   // console.log('TODO implement on refresh inside the library', eventToEmit);
    //
    //   this.currentImage = Object.assign({}, this.currentImage, { previouslyLoaded: false });
    //
    //   // TODO add logic to hide and show the current image
    //
    //   // console.log('onRefresh', this.currentImage);
    //
    //   // const indexNum: number = this.currentImageComponent.getIndex();
    //
    //   // this.images = this.images.map((val: InternalLibImage, index: number) => {
    //   //   if (index !== 2) {
    //   //     return val;
    //   //   } else {
    //   //     const img: InternalLibImage = Object.assign({}, val, {previouslyLoaded: false});
    //   //     return img;
    //   //   }
    //   // });
    //   //
    //   // this.closeGallery();
    //   // this.showModalGallery(2);
    //
    //   this.buttonAfterHook.emit(eventToEmit);
    // }
    // /**
    //  * Method called by the rotate upper button.
    //  * @param ButtonEvent event payload
    //  */
    // onRotate(event: ButtonEvent) {
    //   const eventToEmit: ButtonEvent = this.getButtonEventToEmit(event);
    //   this.buttonBeforeHook.emit(eventToEmit);
    //
    //   // TODO implement rotation logic
    //
    //   this.buttonAfterHook.emit(eventToEmit);
    // }
    /**
     * Method called by the full-screen upper button.
     * @param {?} event
     * @return {?}
     */
    onFullScreen(event) {
        /** @type {?} */
        const eventToEmit = this.getButtonEventToEmit(event);
        this.buttonBeforeHook.emit(eventToEmit);
        /** @type {?} */
        const doc = (/** @type {?} */ (document));
        /** @type {?} */
        const docEl = (/** @type {?} */ (document.documentElement));
        /** @type {?} */
        const fullscreenDisabled = !doc.fullscreenElement && !doc.webkitFullscreenElement && !doc.mozFullScreenElement && !doc.msFullscreenElement;
        if (fullscreenDisabled) {
            if (docEl.requestFullscreen) {
                docEl.requestFullscreen();
            }
            else if (docEl.webkitRequestFullscreen) {
                docEl.webkitRequestFullscreen();
            }
            else if (docEl.mozRequestFullScreen) {
                docEl.mozRequestFullScreen();
            }
            else if (docEl.msRequestFullscreen) {
                docEl.msRequestFullscreen();
            }
        }
        else {
            if (doc.exitFullscreen) {
                doc.exitFullscreen();
            }
            else if (doc.msExitFullscreen) {
                doc.msExitFullscreen();
            }
            else if (doc.mozCancelFullScreen) {
                doc.mozCancelFullScreen();
            }
            else if (doc.webkitExitFullscreen) {
                doc.webkitExitFullscreen();
            }
        }
        this.buttonAfterHook.emit(eventToEmit);
    }
    /**
     * Method called by the delete upper button.
     * @param {?} event
     * @return {?}
     */
    onDelete(event) {
        /** @type {?} */
        const eventToEmit = this.getButtonEventToEmit(event);
        this.buttonBeforeHook.emit(eventToEmit);
        if (this.images.length === 1) {
            this.closeGallery();
        }
        /** @type {?} */
        const imageIndexToDelete = this.currentImageComponent.getIndexToDelete(event.image);
        if (imageIndexToDelete === this.images.length - 1) {
            // last image
            this.currentImageComponent.prevImage();
        }
        else {
            this.currentImageComponent.nextImage();
        }
        this.buttonAfterHook.emit(eventToEmit);
    }
    /**
     * Method called by the navigate upper button.
     * @param {?} event
     * @return {?}
     */
    onNavigate(event) {
        /** @type {?} */
        const eventToEmit = this.getButtonEventToEmit(event);
        this.buttonBeforeHook.emit(eventToEmit);
        // To support SSR
        if (isPlatformBrowser(this.platformId)) {
            if (eventToEmit.image && eventToEmit.image.modal.extUrl) {
                // where I should open this link? The current tab or another one?
                if (eventToEmit.button && eventToEmit.button.extUrlInNewTab) {
                    // in this case I should use target _blank to open the url in a new tab, however these is a security issue.
                    // Prevent Reverse Tabnabbing's attacks (https://www.owasp.org/index.php/Reverse_Tabnabbing)
                    // Some resources:
                    // - https://www.owasp.org/index.php/HTML5_Security_Cheat_Sheet#Tabnabbing
                    // - https://medium.com/@jitbit/target-blank-the-most-underestimated-vulnerability-ever-96e328301f4c
                    // - https://developer.mozilla.org/en-US/docs/Web/API/Window/open
                    /** @type {?} */
                    const newWindow = window.open(eventToEmit.image.modal.extUrl, 'noopener,noreferrer,');
                    newWindow.opener = null; // required to prevent security issues
                }
                else {
                    window.location.href = eventToEmit.image.modal.extUrl;
                }
            }
        }
        this.buttonAfterHook.emit(eventToEmit);
    }
    /**
     * Method called by the download upper button.
     * @param {?} event
     * @return {?}
     */
    onDownload(event) {
        /** @type {?} */
        const eventToEmit = this.getButtonEventToEmit(event);
        this.buttonBeforeHook.emit(eventToEmit);
        this.downloadImage();
        this.buttonAfterHook.emit(eventToEmit);
    }
    /**
     * Method called by the close upper button.
     * @param {?} event
     * @param {?=} action
     * @return {?}
     */
    onCloseGallery(event, action = Action.NORMAL) {
        /** @type {?} */
        const eventToEmit = this.getButtonEventToEmit(event);
        this.buttonBeforeHook.emit(eventToEmit);
        this.closeGallery(action);
        this.buttonAfterHook.emit(eventToEmit);
    }
    /**
     * Method to close the modal gallery specifying the action.
     * It also reset the `keyboardService` to prevent multiple listeners.
     * @param {?=} action
     * @param {?=} isCalledByService
     * @return {?}
     */
    closeGallery(action = Action.NORMAL, isCalledByService = false) {
        this.close.emit(new ImageModalEvent(action, true));
        this.opened = false;
        this.keyboardService.reset();
        // shows scrollbar
        document.body.style.overflow = 'visible';
        if (isCalledByService) {
            // the following is required, otherwise the view will not be updated
            // this happens only if called by gallery.service
            this.changeDetectorRef.markForCheck();
        }
    }
    /**
     * Method called when you click on an image of your plain (or inline) gallery.
     * @param {?} index
     * @return {?}
     */
    onShowModalGallery(index) {
        this.showModalGallery(index);
    }
    /**
     * Method to show the modal gallery displaying the image with
     * the index specified as input parameter.
     * It will also register a new `keyboardService` to catch keyboard's events to download the current
     * image with keyboard's shortcuts. This service, will be removed either when modal gallery component
     * will be destroyed or when the gallery is closed invoking the `closeGallery` method.
     * @param {?} index
     * @param {?=} isCalledByService
     * @return {?}
     */
    showModalGallery(index, isCalledByService = false) {
        // hides scrollbar
        document.body.style.overflow = 'hidden';
        this.keyboardService.add((/**
         * @param {?} event
         * @param {?} combo
         * @return {?}
         */
        (event, combo) => {
            if (event.preventDefault) {
                event.preventDefault();
            }
            else {
                // internet explorer
                event.returnValue = false;
            }
            this.downloadImage();
        }));
        this.opened = true;
        this.currentImage = this.images[index];
        // emit a new ImageModalEvent with the index of the current image
        this.show.emit(new ImageModalEvent(Action.LOAD, index + 1));
        if (isCalledByService) {
            // the following is required, otherwise the view will not be updated
            // this happens only if called by gallery.service
            this.changeDetectorRef.markForCheck();
        }
    }
    /**
     * Method called when the image changes and used to update the `currentImage` object.
     * @param {?} event
     * @return {?}
     */
    onChangeCurrentImage(event) {
        /** @type {?} */
        const newIndex = (/** @type {?} */ (event.result));
        if (newIndex < 0 || newIndex >= this.images.length) {
            return;
        }
        this.currentImage = this.images[newIndex];
        // emit first/last event based on newIndex value
        this.emitBoundaryEvent(event.action, newIndex);
        // emit current visible image index
        this.show.emit(new ImageModalEvent(event.action, newIndex + 1));
    }
    /**
     * @return {?}
     */
    isPlainGalleryVisible() {
        if (this.plainGalleryConfig && this.plainGalleryConfig.layout && this.plainGalleryConfig.layout instanceof AdvancedLayout) {
            return !this.plainGalleryConfig.layout.hideDefaultPlainGallery;
        }
        return true;
    }
    /**
     * Method called when you click 'outside' (i.e. on the semi-transparent background)
     * to close the modal gallery if `enableCloseOutside` is true.
     * @param {?} event
     * @return {?}
     */
    onClickOutside(event) {
        if (event && this.enableCloseOutside) {
            this.closeGallery(Action.CLICK);
        }
    }
    /**
     * Method called when an image is loaded and the loading spinner has gone.
     * It sets the previouslyLoaded flag inside the Image to hide loading spinner when displayed again.
     * @param {?} event
     * @return {?}
     */
    onImageLoad(event) {
        // console.log('modal-image onImageLoad', event);
        // console.log('modal-image onImageLoad images before', this.images);
        // sets as previously loaded the image with index specified by `event.status`
        this.images = this.images.map((/**
         * @param {?} img
         * @return {?}
         */
        (img) => {
            if (img && img.id === event.id) {
                return Object.assign({}, img, { previouslyLoaded: event.status });
            }
            return img;
        }));
        // console.log('modal-image onImageLoad images after', this.images);
    }
    /**
     * Method called when a dot is clicked and used to update the current image.
     * @param {?} index
     * @return {?}
     */
    onClickDot(index) {
        this.currentImage = this.images[index];
    }
    /**
     * Method called when an image preview is clicked and used to update the current image.
     * @param {?} event
     * @return {?}
     */
    onClickPreview(event) {
        this.onChangeCurrentImage(event);
    }
    // onClickArrow(event: InteractionEvent) {
    //   // TODO validate before to emit
    //   this.arrow.emit(event);
    // }
    /**
     * Method to download the current image, only if `downloadable` is true.
     * It contains also a logic to enable downloading features also for IE11.
     * @return {?}
     */
    downloadImage() {
        if (this.currentImageConfig && !this.currentImageConfig.downloadable) {
            return;
        }
        // If IE11 or Microsoft Edge use msSaveBlob(...)
        if (this.isIEorEdge()) {
            // I cannot use fetch API because IE11 doesn't support it,
            // so I have to switch to XMLHttpRequest
            this.downloadImageOnlyIEorEdge();
        }
        else {
            // for all other browsers
            this.downloadImageAllBrowsers();
        }
    }
    /**
     * Method to cleanup resources. In fact, this will reset keyboard's service.
     * This is an Angular's lifecycle hook that is called when this component is destroyed.
     * @return {?}
     */
    ngOnDestroy() {
        this.keyboardService.reset();
        this.idValidatorService.remove(this.id);
        if (this.galleryServiceNavigateSubscription) {
            this.galleryServiceNavigateSubscription.unsubscribe();
        }
        if (this.galleryServiceCloseSubscription) {
            this.galleryServiceCloseSubscription.unsubscribe();
        }
        if (this.galleryServiceUpdateSubscription) {
            this.galleryServiceUpdateSubscription.unsubscribe();
        }
        if (this.galleryServiceAutoPlaySubscription) {
            this.galleryServiceAutoPlaySubscription.unsubscribe();
        }
    }
    /**
     * Private method to download the current image for all browsers except for IE11.
     * @private
     * @return {?}
     */
    downloadImageAllBrowsers() {
        /** @type {?} */
        const link = document.createElement('a');
        link.href = (/** @type {?} */ (this.currentImage.modal.img));
        link.setAttribute('download', this.getFileName(this.currentImage));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    /**
     * Private method to download the current image only for IE11 using
     * custom javascript's methods available only on IE.
     * @private
     * @return {?}
     */
    downloadImageOnlyIEorEdge() {
        if (isPlatformBrowser(this.platformId)) {
            /** @type {?} */
            const req = new XMLHttpRequest();
            req.open('GET', (/** @type {?} */ (this.currentImage.modal.img)), true);
            req.responseType = 'arraybuffer';
            req.onload = (/**
             * @param {?} event
             * @return {?}
             */
            event => {
                /** @type {?} */
                const blob = new Blob([req.response], { type: 'image/png' });
                window.navigator.msSaveBlob(blob, this.getFileName(this.currentImage));
            });
            req.send();
        }
    }
    /**
     * Private method to get the `ButtonEvent` to emit, merging the input `ButtonEvent`
     * with the current image.
     * @private
     * @param {?} event
     * @return {?} ButtonEvent event payload with the current image included
     */
    getButtonEventToEmit(event) {
        return Object.assign(event, { image: this.currentImage });
    }
    /**
     * Private method to get the file name from an input path.
     * This is used either to get the image's name from its path or from the Image itself,
     * if specified as 'downloadFileName' by the user.
     * @private
     * @param {?} image
     * @return {?} string string file name of the input image.
     */
    getFileName(image) {
        if (!image.modal.downloadFileName || image.modal.downloadFileName.length === 0) {
            return ((/** @type {?} */ (this.currentImage.modal.img))).replace(/^.*[\\\/]/, '');
        }
        else {
            return image.modal.downloadFileName;
        }
    }
    /**
     * Private method to initialize `images` as array of `Image`s.
     * Also, it will emit ImageowmodaModalEvent to say that images are loaded.
     * @private
     * @return {?}
     */
    initImages() {
        // I'm not cloning the array, but I'm doing this to cast it to an array of InternalLibImages
        this.images = (/** @type {?} */ (this.modalImages));
        this.hasData.emit(new ImageModalEvent(Action.LOAD, true));
        this.showGallery = this.images.length > 0;
    }
    /**
     * Private method to emit events when either the last or the first image are visible.
     * @private
     * @param {?} action Enum of type Action that represents the source of the event that changed the
     *  current image to the first one or the last one.
     * @param {?} indexToCheck is the index number of the image (the first or the last one).
     * @return {?}
     */
    emitBoundaryEvent(action, indexToCheck) {
        // to emit first/last event
        switch (indexToCheck) {
            case 0:
                this.firstImage.emit(new ImageModalEvent(action, true));
                break;
            case this.images.length - 1:
                this.lastImage.emit(new ImageModalEvent(action, true));
                break;
        }
    }
    /**
     * Private method to check if this library is running on
     * Microsoft browsers or not (i.e. it detects both IE11 and Edge)
     * supporting also Server-Side Rendering.
     * Inspired by https://msdn.microsoft.com/it-it/library/hh779016(v=vs.85).aspx
     * @private
     * @return {?} any the result
     */
    isIEorEdge() {
        if (isPlatformBrowser(this.platformId)) {
            // if both Blob constructor and msSaveOrOpenBlob are supported by the current browser
            return window.Blob && window.navigator.msSaveOrOpenBlob;
        }
        if (isPlatformServer(this.platformId)) {
            // server only
            return true;
        }
    }
}
ModalGalleryComponent.ɵfac = function ModalGalleryComponent_Factory(t) { return new (t || ModalGalleryComponent)(ɵngcc0.ɵɵdirectiveInject(KeyboardService), ɵngcc0.ɵɵdirectiveInject(GalleryService), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(IdValidatorService)); };
ModalGalleryComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ModalGalleryComponent, selectors: [["ks-modal-gallery"]], viewQuery: function ModalGalleryComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(CurrentImageComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.currentImageComponent = _t.first);
    } }, hostBindings: function ModalGalleryComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("popstate", function ModalGalleryComponent_popstate_HostBindingHandler($event) { return ctx.onPopState($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { enableCloseOutside: "enableCloseOutside", accessibilityConfig: "accessibilityConfig", id: "id", modalImages: "modalImages", buttonsConfig: "buttonsConfig", currentImageConfig: "currentImageConfig", dotsConfig: "dotsConfig", previewConfig: "previewConfig", slideConfig: "slideConfig", keyboardConfig: "keyboardConfig", plainGalleryConfig: "plainGalleryConfig" }, outputs: { close: "close", show: "show", firstImage: "firstImage", lastImage: "lastImage", hasData: "hasData", buttonBeforeHook: "buttonBeforeHook", buttonAfterHook: "buttonAfterHook", arrow: "arrow" }, exportAs: ["ksModalGallery"], features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 7, consts: [[3, "images", "showGallery", "plainGalleryConfig", "accessibilityConfig", "show"], [3, "isOpen", "accessibilityConfig"], ["id", "modal-gallery-wrapper", "ksClickOutside", "", 3, "title", "clickOutsideEnable", "clickOutside", 4, "ngIf"], ["id", "modal-gallery-wrapper", "ksClickOutside", "", 3, "title", "clickOutsideEnable", "clickOutside"], ["id", "flex-min-height-ie-fix"], ["id", "modal-gallery-container"], [3, "currentImage", "buttonsConfig", "delete", "navigate", "download", "close", "fullscreen", "customEmit"], [3, "id", "images", "currentImage", "isOpen", "slideConfig", "keyboardConfig", "accessibilityConfig", "currentImageConfig", "loadImage", "changeImage", "close"], [3, "images", "currentImage", "dotsConfig", "accessibilityConfig", "clickDot"], [3, "images", "currentImage", "previewConfig", "accessibilityConfig", "clickPreview"]], template: function ModalGalleryComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ks-plain-gallery", 0);
        ɵngcc0.ɵɵlistener("show", function ModalGalleryComponent_Template_ks_plain_gallery_show_0_listener($event) { return ctx.onShowModalGallery($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(1, "ks-background", 1);
        ɵngcc0.ɵɵtemplate(2, ModalGalleryComponent_div_2_Template, 8, 21, "div", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("images", ctx.images)("showGallery", ctx.showGallery && ctx.isPlainGalleryVisible())("plainGalleryConfig", ctx.plainGalleryConfig)("accessibilityConfig", ctx.accessibilityConfig);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("isOpen", ctx.opened)("accessibilityConfig", ctx.accessibilityConfig);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.opened);
    } }, directives: function () { return [PlainGalleryComponent, BackgroundComponent, ɵngcc1.NgIf, ClickOutsideDirective, UpperButtonsComponent, CurrentImageComponent, DotsComponent, PreviewsComponent]; }, styles: ["#modal-gallery-wrapper[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:10000}#flex-min-height-ie-fix[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center}#modal-gallery-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:space-between;min-height:100vh}"], changeDetection: 0 });
/** @nocollapse */
ModalGalleryComponent.ctorParameters = () => [
    { type: KeyboardService },
    { type: GalleryService },
    { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: ChangeDetectorRef },
    { type: IdValidatorService }
];
ModalGalleryComponent.propDecorators = {
    id: [{ type: Input }],
    modalImages: [{ type: Input }],
    buttonsConfig: [{ type: Input }],
    enableCloseOutside: [{ type: Input }],
    currentImageConfig: [{ type: Input }],
    dotsConfig: [{ type: Input }],
    previewConfig: [{ type: Input }],
    slideConfig: [{ type: Input }],
    accessibilityConfig: [{ type: Input }],
    keyboardConfig: [{ type: Input }],
    plainGalleryConfig: [{ type: Input }],
    close: [{ type: Output }],
    show: [{ type: Output }],
    firstImage: [{ type: Output }],
    lastImage: [{ type: Output }],
    hasData: [{ type: Output }],
    buttonBeforeHook: [{ type: Output }],
    buttonAfterHook: [{ type: Output }],
    arrow: [{ type: Output }],
    currentImageComponent: [{ type: ViewChild, args: [CurrentImageComponent,] }],
    onPopState: [{ type: HostListener, args: ['window:popstate', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalGalleryComponent, [{
        type: Component,
        args: [{
                selector: 'ks-modal-gallery',
                exportAs: 'ksModalGallery',
                template: "<ks-plain-gallery [images]=\"images\"\n                  [showGallery]=\"showGallery && isPlainGalleryVisible()\"\n                  [plainGalleryConfig]=\"plainGalleryConfig\"\n                  [accessibilityConfig]=\"accessibilityConfig\"\n                  (show)=\"onShowModalGallery($event)\"></ks-plain-gallery>\n\n<ks-background [isOpen]=\"opened\"\n               [accessibilityConfig]=\"accessibilityConfig\"></ks-background>\n\n<div id=\"modal-gallery-wrapper\" *ngIf=\"opened\"\n     [attr.aria-label]=\"accessibilityConfig.modalGalleryContentAriaLabel\"\n     [title]=\"accessibilityConfig.modalGalleryContentTitle\"\n     ksClickOutside [clickOutsideEnable]=\"enableCloseOutside\"\n     (clickOutside)=\"onClickOutside($event)\">\n\n  <div id=\"flex-min-height-ie-fix\">\n    <div id=\"modal-gallery-container\">\n\n      <ks-upper-buttons [currentImage]=\"currentImage\"\n                        [buttonsConfig]=\"buttonsConfig\"\n                        (delete)=\"onDelete($event)\"\n                        (navigate)=\"onNavigate($event)\"\n                        (download)=\"onDownload($event)\"\n                        (close)=\"onCloseGallery($event)\"\n                        (fullscreen)=\"onFullScreen($event)\"\n                        (customEmit)=\"onCustomEmit($event)\"></ks-upper-buttons>\n                        <!--(rotate)=\"onRotate($event)\"-->\n\n      <ks-current-image [id]=\"id\"\n                        [images]=\"images\"\n                        [currentImage]=\"currentImage\"\n                        [isOpen]=\"opened\"\n                        [slideConfig]=\"configSlide\"\n                        [keyboardConfig]=\"keyboardConfig\"\n                        [accessibilityConfig]=\"accessibilityConfig\"\n                        [currentImageConfig]=\"currentImageConfig\"\n                        (loadImage)=\"onImageLoad($event)\"\n                        (changeImage)=\"onChangeCurrentImage($event)\"\n                        (close)=\"onCloseGallery($event)\"></ks-current-image>\n\n      <div>\n        <ks-dots [images]=\"images\"\n                 [currentImage]=\"currentImage\"\n                 [dotsConfig]=\"dotsConfig\"\n                 [accessibilityConfig]=\"accessibilityConfig\"\n                 (clickDot)=\"onClickDot($event)\"></ks-dots>\n\n        <ks-previews [images]=\"images\"\n                     [currentImage]=\"currentImage\"\n                     [previewConfig]=\"previewConfig\"\n                     [accessibilityConfig]=\"accessibilityConfig\"\n                     (clickPreview)=\"onClickPreview($event)\"></ks-previews>\n      </div>\n    </div>\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["#modal-gallery-wrapper{position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:10000}#flex-min-height-ie-fix{display:flex;flex-direction:column;justify-content:center}#modal-gallery-container{display:flex;flex-direction:column;justify-content:space-between;min-height:100vh}"]
            }]
    }], function () { return [{ type: KeyboardService }, { type: GalleryService }, { type: Object, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: ɵngcc0.ChangeDetectorRef }, { type: IdValidatorService }]; }, { enableCloseOutside: [{
            type: Input
        }], accessibilityConfig: [{
            type: Input
        }], close: [{
            type: Output
        }], show: [{
            type: Output
        }], firstImage: [{
            type: Output
        }], lastImage: [{
            type: Output
        }], hasData: [{
            type: Output
        }], buttonBeforeHook: [{
            type: Output
        }], buttonAfterHook: [{
            type: Output
        }], arrow: [{
            type: Output
        }], 
    /**
     * HostListener to catch browser's back button and destroy the gallery.
     * This prevents weired behaviour about scrolling.
     * Added to fix this issue: https://github.com/Ks89/angular-modal-gallery/issues/159
     * @param {?} e
     * @return {?}
     */
    onPopState: [{
            type: HostListener,
            args: ['window:popstate', ['$event']]
        }], id: [{
            type: Input
        }], modalImages: [{
            type: Input
        }], buttonsConfig: [{
            type: Input
        }], currentImageConfig: [{
            type: Input
        }], dotsConfig: [{
            type: Input
        }], previewConfig: [{
            type: Input
        }], slideConfig: [{
            type: Input
        }], keyboardConfig: [{
            type: Input
        }], plainGalleryConfig: [{
            type: Input
        }], currentImageComponent: [{
            type: ViewChild,
            args: [CurrentImageComponent]
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Component with configurable inline/plain carousel.
 */
class CarouselComponent extends AccessibleComponent {
    /**
     * @param {?} _platformId
     * @param {?} _ngZone
     * @param {?} galleryService
     * @param {?} ref
     * @param {?} sanitizer
     */
    constructor(_platformId, _ngZone, galleryService, ref, sanitizer) {
        super();
        this._platformId = _platformId;
        this._ngZone = _ngZone;
        this.galleryService = galleryService;
        this.ref = ref;
        this.sanitizer = sanitizer;
        /**
         * Attribute to set ariaLabel of the host component
         */
        this.ariaLabel = `Carousel`;
        /**
         * Object of type `DotsConfig` to init DotsComponent's features.
         * For instance, it contains a param to show/hide this component.
         */
        this.dotsConfig = { visible: true };
        /**
         * boolean to enable/disable infinite sliding. Enabled by default.
         */
        this.infinite = true;
        /**
         * Object of type `AccessibilityConfig` to init custom accessibility features.
         * For instance, it contains titles, alt texts, aria-labels and so on.
         */
        this.accessibilityConfig = KS_DEFAULT_ACCESSIBILITY_CONFIG;
        /**
         * Output to emit an event when an image is changed.
         */
        this.show = new EventEmitter();
        /**
         * Output to emit an event when the current image is the first one.
         */
        this.firstImage = new EventEmitter();
        /**
         * Output to emit an event when the current image is the last one.
         */
        this.lastImage = new EventEmitter();
        /**
         * Enum of type `Action` that represents a mouse click on a button.
         * Declared here to be used inside the template.
         */
        this.clickAction = Action.CLICK;
        /**
         * Enum of type `Action` that represents a keyboard action.
         * Declared here to be used inside the template.
         */
        this.keyboardAction = Action.KEYBOARD;
        /**
         * Boolean that it's true when you are watching the first image (currently visible).
         * False by default
         */
        this.isFirstImage = false;
        /**
         * Boolean that it's true when you are watching the last image (currently visible).
         * False by default
         */
        this.isLastImage = false;
        /**
         * Object of type `PlainGalleryConfig` to force ks-modal-gallery to hide plain-gallery
         */
        this.plainGalleryHidden = {
            strategy: PlainGalleryStrategy.CUSTOM,
            layout: new AdvancedLayout(-1, true)
        };
        /**
         * Subject to play the carousel.
         */
        this.start$ = new Subject();
        /**
         * Subject to stop the carousel.
         */
        this.stop$ = new Subject();
        /**
         * Private object without type to define all swipe actions used by hammerjs.
         */
        this.SWIPE_ACTION = {
            LEFT: 'swipeleft',
            RIGHT: 'swiperight',
            UP: 'swipeup',
            DOWN: 'swipedown'
        };
    }
    /**
     * Listener to stop the gallery when the mouse pointer is over the current image.
     * @return {?}
     */
    onMouseEnter() {
        if (!this.configPlay.pauseOnHover) {
            return;
        }
        this.stopCarousel();
    }
    /**
     * Listener to play the gallery when the mouse pointer leave the current image.
     * @return {?}
     */
    onMouseLeave() {
        if (!this.configPlay.pauseOnHover || !this.configPlay.autoPlay) {
            return;
        }
        this.playCarousel();
    }
    /**
     * Listener to navigate carousel images with keyboard (left).
     * @return {?}
     */
    onKeyDownLeft() {
        if (!this.configCarousel.keyboardEnable) {
            return;
        }
        this.prevImage();
    }
    /**
     * Listener to navigate carousel images with keyboard (right).
     * @return {?}
     */
    onKeyDownLRight() {
        if (!this.configCarousel.keyboardEnable) {
            return;
        }
        this.nextImage();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        // handle changes of dotsConfig
        /** @type {?} */
        const configDotsChange = changes.dotsConfig;
        if (configDotsChange && configDotsChange.currentValue !== configDotsChange.previousValue) {
            this.configDots = configDotsChange.currentValue;
        }
        // handle changes of carouselConfig
        /** @type {?} */
        const carouselConfigChange = changes.carouselConfig;
        if (carouselConfigChange && carouselConfigChange.currentValue !== carouselConfigChange.previousValue) {
            this.configCarousel = carouselConfigChange.currentValue;
        }
        // handle changes of playConfig starting/stopping the carousel accordingly
        /** @type {?} */
        const playConfigChange = changes.playConfig;
        if (playConfigChange) {
            /** @type {?} */
            const playConfigChangePrev = playConfigChange.previousValue;
            /** @type {?} */
            const playConfigChangeCurr = playConfigChange.currentValue;
            if (playConfigChangePrev !== playConfigChangeCurr) {
                this.configPlay = playConfigChange.currentValue;
                // if autoplay is enabled, and this is not the
                // first change (to prevent multiple starts at the beginning)
                if (playConfigChangeCurr.autoPlay && !playConfigChange.isFirstChange()) {
                    this.start$.next();
                }
                else {
                    this.stopCarousel();
                }
            }
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.currentImage = this.images[0];
        /** @type {?} */
        const defaultDescriptionStyle = {
            bgColor: 'rgba(0, 0, 0, .5)',
            textColor: 'white',
            marginTop: '0px',
            marginBottom: '0px',
            marginLeft: '0px',
            marginRight: '0px'
        };
        /** @type {?} */
        const defaultDescription = {
            strategy: DescriptionStrategy.ALWAYS_HIDDEN,
            imageText: 'Image ',
            numberSeparator: '/',
            beforeTextDescription: ' - ',
            style: defaultDescriptionStyle
        };
        /** @type {?} */
        const defaultCurrentImageConfig = {
            description: defaultDescription,
            invertSwipe: false
        };
        /** @type {?} */
        const defaultCurrentCarouselConfig = {
            maxWidth: '100%',
            maxHeight: '400px',
            showArrows: true,
            objectFit: 'cover',
            keyboardEnable: true,
            modalGalleryEnable: false,
            legacyIE11Mode: false
        };
        /** @type {?} */
        const defaultCurrentCarouselPlay = {
            autoPlay: true,
            interval: 5000,
            pauseOnHover: true
        };
        this.configCurrentImageCarousel = Object.assign({}, defaultCurrentImageConfig, this.carouselImageConfig);
        this.configCurrentImageCarousel.description = Object.assign({}, defaultDescription, this.configCurrentImageCarousel.description);
        /** @type {?} */
        const defaultConfig = { visible: true };
        this.configDots = Object.assign(defaultConfig, this.dotsConfig);
        this.configCarousel = Object.assign({}, defaultCurrentCarouselConfig, this.carouselConfig);
        this.configPlay = Object.assign({}, defaultCurrentCarouselPlay, this.playConfig);
        // check values
        if (this.configPlay.interval <= 0) {
            throw new Error(`Carousel's interval must be a number >= 0`);
        }
        this.manageSlideConfig();
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        // interval doesn't play well with SSR and protractor,
        // so we should run it in the browser and outside Angular
        if (isPlatformBrowser(this._platformId)) {
            this._ngZone.runOutsideAngular((/**
             * @return {?}
             */
            () => {
                this.start$
                    .pipe(map((/**
                 * @return {?}
                 */
                () => this.configPlay.interval)), filter((/**
                 * @param {?} interval
                 * @return {?}
                 */
                interval => interval > 0)), switchMap((/**
                 * @param {?} interval
                 * @return {?}
                 */
                interval => timer(interval).pipe(takeUntil(this.stop$)))))
                    .subscribe((/**
                 * @return {?}
                 */
                () => this._ngZone.run((/**
                 * @return {?}
                 */
                () => {
                    if (this.configPlay.autoPlay) {
                        this.nextImage();
                    }
                    this.ref.markForCheck();
                }))));
                this.start$.next();
            }));
        }
    }
    /**
     * Method used in template to sanitize an url when you need legacyIE11Mode.
     * In this way you can set an url as background of a div.
     * @param {?} unsafeStyle is a string and represents the url to sanitize.
     * @return {?} a SafeStyle object that can be used in template without problems.
     */
    sanitizeUrlBgStyle(unsafeStyle) {
        // Method used only to sanitize background-image style before add it to background property when legacyIE11Mode is enabled
        return this.sanitizer.bypassSecurityTrustStyle('url(' + unsafeStyle + ')');
    }
    /**
     * Method called when a dot is clicked and used to update the current image.
     * @param {?} index
     * @return {?}
     */
    onClickDot(index) {
        this.changeCurrentImage(this.images[index], Action.NORMAL);
    }
    /**
     * Method called by events from both keyboard and mouse on a navigation arrow.
     * @param {?} direction
     * @param {?} event
     * @param {?=} action
     * @return {?}
     */
    onNavigationEvent(direction, event, action = Action.NORMAL) {
        /** @type {?} */
        const result = super.handleNavigationEvent(direction, event);
        if (result === NEXT) {
            this.nextImage(action);
        }
        else if (result === PREV) {
            this.prevImage(action);
        }
    }
    /**
     * Method triggered when you click on the current image.
     * Also, if modalGalleryEnable is true, you can open the modal-gallery.
     * @return {?}
     */
    onClickCurrentImage() {
        if (!this.configCarousel.modalGalleryEnable) {
            return;
        }
        /** @type {?} */
        const index = getIndex(this.currentImage, this.images);
        this.galleryService.openGallery(this.id, index);
    }
    /**
     * Method to get the image description based on input params.
     * If you provide a full description this will be the visible description, otherwise,
     * it will be built using the `Description` object, concatenating its fields.
     * @throws an Error if description isn't available
     * @param {?=} image
     * @return {?} String description of the image (or the current image if not provided)
     */
    getDescriptionToDisplay(image = this.currentImage) {
        if (!this.configCurrentImageCarousel || !this.configCurrentImageCarousel.description) {
            throw new Error('Description input must be a valid object implementing the Description interface');
        }
        /** @type {?} */
        const imageWithoutDescription = !image.modal || !image.modal.description || image.modal.description === '';
        switch (this.configCurrentImageCarousel.description.strategy) {
            case DescriptionStrategy.HIDE_IF_EMPTY:
                return imageWithoutDescription ? '' : image.modal.description + '';
            case DescriptionStrategy.ALWAYS_HIDDEN:
                return '';
            default:
                // ----------- DescriptionStrategy.ALWAYS_VISIBLE -----------------
                return this.buildTextDescription(image, imageWithoutDescription);
        }
    }
    /**
     * Method used by Hammerjs to support touch gestures (you can also invert the swipe direction with configCurrentImage.invertSwipe).
     * @param {?=} action String that represent the direction of the swipe action. 'swiperight' by default.
     * @return {?}
     */
    swipe(action = this.SWIPE_ACTION.RIGHT) {
        switch (action) {
            case this.SWIPE_ACTION.RIGHT:
                if (this.configCurrentImageCarousel.invertSwipe) {
                    this.prevImage(Action.SWIPE);
                }
                else {
                    this.nextImage(Action.SWIPE);
                }
                break;
            case this.SWIPE_ACTION.LEFT:
                if (this.configCurrentImageCarousel.invertSwipe) {
                    this.nextImage(Action.SWIPE);
                }
                else {
                    this.prevImage(Action.SWIPE);
                }
                break;
            // case this.SWIPE_ACTION.UP:
            //   break;
            // case this.SWIPE_ACTION.DOWN:
            //   break;
        }
    }
    /**
     * Method to go back to the previous image.
     * @param {?=} action Enum of type `Action` that represents the source
     *  action that moved back to the previous image. `Action.NORMAL` by default.
     * @return {?}
     */
    prevImage(action = Action.NORMAL) {
        // check if prevImage should be blocked
        if (this.isPreventSliding(0)) {
            return;
        }
        this.changeCurrentImage(this.getPrevImage(), action);
        this.manageSlideConfig();
        this.start$.next();
    }
    /**
     * Method to go back to the previous image.
     * @param {?=} action Enum of type `Action` that represents the source
     *  action that moved to the next image. `Action.NORMAL` by default.
     * @return {?}
     */
    nextImage(action = Action.NORMAL) {
        // check if nextImage should be blocked
        if (this.isPreventSliding(this.images.length - 1)) {
            return;
        }
        this.changeCurrentImage(this.getNextImage(), action);
        this.manageSlideConfig();
        this.start$.next();
    }
    /**
     * Method used in the template to track ids in ngFor.
     * @param {?} index
     * @param {?} item
     * @return {?} number the id of the item
     */
    trackById(index, item) {
        return item.id;
    }
    /**
     * Method called when an image preview is clicked and used to update the current image.
     * @param {?} event an ImageEvent object with the relative action and the index of the clicked preview.
     * @return {?}
     */
    onClickPreview(event) {
        /** @type {?} */
        const imageFound = this.images[(/** @type {?} */ (event.result))];
        if (!!imageFound) {
            this.manageSlideConfig();
            this.changeCurrentImage((/** @type {?} */ (imageFound)), event.action);
        }
    }
    /**
     * Method to play carousel.
     * @return {?}
     */
    playCarousel() {
        this.start$.next();
    }
    /**
     * Stops the carousel from cycling through items.
     * @return {?}
     */
    stopCarousel() {
        this.stop$.next();
    }
    // TODO remove this because duplicated
    /**
     * Method to get `alt attribute`.
     * `alt` specifies an alternate text for an image, if the image cannot be displayed.
     * @param {?=} image
     * @return {?} String alt description of the image (or the current image if not provided)
     */
    getAltDescriptionByImage(image = this.currentImage) {
        if (!image) {
            return '';
        }
        return image.modal && image.modal.description ? image.modal.description : `Image ${getIndex(image, this.images) + 1}`;
    }
    // TODO remove this because duplicated
    /**
     * Method to get the title attributes based on descriptions.
     * This is useful to prevent accessibility issues, because if DescriptionStrategy is ALWAYS_HIDDEN,
     * it prevents an empty string as title.
     * @throws an Error if description isn't available
     * @param {?=} image
     * @return {?} String title of the image based on descriptions
     */
    getTitleToDisplay(image = this.currentImage) {
        if (!this.configCurrentImageCarousel || !this.configCurrentImageCarousel.description) {
            throw new Error('Description input must be a valid object implementing the Description interface');
        }
        /** @type {?} */
        const imageWithoutDescription = !image.modal || !image.modal.description || image.modal.description === '';
        /** @type {?} */
        const description = this.buildTextDescription(image, imageWithoutDescription);
        return description;
    }
    /**
       * Method to reset carousel (force image with index 0 to be the current image and re-init also previews)
       */
    // temporary removed because never tested
    // reset() {
    //   if (this.configPlay && this.configPlay.autoPlay) {
    //     this.stopCarousel();
    //   }
    //   this.currentImage = this.images[0];
    //   this.handleBoundaries(0);
    //   if (this.configPlay && this.configPlay.autoPlay) {
    //     this.playCarousel();
    //   }
    //   this.ref.markForCheck();
    // }
    /**
     * Method to cleanup resources. In fact, this will stop the carousel.
     * This is an Angular's lifecycle hook that is called when this component is destroyed.
     * @return {?}
     */
    ngOnDestroy() {
        this.stopCarousel();
    }
    /**
     * Method to change the current image, receiving the new image as input the relative action.
     * @private
     * @param {?} image an Image object that represents the new image to set as current.
     * @param {?} action Enum of type `Action` that represents the source action that triggered the change.
     * @return {?}
     */
    changeCurrentImage(image, action) {
        this.currentImage = image;
        /** @type {?} */
        const index = getIndex(image, this.images);
        // emit first/last event based on newIndex value
        this.emitBoundaryEvent(action, index);
        // emit current visible image index
        this.show.emit(new ImageModalEvent(action, index + 1));
    }
    /**
     * Private method to get the next index.
     * This is necessary because at the end, when you call next again, you'll go to the first image.
     * That happens because all modal images are shown like in a circle.
     * @private
     * @return {?}
     */
    getNextImage() {
        /** @type {?} */
        const currentIndex = getIndex(this.currentImage, this.images);
        /** @type {?} */
        let newIndex = 0;
        if (currentIndex >= 0 && currentIndex < this.images.length - 1) {
            newIndex = currentIndex + 1;
        }
        else {
            newIndex = 0; // start from the first index
        }
        return this.images[newIndex];
    }
    /**
     * Private method to get the previous index.
     * This is necessary because at index 0, when you call prev again, you'll go to the last image.
     * That happens because all modal images are shown like in a circle.
     * @private
     * @return {?}
     */
    getPrevImage() {
        /** @type {?} */
        const currentIndex = getIndex(this.currentImage, this.images);
        /** @type {?} */
        let newIndex = 0;
        if (currentIndex > 0 && currentIndex <= this.images.length - 1) {
            newIndex = currentIndex - 1;
        }
        else {
            newIndex = this.images.length - 1; // start from the last index
        }
        return this.images[newIndex];
    }
    /**
     * Private method to build a text description.
     * This is used also to create titles.
     * @private
     * @param {?} image
     * @param {?} imageWithoutDescription
     * @return {?} String description built concatenating image fields with a specific logic.
     */
    buildTextDescription(image, imageWithoutDescription) {
        if (!this.configCurrentImageCarousel || !this.configCurrentImageCarousel.description) {
            throw new Error('Description input must be a valid object implementing the Description interface');
        }
        // If customFullDescription use it, otherwise proceed to build a description
        if (this.configCurrentImageCarousel.description.customFullDescription && this.configCurrentImageCarousel.description.customFullDescription !== '') {
            return this.configCurrentImageCarousel.description.customFullDescription;
        }
        /** @type {?} */
        const currentIndex = getIndex(image, this.images);
        // If the current image hasn't a description,
        // prevent to write the ' - ' (or this.description.beforeTextDescription)
        /** @type {?} */
        const prevDescription = this.configCurrentImageCarousel.description.imageText ? this.configCurrentImageCarousel.description.imageText : '';
        /** @type {?} */
        const midSeparator = this.configCurrentImageCarousel.description.numberSeparator
            ? this.configCurrentImageCarousel.description.numberSeparator
            : '';
        /** @type {?} */
        const middleDescription = currentIndex + 1 + midSeparator + this.images.length;
        if (imageWithoutDescription) {
            return prevDescription + middleDescription;
        }
        /** @type {?} */
        const currImgDescription = image.modal && image.modal.description ? image.modal.description : '';
        /** @type {?} */
        const endDescription = this.configCurrentImageCarousel.description.beforeTextDescription + currImgDescription;
        return prevDescription + middleDescription + endDescription;
    }
    /**
     * Private method to update both `isFirstImage` and `isLastImage` based on
     * the index of the current image.
     * @private
     * @param {?} currentIndex
     * @return {?}
     */
    handleBoundaries(currentIndex) {
        if (this.images.length === 1) {
            this.isFirstImage = true;
            this.isLastImage = true;
            return;
        }
        switch (currentIndex) {
            case 0:
                // execute this only if infinite sliding is disabled
                this.isFirstImage = true;
                this.isLastImage = false;
                break;
            case this.images.length - 1:
                // execute this only if infinite sliding is disabled
                this.isFirstImage = false;
                this.isLastImage = true;
                break;
            default:
                this.isFirstImage = false;
                this.isLastImage = false;
                break;
        }
    }
    /**
     * Private method to manage boundary arrows and sliding.
     * This is based on the slideConfig input to enable/disable 'infinite sliding'.
     * @private
     * @return {?}
     */
    manageSlideConfig() {
        /** @type {?} */
        let index;
        try {
            index = getIndex(this.currentImage, this.images);
        }
        catch (err) {
            console.error('Cannot get the current image index in current-image');
            throw err;
        }
        if (this.infinite === true) {
            // enable infinite sliding
            this.isFirstImage = false;
            this.isLastImage = false;
        }
        else {
            this.handleBoundaries(index);
        }
    }
    /**
     * Private method to emit events when either the last or the first image are visible.
     * @private
     * @param {?} action Enum of type Action that represents the source of the event that changed the
     *  current image to the first one or the last one.
     * @param {?} indexToCheck is the index number of the image (the first or the last one).
     * @return {?}
     */
    emitBoundaryEvent(action, indexToCheck) {
        // to emit first/last event
        switch (indexToCheck) {
            case 0:
                this.firstImage.emit(new ImageModalEvent(action, true));
                break;
            case this.images.length - 1:
                this.lastImage.emit(new ImageModalEvent(action, true));
                break;
        }
    }
    /**
     * Private method to check if next/prev actions should be blocked.
     * It checks if slideConfig.infinite === false and if the image index is equals to the input parameter.
     * If yes, it returns true to say that sliding should be blocked, otherwise not.
     * @private
     * @param {?} boundaryIndex
     * @return {?} boolean true if slideConfig.infinite === false and the current index is
     *  either the first or the last one.
     */
    isPreventSliding(boundaryIndex) {
        return !this.infinite && getIndex(this.currentImage, this.images) === boundaryIndex;
    }
}
CarouselComponent.ɵfac = function CarouselComponent_Factory(t) { return new (t || CarouselComponent)(ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(GalleryService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.DomSanitizer)); };
CarouselComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CarouselComponent, selectors: [["ks-carousel"]], hostVars: 1, hostBindings: function CarouselComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mouseenter", function CarouselComponent_mouseenter_HostBindingHandler() { return ctx.onMouseEnter(); })("mouseleave", function CarouselComponent_mouseleave_HostBindingHandler() { return ctx.onMouseLeave(); })("keydown.arrowLeft", function CarouselComponent_keydown_arrowLeft_HostBindingHandler() { return ctx.onKeyDownLeft(); })("keydown.arrowRight", function CarouselComponent_keydown_arrowRight_HostBindingHandler() { return ctx.onKeyDownLRight(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel);
    } }, inputs: { dotsConfig: "dotsConfig", infinite: "infinite", accessibilityConfig: "accessibilityConfig", id: "id", images: "images", carouselConfig: "carouselConfig", playConfig: "playConfig", carouselImageConfig: "carouselImageConfig", previewConfig: "previewConfig" }, outputs: { show: "show", firstImage: "firstImage", lastImage: "lastImage" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c6, decls: 8, vars: 15, consts: [["id", "carousel-container", "ksMaxSize", "", 3, "title", "sizeConfig"], ["content", ""], ["class", "current-figure", "ksSize", "", 3, "sizeConfig", 4, "ngIf", "ngIfElse"], ["legacyMode", ""], [3, "images", "currentImage", "carouselConfig", "previewConfig", "accessibilityConfig", "clickPreview"], [3, "id", "modalImages", "plainGalleryConfig"], ["ksSize", "", 1, "current-figure", 3, "sizeConfig"], ["class", "nav-left", "role", "button", 3, "tabindex", "click", "keyup", 4, "ngIf"], [4, "ngTemplateOutlet"], ["id", "current-image", "ksMaxSize", "", "role", "img", 3, "sizeConfig", "src", "title", "alt", "tabindex", "click", "swipeleft", "swiperight"], ["class", "description", "ksDescription", "", 3, "description", "innerHTML", 4, "ngIf"], ["class", "nav-right", "role", "button", 3, "tabindex", "click", "keyup", 4, "ngIf"], ["id", "dots"], [3, "currentImage", "dotsConfig", "accessibilityConfig", "images", "clickDot"], ["role", "button", 1, "nav-left", 3, "tabindex", "click", "keyup"], ["aria-hidden", "true", 3, "title"], ["ksDescription", "", 1, "description", 3, "description", "innerHTML"], ["role", "button", 1, "nav-right", 3, "tabindex", "click", "keyup"], ["id", "current-image-legacy", "ksSize", "", "ksMaxSize", "", "role", "img", 3, "sizeConfig", "title", "tabindex", "click", "swipeleft", "swiperight"], ["class", "description-ie11", "ksDescription", "", 3, "description", "innerHTML", 4, "ngIf"], ["id", "dots-ie11"], ["ksDescription", "", 1, "description-ie11", 3, "description", "innerHTML"]], template: function CarouselComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "main", 0);
        ɵngcc0.ɵɵtemplate(1, CarouselComponent_ng_template_1_Template, 1, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, CarouselComponent_figure_3_Template, 8, 22, "figure", 2);
        ɵngcc0.ɵɵtemplate(4, CarouselComponent_ng_template_4_Template, 8, 32, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "ks-carousel-previews", 4);
        ɵngcc0.ɵɵlistener("clickPreview", function CarouselComponent_Template_ks_carousel_previews_clickPreview_6_listener($event) { return ctx.onClickPreview($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(7, "ks-modal-gallery", 5);
    } if (rf & 2) {
        const _r3 = ɵngcc0.ɵɵreference(5);
        ɵngcc0.ɵɵproperty("title", ctx.accessibilityConfig.carouselContainerTitle)("sizeConfig", ɵngcc0.ɵɵpureFunction1(13, _c5, ctx.configCarousel == null ? null : ctx.configCarousel.maxWidth));
        ɵngcc0.ɵɵattribute("aria-label", ctx.accessibilityConfig.carouselContainerAriaLabel);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.configCarousel == null ? null : ctx.configCarousel.legacyIE11Mode) === false)("ngIfElse", _r3);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("images", ctx.images)("currentImage", ctx.currentImage)("carouselConfig", ctx.configCarousel)("previewConfig", ctx.previewConfig)("accessibilityConfig", ctx.accessibilityConfig);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.id)("modalImages", ctx.images)("plainGalleryConfig", ctx.plainGalleryHidden);
    } }, directives: function () { return [MaxSizeDirective, ɵngcc1.NgIf, CarouselPreviewsComponent, ModalGalleryComponent, SizeDirective, ɵngcc1.NgTemplateOutlet, DotsComponent, DescriptionDirective]; }, styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;justify-content:flex-start;align-items:center}#carousel-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;justify-content:space-between;width:100%}#carousel-container[_ngcontent-%COMP%] > .current-figure[_ngcontent-%COMP%]{-webkit-animation:.8s fadein-visible;animation:.8s fadein-visible;text-align:center;margin:0;position:relative}#carousel-container[_ngcontent-%COMP%] > .current-figure[_ngcontent-%COMP%]   .nav[_ngcontent-%COMP%], #carousel-container[_ngcontent-%COMP%] > .current-figure[_ngcontent-%COMP%] > .nav-left[_ngcontent-%COMP%], #carousel-container[_ngcontent-%COMP%] > .current-figure[_ngcontent-%COMP%] > .nav-right[_ngcontent-%COMP%]{-webkit-animation:1s animatezoom;animation:1s animatezoom;cursor:pointer;transition:.5s;top:50%;position:absolute}#carousel-container[_ngcontent-%COMP%] > .current-figure[_ngcontent-%COMP%]   .nav[_ngcontent-%COMP%]:hover, #carousel-container[_ngcontent-%COMP%] > .current-figure[_ngcontent-%COMP%] > .nav-left[_ngcontent-%COMP%]:hover, #carousel-container[_ngcontent-%COMP%] > .current-figure[_ngcontent-%COMP%] > .nav-right[_ngcontent-%COMP%]:hover{transform:scale(1.1)}#carousel-container[_ngcontent-%COMP%] > .current-figure[_ngcontent-%COMP%] > .nav-left[_ngcontent-%COMP%]{left:5px}#carousel-container[_ngcontent-%COMP%] > .current-figure[_ngcontent-%COMP%] > .nav-right[_ngcontent-%COMP%]{right:5px}#carousel-container[_ngcontent-%COMP%] > .current-figure[_ngcontent-%COMP%] > #current-image[_ngcontent-%COMP%], #carousel-container[_ngcontent-%COMP%] > .current-figure[_ngcontent-%COMP%] > #current-image-legacy[_ngcontent-%COMP%]{width:100%;height:auto;display:block}#carousel-container[_ngcontent-%COMP%] > .current-figure[_ngcontent-%COMP%] > #current-image-legacy[_ngcontent-%COMP%] > .description-ie11[_ngcontent-%COMP%]{bottom:0;width:100%;position:absolute;padding-top:10px;padding-bottom:10px}#carousel-container[_ngcontent-%COMP%] > .current-figure[_ngcontent-%COMP%] > figcaption[_ngcontent-%COMP%]{padding:10px;position:absolute;bottom:0;left:0;right:0}#carousel-container[_ngcontent-%COMP%] > .current-figure[_ngcontent-%COMP%] > figcaption[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{font-weight:700;text-align:center}#carousel-container[_ngcontent-%COMP%] > .current-figure[_ngcontent-%COMP%] > #dots[_ngcontent-%COMP%], #carousel-container[_ngcontent-%COMP%] > .current-figure[_ngcontent-%COMP%] > #dots-ie11[_ngcontent-%COMP%]{position:absolute;bottom:20px;width:100%}", _c7], changeDetection: 0 });
/** @nocollapse */
CarouselComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: NgZone },
    { type: GalleryService },
    { type: ChangeDetectorRef },
    { type: DomSanitizer }
];
CarouselComponent.propDecorators = {
    ariaLabel: [{ type: HostBinding, args: ['attr.aria-label',] }],
    id: [{ type: Input }],
    images: [{ type: Input }],
    carouselConfig: [{ type: Input }],
    playConfig: [{ type: Input }],
    carouselImageConfig: [{ type: Input }],
    dotsConfig: [{ type: Input }],
    previewConfig: [{ type: Input }],
    infinite: [{ type: Input }],
    accessibilityConfig: [{ type: Input }],
    show: [{ type: Output }],
    firstImage: [{ type: Output }],
    lastImage: [{ type: Output }],
    onMouseEnter: [{ type: HostListener, args: ['mouseenter',] }],
    onMouseLeave: [{ type: HostListener, args: ['mouseleave',] }],
    onKeyDownLeft: [{ type: HostListener, args: ['keydown.arrowLeft',] }],
    onKeyDownLRight: [{ type: HostListener, args: ['keydown.arrowRight',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CarouselComponent, [{
        type: Component,
        args: [{
                selector: 'ks-carousel',
                template: "<main id=\"carousel-container\"\n      [attr.aria-label]=\"accessibilityConfig.carouselContainerAriaLabel\"\n      [title]=\"accessibilityConfig.carouselContainerTitle\"\n      ksMaxSize [sizeConfig]=\"{maxWidth: configCarousel?.maxWidth,\n                               maxHeight: ''}\">\n\n\n  <!-- Workaround to support 2 ng-content in the same template in 2 ngIf (https://github.com/angular/angular/issues/22972) -->\n  <ng-template #content><ng-content></ng-content></ng-template>\n\n  <!-- Normal figure used by all browsers except for IE11, because\n    it doesn't support object-fit cover.-->\n  <figure class=\"current-figure\" *ngIf=\"configCarousel?.legacyIE11Mode === false; else legacyMode\"\n          ksSize [sizeConfig]=\"{width: configCarousel?.maxWidth,\n                                height: ''}\">\n\n    <a class=\"nav-left\" *ngIf=\"configCarousel?.showArrows\"\n       [attr.aria-label]=\"accessibilityConfig.carouselPrevImageAriaLabel\"\n       [tabindex]=\"isLastImage && !infinite ? -1 : 0\" role=\"button\"\n       (click)=\"onNavigationEvent('left', $event, clickAction)\" (keyup)=\"onNavigationEvent('left', $event, keyboardAction)\">\n      <div class=\"inside {{(isFirstImage && !infinite) || !configCarousel.showArrows ? 'empty-arrow-image' : 'left-arrow-image'}}\"\n           aria-hidden=\"true\"\n           [title]=\"accessibilityConfig.carouselPrevImageTitle\"></div>\n    </a>\n\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n\n    <img id=\"current-image\"\n         [style.object-fit]=\"configCarousel?.objectFit\"\n         ksMaxSize [sizeConfig]=\"{maxWidth: configCarousel?.maxWidth,\n                                  maxHeight: configCarousel?.maxHeight}\"\n         [src]=\"currentImage.modal.img\"\n         [attr.aria-label]=\"currentImage.modal.ariaLabel\"\n         [title]=\"currentImage.modal.title ? currentImage.modal.title : getTitleToDisplay()\"\n         alt=\"{{currentImage.modal.alt ? currentImage.modal.alt : getAltDescriptionByImage()}}\"\n         [tabindex]=\"0\" role=\"img\"\n         (click)=\"onClickCurrentImage()\"\n         (swipeleft)=\"swipe($event.type)\"\n         (swiperight)=\"swipe($event.type)\"/>\n\n    <figcaption *ngIf=\"getDescriptionToDisplay() !== ''\"\n                class=\"description\"\n                ksDescription [description]=\"configCurrentImageCarousel?.description\"\n                [innerHTML]=\"getDescriptionToDisplay()\"></figcaption>\n\n    <a class=\"nav-right\" *ngIf=\"configCarousel?.showArrows\"\n       [attr.aria-label]=\"accessibilityConfig.carouselNextImageAriaLabel\"\n       [tabindex]=\"isLastImage && !infinite ? -1 : 0\" role=\"button\"\n       (click)=\"onNavigationEvent('right', $event, clickAction)\" (keyup)=\"onNavigationEvent('right', $event, keyboardAction)\">\n      <div class=\"inside {{(isLastImage && !infinite) || !configCarousel.showArrows ? 'empty-arrow-image' : 'right-arrow-image'}}\"\n           aria-hidden=\"true\"\n           [title]=\"accessibilityConfig.carouselNextImageTitle\"></div>\n    </a>\n\n    <div id=\"dots\">\n      <ks-dots [currentImage]=\"currentImage\"\n               [dotsConfig]=\"configDots\"\n               [accessibilityConfig]=\"accessibilityConfig\"\n               [images]=\"images\"\n               (clickDot)=\"onClickDot($event)\"></ks-dots>\n    </div>\n\n  </figure>\n\n  <!-- Legacy mode to support img cover also on IE11,\n    because it doesn't support natively object-fit cover. -->\n  <ng-template #legacyMode>\n    <div class=\"current-figure\"\n         ksSize [sizeConfig]=\"{width: configCarousel?.maxWidth,\n                               height: ''}\">\n\n      <a class=\"nav-left\" *ngIf=\"configCarousel?.showArrows\"\n         [attr.aria-label]=\"accessibilityConfig.carouselPrevImageAriaLabel\"\n         [tabindex]=\"isLastImage && !infinite ? -1 : 0\" role=\"button\"\n         (click)=\"onNavigationEvent('left', $event, clickAction)\" (keyup)=\"onNavigationEvent('left', $event, keyboardAction)\">\n        <div class=\"inside {{(isFirstImage && !infinite) || !configCarousel.showArrows ? 'empty-arrow-image' : 'left-arrow-image'}}\"\n             aria-hidden=\"true\"\n             [title]=\"accessibilityConfig.carouselPrevImageTitle\"></div>\n      </a>\n\n      <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n\n      <div id=\"current-image-legacy\"\n           [style.background-color]=\"'transparent'\"\n           [style.background-image]=\"sanitizeUrlBgStyle(currentImage.modal.img + '')\"\n           [style.background-position]=\"'center center'\"\n           [style.background-size]=\"'cover'\"\n           [style.background-repeat]=\"'no-repeat'\"\n           [style.background-attachment]=\"'scroll'\"\n           ksSize [sizeConfig]=\"{width: '100%',\n                                 height: configCarousel?.maxHeight}\"\n           ksMaxSize [sizeConfig]=\"{maxWidth: configCarousel?.maxWidth}\"\n           [attr.aria-label]=\"currentImage.modal.ariaLabel\"\n           [title]=\"currentImage.modal.title ? currentImage.modal.title : getTitleToDisplay()\"\n           [tabindex]=\"0\" role=\"img\"\n           (click)=\"onClickCurrentImage()\"\n           (swipeleft)=\"swipe($event.type)\"\n           (swiperight)=\"swipe($event.type)\">\n\n        <div *ngIf=\"getDescriptionToDisplay() !== ''\"\n             class=\"description-ie11\"\n             ksDescription [description]=\"configCurrentImageCarousel?.description\"\n             [innerHTML]=\"getDescriptionToDisplay()\"></div>\n      </div>\n\n      <a class=\"nav-right\" *ngIf=\"configCarousel?.showArrows\"\n         [attr.aria-label]=\"accessibilityConfig.carouselNextImageAriaLabel\"\n         [tabindex]=\"isLastImage && !infinite ? -1 : 0\" role=\"button\"\n         (click)=\"onNavigationEvent('right', $event, clickAction)\" (keyup)=\"onNavigationEvent('right', $event, keyboardAction)\">\n        <div class=\"inside {{(isLastImage && !infinite) || !configCarousel.showArrows ? 'empty-arrow-image' : 'right-arrow-image'}}\"\n             aria-hidden=\"true\"\n             [title]=\"accessibilityConfig.carouselNextImageTitle\"></div>\n      </a>\n\n      <div id=\"dots-ie11\">\n        <ks-dots [currentImage]=\"currentImage\"\n                 [dotsConfig]=\"configDots\"\n                 [accessibilityConfig]=\"accessibilityConfig\"\n                 [images]=\"images\"\n                 (clickDot)=\"onClickDot($event)\"></ks-dots>\n      </div>\n\n    </div>\n  </ng-template>\n\n</main>\n\n<ks-carousel-previews [images]=\"images\"\n                      [currentImage]=\"currentImage\"\n                      [carouselConfig]=\"configCarousel\"\n                      [previewConfig]=\"previewConfig\"\n                      [accessibilityConfig]=\"accessibilityConfig\"\n                      (clickPreview)=\"onClickPreview($event)\"></ks-carousel-previews>\n\n<ks-modal-gallery [id]=\"id\" [modalImages]=\"images\" [plainGalleryConfig]=\"plainGalleryHidden\"></ks-modal-gallery>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:flex;flex-direction:column;justify-content:flex-start;align-items:center}#carousel-container{display:flex;flex-direction:row;align-items:center;justify-content:space-between;width:100%}#carousel-container>.current-figure{-webkit-animation:.8s fadein-visible;animation:.8s fadein-visible;text-align:center;margin:0;position:relative}#carousel-container>.current-figure .nav,#carousel-container>.current-figure>.nav-left,#carousel-container>.current-figure>.nav-right{-webkit-animation:1s animatezoom;animation:1s animatezoom;cursor:pointer;transition:.5s;top:50%;position:absolute}#carousel-container>.current-figure .nav:hover,#carousel-container>.current-figure>.nav-left:hover,#carousel-container>.current-figure>.nav-right:hover{transform:scale(1.1)}#carousel-container>.current-figure>.nav-left{left:5px}#carousel-container>.current-figure>.nav-right{right:5px}#carousel-container>.current-figure>#current-image,#carousel-container>.current-figure>#current-image-legacy{width:100%;height:auto;display:block}#carousel-container>.current-figure>#current-image-legacy>.description-ie11{bottom:0;width:100%;position:absolute;padding-top:10px;padding-bottom:10px}#carousel-container>.current-figure>figcaption{padding:10px;position:absolute;bottom:0;left:0;right:0}#carousel-container>.current-figure>figcaption .description{font-weight:700;text-align:center}#carousel-container>.current-figure>#dots,#carousel-container>.current-figure>#dots-ie11{position:absolute;bottom:20px;width:100%}", ".arrow-image,.empty-arrow-image,.left-arrow-image,.right-arrow-image{width:30px;height:30px;background-size:30px}.empty-arrow-image{background:#000;opacity:0}.left-arrow-image{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3Ny4xNzUgNDc3LjE3NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDc3LjE3NSA0NzcuMTc1OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij48Zz48cGF0aCBkPSJNMTQ1LjE4OCwyMzguNTc1bDIxNS41LTIxNS41YzUuMy01LjMsNS4zLTEzLjgsMC0xOS4xcy0xMy44LTUuMy0xOS4xLDBsLTIyNS4xLDIyNS4xYy01LjMsNS4zLTUuMywxMy44LDAsMTkuMWwyMjUuMSwyMjUgICBjMi42LDIuNiw2LjEsNCw5LjUsNHM2LjktMS4zLDkuNS00YzUuMy01LjMsNS4zLTEzLjgsMC0xOS4xTDE0NS4xODgsMjM4LjU3NXoiIGZpbGw9IiNGRkZGRkYiLz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+);opacity:.8;transition:.5s}.left-arrow-image:hover{transform:scale(1.2)}.right-arrow-image{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3Ny4xNzUgNDc3LjE3NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDc3LjE3NSA0NzcuMTc1OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij48Zz48cGF0aCBkPSJNMzYwLjczMSwyMjkuMDc1bC0yMjUuMS0yMjUuMWMtNS4zLTUuMy0xMy44LTUuMy0xOS4xLDBzLTUuMywxMy44LDAsMTkuMWwyMTUuNSwyMTUuNWwtMjE1LjUsMjE1LjUgICBjLTUuMyw1LjMtNS4zLDEzLjgsMCwxOS4xYzIuNiwyLjYsNi4xLDQsOS41LDRjMy40LDAsNi45LTEuMyw5LjUtNGwyMjUuMS0yMjUuMUMzNjUuOTMxLDI0Mi44NzUsMzY1LjkzMSwyMzQuMjc1LDM2MC43MzEsMjI5LjA3NXogICAiIGZpbGw9IiNGRkZGRkYiLz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+);opacity:.8;transition:.5s}.right-arrow-image:hover{transform:scale(1.2)}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: ɵngcc0.NgZone }, { type: GalleryService }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc2.DomSanitizer }]; }, { ariaLabel: [{
            type: HostBinding,
            args: ['attr.aria-label']
        }], dotsConfig: [{
            type: Input
        }], infinite: [{
            type: Input
        }], accessibilityConfig: [{
            type: Input
        }], show: [{
            type: Output
        }], firstImage: [{
            type: Output
        }], lastImage: [{
            type: Output
        }], 
    /**
     * Listener to stop the gallery when the mouse pointer is over the current image.
     * @return {?}
     */
    onMouseEnter: [{
            type: HostListener,
            args: ['mouseenter']
        }], 
    /**
     * Listener to play the gallery when the mouse pointer leave the current image.
     * @return {?}
     */
    onMouseLeave: [{
            type: HostListener,
            args: ['mouseleave']
        }], 
    /**
     * Listener to navigate carousel images with keyboard (left).
     * @return {?}
     */
    onKeyDownLeft: [{
            type: HostListener,
            args: ['keydown.arrowLeft']
        }], 
    /**
     * Listener to navigate carousel images with keyboard (right).
     * @return {?}
     */
    onKeyDownLRight: [{
            type: HostListener,
            args: ['keydown.arrowRight']
        }], id: [{
            type: Input
        }], images: [{
            type: Input
        }], carouselConfig: [{
            type: Input
        }], playConfig: [{
            type: Input
        }], carouselImageConfig: [{
            type: Input
        }], previewConfig: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Component with image previews for carousel
 */
class CarouselPreviewsComponent extends AccessibleComponent {
    /**
     * @param {?} ref
     * @param {?} breakpointObserver
     * @param {?} sanitizer
     */
    constructor(ref, breakpointObserver, sanitizer) {
        super();
        this.ref = ref;
        this.breakpointObserver = breakpointObserver;
        this.sanitizer = sanitizer;
        /**
         * Variable to change the max-width of the host component
         */
        this.hostMaxWidth = '100%';
        /**
         * Variable to set aria-label of the host component
         */
        this.ariaLabel = `Carousel previews`;
        /**
         * Output to emit the clicked preview. The payload contains the `InternalLibImage` associated to the clicked preview.
         */
        this.clickPreview = new EventEmitter();
        /**
         * Enum of type `Action` that represents a mouse click on a button.
         * Declared here to be used inside the template.
         */
        this.clickAction = Action.CLICK;
        /**
         * Enum of type `Action` that represents a keyboard action.
         * Declared here to be used inside the template.
         */
        this.keyboardAction = Action.KEYBOARD;
        /**
         * Array of `InternalLibImage` exposed to the template. This field is initialized
         * applying transformations, default values and so on to the input of the same type.
         */
        this.previews = [];
        /**
         * Private property with the default max height of previews.
         */
        this.defaultMaxHeight = '200px';
        // listen for width changes and update preview heights accordingly
        this.breakpointSubscription = breakpointObserver
            .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
            .subscribe((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            if (!this.configPreview) {
                return;
            }
            if (result.breakpoints[Breakpoints.XSmall]) {
                this.updateHeight(this.configPreview.breakpoints.xSmall);
            }
            else if (result.breakpoints[Breakpoints.Small]) {
                this.updateHeight(this.configPreview.breakpoints.small);
            }
            else if (result.breakpoints[Breakpoints.Medium]) {
                this.updateHeight(this.configPreview.breakpoints.medium);
            }
            else if (result.breakpoints[Breakpoints.Large]) {
                this.updateHeight(this.configPreview.breakpoints.large);
            }
            else if (result.breakpoints[Breakpoints.XLarge]) {
                this.updateHeight(this.configPreview.breakpoints.xLarge);
            }
        }));
    }
    /**
     * Method to update the height of previews, passing the desired height as input.
     * @private
     * @param {?} configBreakpointHeight is a number that represent the desired height to set.
     * @return {?}
     */
    updateHeight(configBreakpointHeight) {
        /** @type {?} */
        const newConfigPreview = Object.assign({}, this.configPreview);
        if (this.previewConfig && this.previewConfig.maxHeight) {
            /** @type {?} */
            const heightNum = +this.previewConfig.maxHeight.replace('px', '').replace('%', '');
            newConfigPreview.maxHeight = Math.min(configBreakpointHeight, heightNum) + 'px';
        }
        else {
            /** @type {?} */
            const heightNum = +this.defaultMaxHeight.replace('px', '').replace('%', '');
            newConfigPreview.maxHeight = Math.min(configBreakpointHeight, heightNum) + 'px';
        }
        this.configPreview = newConfigPreview;
        this.ref.markForCheck();
    }
    /**
     * Method ´ngOnInit´ to build `configPreview` applying a default value and also to
     * init the `previews` array.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called only one time!!!
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        const defaultBreakpoints = { xSmall: 100, small: 100, medium: 150, large: 200, xLarge: 200 };
        /** @type {?} */
        const defaultPreviewConfig = {
            visible: true,
            number: 4,
            arrows: true,
            clickable: true,
            width: 100 / 4 + '%',
            maxHeight: this.defaultMaxHeight,
            breakpoints: defaultBreakpoints
        };
        this.configPreview = Object.assign({}, defaultPreviewConfig, this.previewConfig);
        // if number is <= 0 reset to default
        if (this.configPreview && this.configPreview.number <= 0) {
            this.configPreview.number = defaultPreviewConfig.number;
        }
        // Init preview image width based on the number of previews in PreviewConfig
        // Don't move this line above, because I need to be sure that both configPreview.number
        // and configPreview.size are initialized
        this.configPreview.width = 100 / this.configPreview.number + '%';
        // change the max-width of this component if there is a specified width !== 100% in carouselConfig
        if (this.carouselConfig && this.carouselConfig.maxWidth !== '100%') {
            this.hostMaxWidth = this.carouselConfig.maxWidth;
        }
        // init previews based on currentImage and the full array of images
        this.initPreviews(this.currentImage, this.images);
        // apply custom height based on responsive breakpoints
        // This is required, because the breakpointSubscription is not triggered at creation,
        // but only when the width changes
        /** @type {?} */
        const isXsmallScreen = this.breakpointObserver.isMatched(Breakpoints.XSmall);
        /** @type {?} */
        const isSmallScreen = this.breakpointObserver.isMatched(Breakpoints.Small);
        /** @type {?} */
        const isMediumScreen = this.breakpointObserver.isMatched(Breakpoints.Medium);
        /** @type {?} */
        const isLargeScreen = this.breakpointObserver.isMatched(Breakpoints.Large);
        /** @type {?} */
        const isxLargeScreen = this.breakpointObserver.isMatched(Breakpoints.XLarge);
        if (isXsmallScreen) {
            this.updateHeight(this.configPreview.breakpoints.xSmall);
        }
        else if (isSmallScreen) {
            this.updateHeight(this.configPreview.breakpoints.small);
        }
        else if (isMediumScreen) {
            this.updateHeight(this.configPreview.breakpoints.medium);
        }
        else if (isLargeScreen) {
            this.updateHeight(this.configPreview.breakpoints.large);
        }
        else if (isxLargeScreen) {
            this.updateHeight(this.configPreview.breakpoints.xLarge);
        }
    }
    /**
     * Method to check if an image is active (i.e. a preview image).
     * @param {?} preview
     * @return {?} boolean true if is active, false otherwise
     */
    isActive(preview) {
        if (!preview || !this.currentImage) {
            return false;
        }
        return preview.id === this.currentImage.id;
    }
    /**
     * Method ´ngOnChanges´ to update `previews` array.
     * Also, both `start` and `end` local variables will be updated accordingly.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called when any data-bound property of a directive changes!!!
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        /** @type {?} */
        const simpleChange = changes.currentImage;
        if (!simpleChange) {
            return;
        }
        /** @type {?} */
        const prev = simpleChange.previousValue;
        /** @type {?} */
        const current = simpleChange.currentValue;
        if (current && changes.images && changes.images.previousValue && changes.images.currentValue) {
            // I'm in this if statement, if input images are changed (for instance, because I removed one of them with the 'delete button',
            // or because users changed the images array while modal gallery is still open).
            // In this case, I have to re-init previews, because the input array of images is changed.
            this.initPreviews(current, changes.images.currentValue);
        }
        if (prev && current && prev.id !== current.id) {
            // to manage infinite sliding I have to reset both `start` and `end` at the beginning
            // to show again previews from the first image.
            // This happens when you navigate over the last image to return to the first one
            /** @type {?} */
            let prevIndex;
            /** @type {?} */
            let currentIndex;
            try {
                prevIndex = getIndex(prev, this.images);
                currentIndex = getIndex(current, this.images);
            }
            catch (err) {
                console.error('Cannot get previous and current image indexes in previews');
                throw err;
            }
            // apply a formula to get a values to be used to decide if go next, return back or stay without doing anything
            /** @type {?} */
            const calc = Math.floor((this.end - this.start) / 2) + this.start;
            if (prevIndex === this.images.length - 1 && currentIndex === 0) {
                // first image
                this.setBeginningIndexesPreviews();
                this.previews = this.images.filter((/**
                 * @param {?} img
                 * @param {?} i
                 * @return {?}
                 */
                (img, i) => i >= this.start && i < this.end));
                return;
            }
            // the same for the opposite case, when you navigate back from the fist image to go to the last one.
            if (prevIndex === 0 && currentIndex === this.images.length - 1) {
                // last image
                this.setEndIndexesPreviews();
                this.previews = this.images.filter((/**
                 * @param {?} img
                 * @param {?} i
                 * @return {?}
                 */
                (img, i) => i >= this.start && i < this.end));
                return;
            }
            if (this.configPreview.number % 2 === 0) {
                if (calc > currentIndex) {
                    this.previous();
                }
                else {
                    this.next();
                }
            }
            else {
                if (calc > currentIndex) {
                    this.previous();
                }
                if (calc < currentIndex) {
                    this.next();
                }
            }
        }
    }
    /**
     * Method called by events from both keyboard and mouse on a preview.
     * This will trigger the `clickpreview` output with the input preview as its payload.
     * @param {?} preview
     * @param {?} event
     * @param {?=} action
     * @return {?}
     */
    onImageEvent(preview, event, action = Action.NORMAL) {
        if (!this.configPreview || !this.configPreview.clickable) {
            return;
        }
        /** @type {?} */
        const clickedImageIndex = this.images.indexOf(preview);
        /** @type {?} */
        const result = super.handleImageEvent(event);
        if (result === NEXT) {
            this.clickPreview.emit((/** @type {?} */ ({ action: action, result: clickedImageIndex })));
        }
        else if (result === PREV) {
            this.clickPreview.emit((/** @type {?} */ ({ action: action, result: clickedImageIndex })));
        }
    }
    /**
     * Method called by events from both keyboard and mouse on a navigation arrow.
     * @param {?} direction
     * @param {?} event
     * @return {?}
     */
    onNavigationEvent(direction, event) {
        /** @type {?} */
        const result = super.handleNavigationEvent(direction, event);
        if (result === NEXT) {
            this.next();
        }
        else if (result === PREV) {
            this.previous();
        }
    }
    /**
     * Method to get aria-label text for a preview image.
     * @param {?} preview
     * @return {?}
     */
    getAriaLabel(preview) {
        if (!preview.plain) {
            return preview.modal.ariaLabel || '';
        }
        return preview.plain.ariaLabel || preview.modal.ariaLabel || '';
    }
    /**
     * Method to get title text for a preview image.
     * @param {?} preview
     * @return {?}
     */
    getTitle(preview) {
        if (!preview.plain) {
            return preview.modal.title || '';
        }
        return preview.plain.title || preview.modal.title || '';
    }
    /**
     * Method to get alt text for a preview image.
     * @param {?} preview
     * @return {?}
     */
    getAlt(preview) {
        if (!preview.plain) {
            return preview.modal.alt || '';
        }
        return preview.plain.alt || preview.modal.alt || '';
    }
    /**
     * Method used in the template to track ids in ngFor.
     * @param {?} index
     * @param {?} item
     * @return {?} number the id of the item
     */
    trackById(index, item) {
        return item.id;
    }
    /**
     * Method used in template to sanitize an url when you need legacyIE11Mode.
     * In this way you can set an url as background of a div.
     * @param {?} unsafeStyle is a string and represents the url to sanitize.
     * @return {?} a SafeStyle object that can be used in template without problems.
     */
    sanitizeUrlBgStyle(unsafeStyle) {
        // Method used only to sanitize background-image style before add it to background property when legacyIE11Mode is enabled
        return this.sanitizer.bypassSecurityTrustStyle('url(' + unsafeStyle + ')');
    }
    /**
     * Method to get the background-size value when IE11LegacyMode is enabled.
     * This prevent weired behaviour on IE11 when previews are really small, but original images (.png/.jgp/...) are big.
     * Using 'cover' it's not enough, because it's causing empty background in some cases.
     * After some experiments, I decided to use the double of the height and auto as width.
     * @return {?}
     */
    getIE11LegacyBgSize() {
        if (this.configPreview && this.configPreview.maxHeight) {
            /** @type {?} */
            const bgHeight = +this.configPreview.maxHeight.replace('px', '');
            return '100% ' + bgHeight * 2 + 'px';
        }
        return 'cover';
    }
    /**
     * Method to cleanup resources. In fact, it cleans breakpointSubscription.
     * This is an Angular's lifecycle hook that is called when this component is destroyed.
     * @return {?}
     */
    ngOnDestroy() {
        if (this.breakpointSubscription) {
            this.breakpointSubscription.unsubscribe();
        }
    }
    /**
     * Private method to init previews based on the currentImage and the full array of images.
     * The current image in mandatory to show always the current preview (as highlighted).
     * @private
     * @param {?} currentImage
     * @param {?} images
     * @return {?}
     */
    initPreviews(currentImage, images) {
        /** @type {?} */
        let index;
        try {
            index = getIndex(currentImage, images);
        }
        catch (err) {
            throw err;
        }
        switch (index) {
            case 0:
                // first image
                this.setBeginningIndexesPreviews();
                break;
            case images.length - 1:
                // last image
                this.setEndIndexesPreviews();
                break;
            // default:
            //   // other images
            //   // TODO unused because it starts always at image 0
            //   this.setIndexesPreviews();
            //   break;
        }
        this.previews = images.filter((/**
         * @param {?} img
         * @param {?} i
         * @return {?}
         */
        (img, i) => i >= this.start && i < this.end));
    }
    /**
     * Private method to init both `start` and `end` to the beginning.
     * @private
     * @return {?}
     */
    setBeginningIndexesPreviews() {
        this.start = 0;
        this.end = Math.min((/** @type {?} */ (this.configPreview.number)), this.images.length);
    }
    /**
     * Private method to init both `start` and `end` to the end.
     * @private
     * @return {?}
     */
    setEndIndexesPreviews() {
        this.start = this.images.length - 1 - ((/** @type {?} */ (this.configPreview.number)) - 1);
        this.end = this.images.length;
    }
    /**
     * Private method to update the visible previews navigating to the right (next).
     * @private
     * @return {?}
     */
    next() {
        // check if nextImage should be blocked
        if (this.isPreventSliding(this.images.length - 1)) {
            return;
        }
        if (this.end === this.images.length) {
            return;
        }
        this.start++;
        this.end = Math.min(this.end + 1, this.images.length);
        this.previews = this.images.filter((/**
         * @param {?} img
         * @param {?} i
         * @return {?}
         */
        (img, i) => i >= this.start && i < this.end));
    }
    /**
     * Private method to update the visible previews navigating to the left (previous).
     * @private
     * @return {?}
     */
    previous() {
        // check if prevImage should be blocked
        if (this.isPreventSliding(0)) {
            return;
        }
        if (this.start === 0) {
            return;
        }
        this.start = Math.max(this.start - 1, 0);
        this.end = Math.min(this.end - 1, this.images.length);
        this.previews = this.images.filter((/**
         * @param {?} img
         * @param {?} i
         * @return {?}
         */
        (img, i) => i >= this.start && i < this.end));
    }
    /**
     * Private method to block/permit sliding between previews.
     * @private
     * @param {?} boundaryIndex
     * @return {?} boolean if true block sliding, otherwise not
     */
    isPreventSliding(boundaryIndex) {
        return getIndex(this.currentImage, this.images) === boundaryIndex;
    }
}
CarouselPreviewsComponent.ɵfac = function CarouselPreviewsComponent_Factory(t) { return new (t || CarouselPreviewsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.BreakpointObserver), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.DomSanitizer)); };
CarouselPreviewsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CarouselPreviewsComponent, selectors: [["ks-carousel-previews"]], hostVars: 3, hostBindings: function CarouselPreviewsComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel);
        ɵngcc0.ɵɵstyleProp("max-width", ctx.hostMaxWidth);
    } }, inputs: { carouselConfig: "carouselConfig", currentImage: "currentImage", images: "images", previewConfig: "previewConfig", accessibilityConfig: "accessibilityConfig" }, outputs: { clickPreview: "clickPreview" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "previews-container", 3, "title", 4, "ngIf"], [1, "previews-container", 3, "title"], ["role", "button", 1, "nav-left", 3, "tabindex", "click", "keyup"], ["aria-hidden", "true", 3, "title"], [1, "preview-inner-container"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["role", "button", 1, "nav-right", 3, "tabindex", "click", "keyup"], [4, "ngIf", "ngIfElse"], ["legacyMode", ""], ["ksSize", "", "role", "img", 3, "class", "src", "sizeConfig", "title", "alt", "tabindex", "click", "keyup", 4, "ngIf"], ["ksSize", "", "role", "img", 3, "src", "sizeConfig", "title", "alt", "tabindex", "click", "keyup"], ["ksSize", "", "role", "img", 3, "class", "background-color", "background-image", "background-position", "background-size", "background-repeat", "background-attachment", "sizeConfig", "title", "tabindex", "click", "keyup", 4, "ngIf"], ["ksSize", "", "role", "img", 3, "sizeConfig", "title", "tabindex", "click", "keyup"]], template: function CarouselPreviewsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CarouselPreviewsComponent_nav_0_Template, 7, 16, "nav", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.configPreview == null ? null : ctx.configPreview.visible);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, SizeDirective], styles: ["[_nghost-%COMP%]{position:relative;margin-top:3px;margin-bottom:3px;width:100%}.previews-container[_ngcontent-%COMP%]{align-items:center;-webkit-animation:.8s fadein-semi-visible08;animation:.8s fadein-semi-visible08;display:flex;flex-direction:row;justify-content:center;margin-bottom:0}.previews-container[_ngcontent-%COMP%] > .preview-inner-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:center;align-items:center;flex-wrap:nowrap;width:100%}.previews-container[_ngcontent-%COMP%] > .preview-inner-container[_ngcontent-%COMP%] > .preview-image[_ngcontent-%COMP%]{cursor:pointer;-o-object-fit:cover;object-fit:cover}.previews-container[_ngcontent-%COMP%] > .preview-inner-container[_ngcontent-%COMP%] > .preview-image.unclickable[_ngcontent-%COMP%]{cursor:not-allowed}.previews-container[_ngcontent-%COMP%] > .preview-inner-container[_ngcontent-%COMP%] > .preview-ie11-image[_ngcontent-%COMP%]{cursor:pointer}.previews-container[_ngcontent-%COMP%] > .preview-inner-container[_ngcontent-%COMP%] > .preview-ie11-image.unclickable[_ngcontent-%COMP%]{cursor:not-allowed}.previews-container[_ngcontent-%COMP%]   .nav[_ngcontent-%COMP%], .previews-container[_ngcontent-%COMP%] > .nav-left[_ngcontent-%COMP%], .previews-container[_ngcontent-%COMP%] > .nav-right[_ngcontent-%COMP%]{position:absolute;top:calc(50% - 7px);color:#919191;z-index:1000;cursor:pointer;transition:.5s}.previews-container[_ngcontent-%COMP%]   .nav[_ngcontent-%COMP%]:hover, .previews-container[_ngcontent-%COMP%] > .nav-left[_ngcontent-%COMP%]:hover, .previews-container[_ngcontent-%COMP%] > .nav-right[_ngcontent-%COMP%]:hover{transform:scale(1.1)}.previews-container[_ngcontent-%COMP%] > .nav-left[_ngcontent-%COMP%]{margin-right:10px;left:10px}.previews-container[_ngcontent-%COMP%] > .nav-left[_ngcontent-%COMP%] > .left-arrow-preview-image[_ngcontent-%COMP%]{opacity:1}.previews-container[_ngcontent-%COMP%] > .nav-right[_ngcontent-%COMP%]{margin-left:10px;right:10px}.previews-container[_ngcontent-%COMP%] > .nav-right[_ngcontent-%COMP%] > .right-arrow-preview-image[_ngcontent-%COMP%]{opacity:1}", _c10], changeDetection: 0 });
/** @nocollapse */
CarouselPreviewsComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: BreakpointObserver },
    { type: DomSanitizer }
];
CarouselPreviewsComponent.propDecorators = {
    hostMaxWidth: [{ type: HostBinding, args: ['style.max-width',] }],
    ariaLabel: [{ type: HostBinding, args: ['attr.aria-label',] }],
    carouselConfig: [{ type: Input }],
    currentImage: [{ type: Input }],
    images: [{ type: Input }],
    previewConfig: [{ type: Input }],
    accessibilityConfig: [{ type: Input }],
    clickPreview: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CarouselPreviewsComponent, [{
        type: Component,
        args: [{
                selector: 'ks-carousel-previews',
                template: "<nav *ngIf=\"configPreview?.visible\"\n     class=\"previews-container\"\n     [attr.aria-label]=\"accessibilityConfig?.carouselPreviewsContainerAriaLabel\"\n     [title]=\"accessibilityConfig?.carouselPreviewsContainerTitle\">\n\n  <a class=\"nav-left\"\n     [attr.aria-label]=\"accessibilityConfig?.carouselPreviewScrollPrevAriaLabel\"\n     [tabindex]=\"configPreview.arrows && start > 0 ? 0 : -1\" role=\"button\"\n     (click)=\"onNavigationEvent('left', $event)\" (keyup)=\"onNavigationEvent('left', $event)\">\n    <div class=\"inside {{configPreview.arrows && start > 0 ? 'left-arrow-preview-image' : 'empty-arrow-preview-image'}}\"\n         aria-hidden=\"true\"\n         [title]=\"accessibilityConfig?.carouselPreviewScrollPrevTitle\"></div>\n  </a>\n\n  <div class=\"preview-inner-container\">\n    <ng-container *ngFor=\"let preview of previews; trackBy: trackById; let index = index\">\n      <ng-container *ngIf=\"!carouselConfig?.legacyIE11Mode; else legacyMode\">\n        <img *ngIf=\"preview?.modal?.img\"\n             class=\"inside preview-image{{isActive(preview) ? ' active' : ''}}{{!configPreview.clickable ? ' unclickable' : ''}}\"\n             [src]=\"preview.plain?.img ? preview.plain.img : preview.modal.img\"\n             ksSize [sizeConfig]=\"{width: configPreview?.width,\n                                 height: configPreview?.maxHeight}\"\n             [attr.aria-label]=\"getAriaLabel(preview)\"\n             [title]=\"getTitle(preview)\"\n             alt=\"{{getAlt(preview)}}\"\n             [tabindex]=\"0\" role=\"img\"\n             (click)=\"onImageEvent(preview, $event, clickAction)\" (keyup)=\"onImageEvent(preview, $event, keyboardAction)\"/>\n      </ng-container>\n      <ng-template #legacyMode>\n        <div *ngIf=\"preview?.modal?.img\"\n             class=\"inside preview-ie11-image{{isActive(preview) ? ' active' : ''}}{{!configPreview.clickable ? ' unclickable' : ''}}\"\n             [style.background-color]=\"'transparent'\"\n             [style.background-image]=\"sanitizeUrlBgStyle(preview.plain?.img ? preview.plain.img : preview.modal.img)\"\n             [style.background-position]=\"'center center'\"\n             [style.background-size]=\"getIE11LegacyBgSize()\"\n             [style.background-repeat]=\"'no-repeat'\"\n             [style.background-attachment]=\"'scroll'\"\n             ksSize [sizeConfig]=\"{width: configPreview?.width,\n                                 height: configPreview?.maxHeight}\"\n             [attr.aria-label]=\"getAriaLabel(preview)\"\n             [title]=\"getTitle(preview)\"\n             [tabindex]=\"0\" role=\"img\"\n             (click)=\"onImageEvent(preview, $event, clickAction)\" (keyup)=\"onImageEvent(preview, $event, keyboardAction)\"></div>\n      </ng-template>\n    </ng-container>\n  </div>\n\n  <a class=\"nav-right\"\n     [attr.aria-label]=\"accessibilityConfig?.carouselPreviewScrollNextAriaLabel\"\n     [tabindex]=\"configPreview.arrows && end < images.length ? 0 : -1\" role=\"button\"\n     (click)=\"onNavigationEvent('right', $event)\" (keyup)=\"onNavigationEvent('right', $event)\">\n    <div class=\"inside {{configPreview.arrows && end < images.length ? 'right-arrow-preview-image' : 'empty-arrow-preview-image'}}\"\n         aria-hidden=\"true\"\n         [title]=\"accessibilityConfig?.carouselPreviewScrollNextTitle\"></div>\n  </a>\n\n</nav>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{position:relative;margin-top:3px;margin-bottom:3px;width:100%}.previews-container{align-items:center;-webkit-animation:.8s fadein-semi-visible08;animation:.8s fadein-semi-visible08;display:flex;flex-direction:row;justify-content:center;margin-bottom:0}.previews-container>.preview-inner-container{display:flex;flex-direction:row;justify-content:center;align-items:center;flex-wrap:nowrap;width:100%}.previews-container>.preview-inner-container>.preview-image{cursor:pointer;-o-object-fit:cover;object-fit:cover}.previews-container>.preview-inner-container>.preview-image.unclickable{cursor:not-allowed}.previews-container>.preview-inner-container>.preview-ie11-image{cursor:pointer}.previews-container>.preview-inner-container>.preview-ie11-image.unclickable{cursor:not-allowed}.previews-container .nav,.previews-container>.nav-left,.previews-container>.nav-right{position:absolute;top:calc(50% - 7px);color:#919191;z-index:1000;cursor:pointer;transition:.5s}.previews-container .nav:hover,.previews-container>.nav-left:hover,.previews-container>.nav-right:hover{transform:scale(1.1)}.previews-container>.nav-left{margin-right:10px;left:10px}.previews-container>.nav-left>.left-arrow-preview-image{opacity:1}.previews-container>.nav-right{margin-left:10px;right:10px}.previews-container>.nav-right>.right-arrow-preview-image{opacity:1}", ".arrow-preview-image,.empty-arrow-preview-image,.left-arrow-preview-image,.right-arrow-preview-image{width:15px;height:15px;opacity:.5}.empty-arrow-preview-image{background:#000;opacity:0}.left-arrow-preview-image{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3Ny4xNzUgNDc3LjE3NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDc3LjE3NSA0NzcuMTc1OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij48Zz48cGF0aCBkPSJNMTQ1LjE4OCwyMzguNTc1bDIxNS41LTIxNS41YzUuMy01LjMsNS4zLTEzLjgsMC0xOS4xcy0xMy44LTUuMy0xOS4xLDBsLTIyNS4xLDIyNS4xYy01LjMsNS4zLTUuMywxMy44LDAsMTkuMWwyMjUuMSwyMjUgICBjMi42LDIuNiw2LjEsNCw5LjUsNHM2LjktMS4zLDkuNS00YzUuMy01LjMsNS4zLTEzLjgsMC0xOS4xTDE0NS4xODgsMjM4LjU3NXoiIGZpbGw9IiNGRkZGRkYiLz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+);background-size:15px;transition:.5s}.left-arrow-preview-image:hover{transform:scale(1.2)}.right-arrow-preview-image{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3Ny4xNzUgNDc3LjE3NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDc3LjE3NSA0NzcuMTc1OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij48Zz48cGF0aCBkPSJNMzYwLjczMSwyMjkuMDc1bC0yMjUuMS0yMjUuMWMtNS4zLTUuMy0xMy44LTUuMy0xOS4xLDBzLTUuMywxMy44LDAsMTkuMWwyMTUuNSwyMTUuNWwtMjE1LjUsMjE1LjUgICBjLTUuMyw1LjMtNS4zLDEzLjgsMCwxOS4xYzIuNiwyLjYsNi4xLDQsOS41LDRjMy40LDAsNi45LTEuMyw5LjUtNGwyMjUuMS0yMjUuMUMzNjUuOTMxLDI0Mi44NzUsMzY1LjkzMSwyMzQuMjc1LDM2MC43MzEsMjI5LjA3NXogICAiIGZpbGw9IiNGRkZGRkYiLz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+);background-size:15px;transition:.5s}.right-arrow-preview-image:hover{transform:scale(1.2)}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc3.BreakpointObserver }, { type: ɵngcc2.DomSanitizer }]; }, { hostMaxWidth: [{
            type: HostBinding,
            args: ['style.max-width']
        }], ariaLabel: [{
            type: HostBinding,
            args: ['attr.aria-label']
        }], clickPreview: [{
            type: Output
        }], carouselConfig: [{
            type: Input
        }], currentImage: [{
            type: Input
        }], images: [{
            type: Input
        }], previewConfig: [{
            type: Input
        }], accessibilityConfig: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const ButtonsStrategy = {
    // don't use 0 here
    // the first index is 1 and all of the following members are auto-incremented from that point on
    DEFAULT: 1,
    SIMPLE: 2,
    ADVANCED: 3,
    FULL: 4,
    CUSTOM: 5,
};
ButtonsStrategy[ButtonsStrategy.DEFAULT] = 'DEFAULT';
ButtonsStrategy[ButtonsStrategy.SIMPLE] = 'SIMPLE';
ButtonsStrategy[ButtonsStrategy.ADVANCED] = 'ADVANCED';
ButtonsStrategy[ButtonsStrategy.FULL] = 'FULL';
ButtonsStrategy[ButtonsStrategy.CUSTOM] = 'CUSTOM';
/** @enum {number} */
const ButtonType = {
    // don't use 0 here
    // the first index is 1 and all of the following members are auto-incremented from that point on
    // REFRESH = 1,
    DELETE: 1,
    EXTURL: 2,
    DOWNLOAD: 3,
    CLOSE: 4,
    CUSTOM: 5,
    FULLSCREEN: 6,
    // ROTATE
};
ButtonType[ButtonType.DELETE] = 'DELETE';
ButtonType[ButtonType.EXTURL] = 'EXTURL';
ButtonType[ButtonType.DOWNLOAD] = 'DOWNLOAD';
ButtonType[ButtonType.CLOSE] = 'CLOSE';
ButtonType[ButtonType.CUSTOM] = 'CUSTOM';
ButtonType[ButtonType.FULLSCREEN] = 'FULLSCREEN';
/**
 * Array of admitted types of buttons.
 * @type {?}
 */
const WHITELIST_BUTTON_TYPES = [
    // ButtonType.REFRESH,
    ButtonType.FULLSCREEN,
    ButtonType.DELETE,
    ButtonType.EXTURL,
    ButtonType.DOWNLOAD,
    ButtonType.CLOSE,
    ButtonType.CUSTOM
    // ButtonType.ROTATE
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Default button size object
 * @type {?}
 */
const KS_DEFAULT_SIZE = { height: 'auto', width: '30px' };
/**
 * Default close button object
 * @type {?}
 */
const KS_DEFAULT_BTN_CLOSE = {
    className: 'close-image',
    size: KS_DEFAULT_SIZE,
    type: ButtonType.CLOSE,
    title: 'Close this modal image gallery',
    ariaLabel: 'Close this modal image gallery'
};
/**
 * Default download button object
 * @type {?}
 */
const KS_DEFAULT_BTN_DOWNLOAD = {
    className: 'download-image',
    size: KS_DEFAULT_SIZE,
    type: ButtonType.DOWNLOAD,
    title: 'Download the current image',
    ariaLabel: 'Download the current image'
};
/**
 * Default exturl button object
 * @type {?}
 */
const KS_DEFAULT_BTN_EXTURL = {
    className: 'ext-url-image',
    size: KS_DEFAULT_SIZE,
    type: ButtonType.EXTURL,
    title: 'Navigate the current image',
    ariaLabel: 'Navigate the current image'
};
// /**
//  * Default refresh button object
//  */
// export const KS_DEFAULT_BTN_REFRESH: ButtonConfig = {
//   className: 'refresh-image',
//   size: KS_DEFAULT_SIZE,
//   type: ButtonType.REFRESH,
//   title: 'Refresh all images',
//   ariaLabel: 'Refresh all images'
// };
/**
 * Default delete button object
 * @type {?}
 */
const KS_DEFAULT_BTN_DELETE = {
    className: 'delete-image',
    size: KS_DEFAULT_SIZE,
    type: ButtonType.DELETE,
    title: 'Delete the current image',
    ariaLabel: 'Delete the current image'
};
/**
 * Default full-screen button object
 * @type {?}
 */
const KS_DEFAULT_BTN_FULL_SCREEN = {
    className: 'fullscreen-image',
    size: KS_DEFAULT_SIZE,
    type: ButtonType.FULLSCREEN,
    title: 'Switch to full-screen',
    ariaLabel: 'Switch to full-screen'
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Component with all upper buttons.
 * Also it emits click events as outputs.
 */
class UpperButtonsComponent extends AccessibleComponent {
    constructor() {
        super(...arguments);
        /**
         * Output to emit clicks on refresh button. The payload contains a `ButtonEvent`.
         */
        this.refresh = new EventEmitter();
        /**
         * Output to emit clicks on delete button. The payload contains a `ButtonEvent`.
         */
        this.delete = new EventEmitter();
        /**
         * Output to emit clicks on navigate button. The payload contains a `ButtonEvent`.
         */
        this.navigate = new EventEmitter();
        /**
         * Output to emit clicks on download button. The payload contains a `ButtonEvent`.
         */
        this.download = new EventEmitter();
        /**
         * Output to emit clicks on close button. The payload contains a `ButtonEvent`.
         */
        this.close = new EventEmitter();
        /**
         * Output to emit clicks on full-screen button. The payload contains a `ButtonEvent`.
         */
        this.fullscreen = new EventEmitter();
        // /**
        //  * Output to emit clicks on rotate button. The payload contains a `ButtonEvent`.
        //  */
        // @Output()
        // rotate: EventEmitter<ButtonEvent> = new EventEmitter<ButtonEvent>();
        /**
         * Output to emit clicks on all custom buttons. The payload contains a `ButtonEvent`.
         */
        this.customEmit = new EventEmitter();
        /**
         * Default buttons array for standard configuration
         */
        this.defaultButtonsDefault = [KS_DEFAULT_BTN_CLOSE];
        /**
         * Default buttons array for simple configuration
         */
        this.simpleButtonsDefault = [KS_DEFAULT_BTN_DOWNLOAD, ...this.defaultButtonsDefault];
        /**
         * Default buttons array for advanced configuration
         */
        this.advancedButtonsDefault = [KS_DEFAULT_BTN_EXTURL, ...this.simpleButtonsDefault];
        /**
         * Default buttons array for full configuration
         */
        this.fullButtonsDefault = [
            /*KS_DEFAULT_BTN_REFRESH, */
            KS_DEFAULT_BTN_FULL_SCREEN,
            KS_DEFAULT_BTN_DELETE,
            ...this.advancedButtonsDefault
        ];
    }
    /**
     * Method ´ngOnInit´ to build `configButtons` applying a default value and also to
     * init the `buttons` array.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called only one time!!!
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        const defaultConfig = { visible: true, strategy: ButtonsStrategy.DEFAULT };
        this.configButtons = Object.assign(defaultConfig, this.buttonsConfig);
        switch (this.configButtons.strategy) {
            case ButtonsStrategy.SIMPLE:
                this.buttons = this.addButtonIds(this.simpleButtonsDefault);
                break;
            case ButtonsStrategy.ADVANCED:
                this.buttons = this.addButtonIds(this.advancedButtonsDefault);
                break;
            case ButtonsStrategy.FULL:
                this.buttons = this.addButtonIds(this.fullButtonsDefault);
                break;
            case ButtonsStrategy.CUSTOM:
                this.buttons = this.addButtonIds(this.validateCustomButtons(this.configButtons.buttons));
                break;
            case ButtonsStrategy.DEFAULT:
            default:
                this.buttons = this.addButtonIds(this.defaultButtonsDefault);
                break;
        }
    }
    /**
     * Method called by events from both keyboard and mouse on a button.
     * This will call a private method to trigger an output with the right payload.
     * @throws an error if the button type is unknown
     * @param {?} button
     * @param {?} event
     * @param {?=} action
     * @return {?}
     */
    onEvent(button, event, action = Action.CLICK) {
        if (!event) {
            return;
        }
        /** @type {?} */
        const dataToEmit = {
            button: button,
            // current image initialized as null
            // (I'll fill this value inside the parent of this component
            image: null,
            action: action
        };
        switch (button.type) {
            // case ButtonType.REFRESH:
            //   this.triggerOnMouseAndKeyboard(this.refresh, event, dataToEmit);
            //   break;
            case ButtonType.DELETE:
                this.triggerOnMouseAndKeyboard(this.delete, event, dataToEmit);
                break;
            case ButtonType.EXTURL:
                if (!this.currentImage || !this.currentImage.modal || !this.currentImage.modal.extUrl) {
                    return;
                }
                this.triggerOnMouseAndKeyboard(this.navigate, event, dataToEmit);
                break;
            case ButtonType.DOWNLOAD:
                this.triggerOnMouseAndKeyboard(this.download, event, dataToEmit);
                break;
            case ButtonType.CLOSE:
                this.triggerOnMouseAndKeyboard(this.close, event, dataToEmit);
                break;
            case ButtonType.CUSTOM:
                this.triggerOnMouseAndKeyboard(this.customEmit, event, dataToEmit);
                break;
            case ButtonType.FULLSCREEN:
                this.triggerOnMouseAndKeyboard(this.fullscreen, event, dataToEmit);
                break;
            // case ButtonType.ROTATE:
            //   this.triggerOnMouseAndKeyboard(this.rotate, event, dataToEmit);
            //   break;
            default:
                throw new Error(`Unknown button's type into ButtonConfig`);
        }
    }
    /**
     * Method used in the template to track ids in ngFor.
     * @param {?} index
     * @param {?} item
     * @return {?} number the id of the item or undefined if the item is not valid
     */
    trackById(index, item) {
        return item ? item.id : undefined;
    }
    /**
     * Private method to emit an event using the specified output as an `EventEmitter`.
     * @private
     * @param {?} emitter
     * @param {?} event
     * @param {?} dataToEmit
     * @return {?}
     */
    triggerOnMouseAndKeyboard(emitter, event, dataToEmit) {
        if (!emitter) {
            throw new Error(`UpperButtonsComponent unknown emitter in triggerOnMouseAndKeyboard`);
        }
        /** @type {?} */
        const result = super.handleImageEvent(event);
        if (result === NEXT) {
            emitter.emit(dataToEmit);
        }
    }
    /**
     * Private method to add ids to the array of buttons.
     * It adds ids in a reverse way, to be sure that the last button will always have id = 0.
     * This is really useful in unit testing to be sure that close button always have id = 0, download 1 and so on...
     * It's totally transparent to the user.
     * @private
     * @param {?} buttons
     * @return {?} ButtonConfig[] the input array with incremental numeric ids
     */
    addButtonIds(buttons) {
        return buttons.map((/**
         * @param {?} val
         * @param {?} i
         * @return {?}
         */
        (val, i) => Object.assign(val, { id: buttons.length - 1 - i })));
    }
    /**
     * Private method to validate custom buttons received as input.
     * @throws an error is exists a button with an unknown type
     * @private
     * @param {?=} buttons
     * @return {?} ButtonConfig[] the same input buttons config array
     */
    validateCustomButtons(buttons = []) {
        buttons.forEach((/**
         * @param {?} val
         * @return {?}
         */
        (val) => {
            /** @type {?} */
            const indexOfButtonType = WHITELIST_BUTTON_TYPES.findIndex((/**
             * @param {?} type
             * @return {?}
             */
            (type) => type === val.type));
            if (indexOfButtonType === -1) {
                throw new Error(`Unknown ButtonType. For custom types use ButtonType.CUSTOM`);
            }
        }));
        return buttons;
    }
}
UpperButtonsComponent.ɵfac = /*@__PURE__*/ function () { let ɵUpperButtonsComponent_BaseFactory; return function UpperButtonsComponent_Factory(t) { return (ɵUpperButtonsComponent_BaseFactory || (ɵUpperButtonsComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(UpperButtonsComponent)))(t || UpperButtonsComponent); }; }();
UpperButtonsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UpperButtonsComponent, selectors: [["ks-upper-buttons"]], inputs: { currentImage: "currentImage", buttonsConfig: "buttonsConfig" }, outputs: { refresh: "refresh", delete: "delete", navigate: "navigate", download: "download", close: "close", fullscreen: "fullscreen", customEmit: "customEmit" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 1, consts: [[1, "buttons-container"], [4, "ngIf"], ["class", "upper-button", "ksSize", "", "role", "button", 3, "sizeConfig", "ngStyle", "tabindex", "click", "keyup", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["ksSize", "", "role", "button", 1, "upper-button", 3, "sizeConfig", "ngStyle", "tabindex", "click", "keyup"], ["aria-hidden", "true", 3, "title"]], template: function UpperButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "header", 0);
        ɵngcc0.ɵɵtemplate(1, UpperButtonsComponent_ng_container_1_Template, 2, 2, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.configButtons || (ctx.configButtons == null ? null : ctx.configButtons.visible));
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, SizeDirective, ɵngcc1.NgStyle], styles: [".buttons-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:flex-end}.buttons-container[_ngcontent-%COMP%] > .upper-button[_ngcontent-%COMP%]{-ms-grid-row-align:center;align-self:center;margin-right:30px;margin-top:28px;font-size:50px;text-decoration:none;cursor:pointer;-webkit-animation:.6s animatezoom;animation:.6s animatezoom;color:#fff}@-webkit-keyframes animatezoom{from{transform:scale(0)}to{transform:scale(1)}}@keyframes animatezoom{from{transform:scale(0)}to{transform:scale(1)}}.base-btn[_ngcontent-%COMP%], .close-image[_ngcontent-%COMP%], .copy[_ngcontent-%COMP%], .delete-image[_ngcontent-%COMP%], .download-image[_ngcontent-%COMP%], .ext-url-image[_ngcontent-%COMP%], .fullscreen-image[_ngcontent-%COMP%], .refresh-image[_ngcontent-%COMP%], .rotate-image[_ngcontent-%COMP%]{width:30px;height:30px;background-size:30px;opacity:.8;transition:.5s}.base-btn[_ngcontent-%COMP%]:hover, .close-image[_ngcontent-%COMP%]:hover, .copy[_ngcontent-%COMP%]:hover, .delete-image[_ngcontent-%COMP%]:hover, .download-image[_ngcontent-%COMP%]:hover, .ext-url-image[_ngcontent-%COMP%]:hover, .fullscreen-image[_ngcontent-%COMP%]:hover, .refresh-image[_ngcontent-%COMP%]:hover, .rotate-image[_ngcontent-%COMP%]:hover{transform:scale(1.2)}.rotate-image[_ngcontent-%COMP%]{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDY0IDY0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA2NCA2NDsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+PGc+PGc+PHBhdGggZD0iTTMzLDJjNy43NDYsMCwxNS4wMjgsMy4wMTcsMjAuNTA1LDguNDk0YzEwLjEzOCwxMC4xMzcsMTEuMzEsMjYuMzk2LDIuNzQsMzcuODQ5TDUyLDUyLjU4OVY0NGgtMnYxMWwxLDFoMTF2LTJoLTguNTgyICAgIGw0LjI5Mi00LjI5M2wwLjA5Mi0wLjEwNmM5LjIxMS0xMi4yNDcsNy45NzItMjkuNjY3LTIuODgzLTQwLjUyMUM0OS4wNjQsMy4yMjUsNDEuMjgsMCwzMywwVjJ6IiBmaWxsPSIjRkZGRkZGIi8+PHBhdGggZD0iTTcuNzU1LDE1LjY1N0wxMiwxMS40MTFWMjBoMlY5bC0xLTFIMnYyaDguNTgyTDYuMjksMTQuMjkzbC0wLjA5MiwwLjEwNkMtMy4wMTMsMjYuNjQ2LTEuNzczLDQ0LjA2Niw5LjA4MSw1NC45MiAgICBDMTQuOTM2LDYwLjc3NSwyMi43Miw2NCwzMSw2NHYtMmMtNy43NDYsMC0xNS4wMjgtMy4wMTctMjAuNTA1LTguNDk0QzAuMzU3LDQzLjM2OS0wLjgxNCwyNy4xMSw3Ljc1NSwxNS42NTd6IiBmaWxsPSIjRkZGRkZGIi8+PC9nPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48L3N2Zz4=)}.fullscreen-image[_ngcontent-%COMP%]{background-image:url(data:image/svg+xml;base64,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)}.delete-image[_ngcontent-%COMP%]{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ4Ni40IDQ4Ni40IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODYuNCA0ODYuNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+PGc+PGc+PHBhdGggZD0iTTQ0Niw3MEgzNDQuOFY1My41YzAtMjkuNS0yNC01My41LTUzLjUtNTMuNWgtOTYuMmMtMjkuNSwwLTUzLjUsMjQtNTMuNSw1My41VjcwSDQwLjRjLTcuNSwwLTEzLjUsNi0xMy41LDEzLjUgICAgUzMyLjksOTcsNDAuNCw5N2gyNC40djMxNy4yYzAsMzkuOCwzMi40LDcyLjIsNzIuMiw3Mi4yaDIxMi40YzM5LjgsMCw3Mi4yLTMyLjQsNzIuMi03Mi4yVjk3SDQ0NmM3LjUsMCwxMy41LTYsMTMuNS0xMy41ICAgIFM0NTMuNSw3MCw0NDYsNzB6IE0xNjguNiw1My41YzAtMTQuNiwxMS45LTI2LjUsMjYuNS0yNi41aDk2LjJjMTQuNiwwLDI2LjUsMTEuOSwyNi41LDI2LjVWNzBIMTY4LjZWNTMuNXogTTM5NC42LDQxNC4yICAgIGMwLDI0LjktMjAuMyw0NS4yLTQ1LjIsNDUuMkgxMzdjLTI0LjksMC00NS4yLTIwLjMtNDUuMi00NS4yVjk3aDMwMi45djMxNy4ySDM5NC42eiIgZmlsbD0iI0ZGRkZGRiIvPjxwYXRoIGQ9Ik0yNDMuMiw0MTFjNy41LDAsMTMuNS02LDEzLjUtMTMuNVYxNTguOWMwLTcuNS02LTEzLjUtMTMuNS0xMy41cy0xMy41LDYtMTMuNSwxMy41djIzOC41ICAgIEMyMjkuNyw0MDQuOSwyMzUuNyw0MTEsMjQzLjIsNDExeiIgZmlsbD0iI0ZGRkZGRiIvPjxwYXRoIGQ9Ik0xNTUuMSwzOTYuMWM3LjUsMCwxMy41LTYsMTMuNS0xMy41VjE3My43YzAtNy41LTYtMTMuNS0xMy41LTEzLjVzLTEzLjUsNi0xMy41LDEzLjV2MjA4LjkgICAgQzE0MS42LDM5MC4xLDE0Ny43LDM5Ni4xLDE1NS4xLDM5Ni4xeiIgZmlsbD0iI0ZGRkZGRiIvPjxwYXRoIGQ9Ik0zMzEuMywzOTYuMWM3LjUsMCwxMy41LTYsMTMuNS0xMy41VjE3My43YzAtNy41LTYtMTMuNS0xMy41LTEzLjVzLTEzLjUsNi0xMy41LDEzLjV2MjA4LjkgICAgQzMxNy44LDM5MC4xLDMyMy44LDM5Ni4xLDMzMS4zLDM5Ni4xeiIgZmlsbD0iI0ZGRkZGRiIvPjwvZz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+)}.ext-url-image[_ngcontent-%COMP%]{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiPjxnPjxnPjxnPjxwYXRoIGQ9Ik00ODAsMjg4djExMmMwLDQ0LjE4My0zNS44MTcsODAtODAsODBIMTEyYy00NC4xODMsMC04MC0zNS44MTctODAtODBWMTEyYzAtNDQuMTgzLDM1LjgxNy04MCw4MC04MGg5NlYwaC05NiAgICAgQzUwLjE0NCwwLDAsNTAuMTQ0LDAsMTEydjI4OGMwLDYxLjg1Niw1MC4xNDQsMTEyLDExMiwxMTJoMjg4YzYxLjg1NiwwLDExMi01MC4xNDQsMTEyLTExMlYyODhINDgweiIgZmlsbD0iI0ZGRkZGRiIvPjxwYXRoIGQ9Ik0xNzYsNDE2aDMyVjI4OGMwLTEyNS43NiwxMDcuNTItMTI4LDExMi0xMjhoMTA1LjQ0bC04NC42NCw4NC42NGwyMi41NiwyMi41NmwxMTItMTEyYzYuMjA0LTYuMjQxLDYuMjA0LTE2LjMxOSwwLTIyLjU2ICAgICBsLTExMi0xMTJsLTIyLjcyLDIyLjcybDg0LjgsODQuNjRIMzIwYy0xLjQ0LDAtMTQ0LDEuNzYtMTQ0LDE2MFY0MTZ6IiBmaWxsPSIjRkZGRkZGIi8+PC9nPjwvZz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+)}.download-image[_ngcontent-%COMP%]{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3MS4yIDQ3MS4yIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0NzEuMiA0NzEuMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+PGc+PGc+PHBhdGggZD0iTTQ1Ny43LDIzMC4xNWMtNy41LDAtMTMuNSw2LTEzLjUsMTMuNXYxMjIuOGMwLDMzLjQtMjcuMiw2MC41LTYwLjUsNjAuNUg4Ny41Yy0zMy40LDAtNjAuNS0yNy4yLTYwLjUtNjAuNXYtMTI0LjggICAgYzAtNy41LTYtMTMuNS0xMy41LTEzLjVzLTEzLjUsNi0xMy41LDEzLjV2MTI0LjhjMCw0OC4zLDM5LjMsODcuNSw4Ny41LDg3LjVoMjk2LjJjNDguMywwLDg3LjUtMzkuMyw4Ny41LTg3LjV2LTEyMi44ICAgIEM0NzEuMiwyMzYuMjUsNDY1LjIsMjMwLjE1LDQ1Ny43LDIzMC4xNXoiIGZpbGw9IiNGRkZGRkYiLz48cGF0aCBkPSJNMjI2LjEsMzQ2Ljc1YzIuNiwyLjYsNi4xLDQsOS41LDRzNi45LTEuMyw5LjUtNGw4NS44LTg1LjhjNS4zLTUuMyw1LjMtMTMuOCwwLTE5LjFjLTUuMy01LjMtMTMuOC01LjMtMTkuMSwwbC02Mi43LDYyLjggICAgVjMwLjc1YzAtNy41LTYtMTMuNS0xMy41LTEzLjVzLTEzLjUsNi0xMy41LDEzLjV2MjczLjlsLTYyLjgtNjIuOGMtNS4zLTUuMy0xMy44LTUuMy0xOS4xLDBjLTUuMyw1LjMtNS4zLDEzLjgsMCwxOS4xICAgIEwyMjYuMSwzNDYuNzV6IiBmaWxsPSIjRkZGRkZGIi8+PC9nPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48L3N2Zz4=)}.close-image[_ngcontent-%COMP%]{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3NS4yIDQ3NS4yIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0NzUuMiA0NzUuMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+PGc+PGc+PHBhdGggZD0iTTQwNS42LDY5LjZDMzYwLjcsMjQuNywzMDEuMSwwLDIzNy42LDBzLTEyMy4xLDI0LjctMTY4LDY5LjZTMCwxNzQuMSwwLDIzNy42czI0LjcsMTIzLjEsNjkuNiwxNjhzMTA0LjUsNjkuNiwxNjgsNjkuNiAgICBzMTIzLjEtMjQuNywxNjgtNjkuNnM2OS42LTEwNC41LDY5LjYtMTY4UzQ1MC41LDExNC41LDQwNS42LDY5LjZ6IE0zODYuNSwzODYuNWMtMzkuOCwzOS44LTkyLjcsNjEuNy0xNDguOSw2MS43ICAgIHMtMTA5LjEtMjEuOS0xNDguOS02MS43Yy04Mi4xLTgyLjEtODIuMS0yMTUuNywwLTI5Ny44QzEyOC41LDQ4LjksMTgxLjQsMjcsMjM3LjYsMjdzMTA5LjEsMjEuOSwxNDguOSw2MS43ICAgIEM0NjguNiwxNzAuOCw0NjguNiwzMDQuNCwzODYuNSwzODYuNXoiIGZpbGw9IiNGRkZGRkYiLz48cGF0aCBkPSJNMzQyLjMsMTMyLjljLTUuMy01LjMtMTMuOC01LjMtMTkuMSwwbC04NS42LDg1LjZMMTUyLDEzMi45Yy01LjMtNS4zLTEzLjgtNS4zLTE5LjEsMGMtNS4zLDUuMy01LjMsMTMuOCwwLDE5LjEgICAgbDg1LjYsODUuNmwtODUuNiw4NS42Yy01LjMsNS4zLTUuMywxMy44LDAsMTkuMWMyLjYsMi42LDYuMSw0LDkuNSw0czYuOS0xLjMsOS41LTRsODUuNi04NS42bDg1LjYsODUuNmMyLjYsMi42LDYuMSw0LDkuNSw0ICAgIGMzLjUsMCw2LjktMS4zLDkuNS00YzUuMy01LjMsNS4zLTEzLjgsMC0xOS4xbC04NS40LTg1LjZsODUuNi04NS42QzM0Ny42LDE0Ni43LDM0Ny42LDEzOC4yLDM0Mi4zLDEzMi45eiIgZmlsbD0iI0ZGRkZGRiIvPjwvZz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+)}.refresh-image[_ngcontent-%COMP%]{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ4OS43MTEgNDg5LjcxMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDg5LjcxMSA0ODkuNzExOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij48Zz48Zz48cGF0aCBkPSJNMTEyLjE1Niw5Ny4xMTFjNzIuMy02NS40LDE4MC41LTY2LjQsMjUzLjgtNi43bC01OC4xLDIuMmMtNy41LDAuMy0xMy4zLDYuNS0xMywxNGMwLjMsNy4zLDYuMywxMywxMy41LDEzICAgIGMwLjIsMCwwLjMsMCwwLjUsMGw4OS4yLTMuM2M3LjMtMC4zLDEzLTYuMiwxMy0xMy41di0xYzAtMC4yLDAtMC4zLDAtMC41di0wLjFsMCwwbC0zLjMtODguMmMtMC4zLTcuNS02LjYtMTMuMy0xNC0xMyAgICBjLTcuNSwwLjMtMTMuMyw2LjUtMTMsMTRsMi4xLDU1LjNjLTM2LjMtMjkuNy04MS00Ni45LTEyOC44LTQ5LjNjLTU5LjItMy0xMTYuMSwxNy4zLTE2MCw1Ny4xYy02MC40LDU0LjctODYsMTM3LjktNjYuOCwyMTcuMSAgICBjMS41LDYuMiw3LDEwLjMsMTMuMSwxMC4zYzEuMSwwLDIuMS0wLjEsMy4yLTAuNGM3LjItMS44LDExLjctOS4xLDkuOS0xNi4zQzM2LjY1NiwyMTguMjExLDU5LjA1NiwxNDUuMTExLDExMi4xNTYsOTcuMTExeiIgZmlsbD0iI0ZGRkZGRiIvPjxwYXRoIGQ9Ik00NjIuNDU2LDE5NS41MTFjLTEuOC03LjItOS4xLTExLjctMTYuMy05LjljLTcuMiwxLjgtMTEuNyw5LjEtOS45LDE2LjNjMTYuOSw2OS42LTUuNiwxNDIuNy01OC43LDE5MC43ICAgIGMtMzcuMywzMy43LTg0LjEsNTAuMy0xMzAuNyw1MC4zYy00NC41LDAtODguOS0xNS4xLTEyNC43LTQ0LjlsNTguOC01LjNjNy40LTAuNywxMi45LTcuMiwxMi4yLTE0LjdzLTcuMi0xMi45LTE0LjctMTIuMmwtODguOSw4ICAgIGMtNy40LDAuNy0xMi45LDcuMi0xMi4yLDE0LjdsOCw4OC45YzAuNiw3LDYuNSwxMi4zLDEzLjQsMTIuM2MwLjQsMCwwLjgsMCwxLjItMC4xYzcuNC0wLjcsMTIuOS03LjIsMTIuMi0xNC43bC00LjgtNTQuMSAgICBjMzYuMywyOS40LDgwLjgsNDYuNSwxMjguMyw0OC45YzMuOCwwLjIsNy42LDAuMywxMS4zLDAuM2M1NS4xLDAsMTA3LjUtMjAuMiwxNDguNy01Ny40ICAgIEM0NTYuMDU2LDM1Ny45MTEsNDgxLjY1NiwyNzQuODExLDQ2Mi40NTYsMTk1LjUxMXoiIGZpbGw9IiNGRkZGRkYiLz48L2c+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjwvc3ZnPg==)}.copy[_ngcontent-%COMP%]{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ4OC4zIDQ4OC4zIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODguMyA0ODguMzsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+PGc+PGc+PHBhdGggZD0iTTMxNC4yNSw4NS40aC0yMjdjLTIxLjMsMC0zOC42LDE3LjMtMzguNiwzOC42djMyNS43YzAsMjEuMywxNy4zLDM4LjYsMzguNiwzOC42aDIyN2MyMS4zLDAsMzguNi0xNy4zLDM4LjYtMzguNlYxMjQgICAgQzM1Mi43NSwxMDIuNywzMzUuNDUsODUuNCwzMTQuMjUsODUuNHogTTMyNS43NSw0NDkuNmMwLDYuNC01LjIsMTEuNi0xMS42LDExLjZoLTIyN2MtNi40LDAtMTEuNi01LjItMTEuNi0xMS42VjEyNCAgICBjMC02LjQsNS4yLTExLjYsMTEuNi0xMS42aDIyN2M2LjQsMCwxMS42LDUuMiwxMS42LDExLjZWNDQ5LjZ6IiBmaWxsPSIjRkZGRkZGIi8+PHBhdGggZD0iTTQwMS4wNSwwaC0yMjdjLTIxLjMsMC0zOC42LDE3LjMtMzguNiwzOC42YzAsNy41LDYsMTMuNSwxMy41LDEzLjVzMTMuNS02LDEzLjUtMTMuNWMwLTYuNCw1LjItMTEuNiwxMS42LTExLjZoMjI3ICAgIGM2LjQsMCwxMS42LDUuMiwxMS42LDExLjZ2MzI1LjdjMCw2LjQtNS4yLDExLjYtMTEuNiwxMS42Yy03LjUsMC0xMy41LDYtMTMuNSwxMy41czYsMTMuNSwxMy41LDEzLjVjMjEuMywwLDM4LjYtMTcuMywzOC42LTM4LjYgICAgVjM4LjZDNDM5LjY1LDE3LjMsNDIyLjM1LDAsNDAxLjA1LDB6IiBmaWxsPSIjRkZGRkZGIi8+PC9nPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48L3N2Zz4=)}"], changeDetection: 0 });
UpperButtonsComponent.propDecorators = {
    currentImage: [{ type: Input }],
    buttonsConfig: [{ type: Input }],
    refresh: [{ type: Output }],
    delete: [{ type: Output }],
    navigate: [{ type: Output }],
    download: [{ type: Output }],
    close: [{ type: Output }],
    fullscreen: [{ type: Output }],
    customEmit: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UpperButtonsComponent, [{
        type: Component,
        args: [{
                selector: 'ks-upper-buttons',
                template: "<header class=\"buttons-container\">\n\n  <ng-container *ngIf=\"!configButtons || configButtons?.visible\">\n    <a *ngFor=\"let btn of buttons; trackBy: trackById; let index = index\"\n       class=\"upper-button\"\n       ksSize [sizeConfig]=\"{width: btn.size?.width, height: btn.size?.height}\"\n       [ngStyle]=\"{'font-size': btn.fontSize}\"\n       [attr.aria-label]=\"btn.ariaLabel\"\n       [tabindex]=\"0\" role=\"button\"\n       (click)=\"onEvent(btn, $event)\" (keyup)=\"onEvent(btn, $event)\">\n      <div class=\"inside {{btn.className}}\" aria-hidden=\"true\" title=\"{{btn.title}}\"></div>\n    </a>\n  </ng-container>\n</header>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".buttons-container{display:flex;flex-direction:row;justify-content:flex-end}.buttons-container>.upper-button{-ms-grid-row-align:center;align-self:center;margin-right:30px;margin-top:28px;font-size:50px;text-decoration:none;cursor:pointer;-webkit-animation:.6s animatezoom;animation:.6s animatezoom;color:#fff}@-webkit-keyframes animatezoom{from{transform:scale(0)}to{transform:scale(1)}}@keyframes animatezoom{from{transform:scale(0)}to{transform:scale(1)}}.base-btn,.close-image,.copy,.delete-image,.download-image,.ext-url-image,.fullscreen-image,.refresh-image,.rotate-image{width:30px;height:30px;background-size:30px;opacity:.8;transition:.5s}.base-btn:hover,.close-image:hover,.copy:hover,.delete-image:hover,.download-image:hover,.ext-url-image:hover,.fullscreen-image:hover,.refresh-image:hover,.rotate-image:hover{transform:scale(1.2)}.rotate-image{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDY0IDY0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA2NCA2NDsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+PGc+PGc+PHBhdGggZD0iTTMzLDJjNy43NDYsMCwxNS4wMjgsMy4wMTcsMjAuNTA1LDguNDk0YzEwLjEzOCwxMC4xMzcsMTEuMzEsMjYuMzk2LDIuNzQsMzcuODQ5TDUyLDUyLjU4OVY0NGgtMnYxMWwxLDFoMTF2LTJoLTguNTgyICAgIGw0LjI5Mi00LjI5M2wwLjA5Mi0wLjEwNmM5LjIxMS0xMi4yNDcsNy45NzItMjkuNjY3LTIuODgzLTQwLjUyMUM0OS4wNjQsMy4yMjUsNDEuMjgsMCwzMywwVjJ6IiBmaWxsPSIjRkZGRkZGIi8+PHBhdGggZD0iTTcuNzU1LDE1LjY1N0wxMiwxMS40MTFWMjBoMlY5bC0xLTFIMnYyaDguNTgyTDYuMjksMTQuMjkzbC0wLjA5MiwwLjEwNkMtMy4wMTMsMjYuNjQ2LTEuNzczLDQ0LjA2Niw5LjA4MSw1NC45MiAgICBDMTQuOTM2LDYwLjc3NSwyMi43Miw2NCwzMSw2NHYtMmMtNy43NDYsMC0xNS4wMjgtMy4wMTctMjAuNTA1LTguNDk0QzAuMzU3LDQzLjM2OS0wLjgxNCwyNy4xMSw3Ljc1NSwxNS42NTd6IiBmaWxsPSIjRkZGRkZGIi8+PC9nPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48L3N2Zz4=)}.fullscreen-image{background-image:url(data:image/svg+xml;base64,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)}.delete-image{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ4Ni40IDQ4Ni40IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODYuNCA0ODYuNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+PGc+PGc+PHBhdGggZD0iTTQ0Niw3MEgzNDQuOFY1My41YzAtMjkuNS0yNC01My41LTUzLjUtNTMuNWgtOTYuMmMtMjkuNSwwLTUzLjUsMjQtNTMuNSw1My41VjcwSDQwLjRjLTcuNSwwLTEzLjUsNi0xMy41LDEzLjUgICAgUzMyLjksOTcsNDAuNCw5N2gyNC40djMxNy4yYzAsMzkuOCwzMi40LDcyLjIsNzIuMiw3Mi4yaDIxMi40YzM5LjgsMCw3Mi4yLTMyLjQsNzIuMi03Mi4yVjk3SDQ0NmM3LjUsMCwxMy41LTYsMTMuNS0xMy41ICAgIFM0NTMuNSw3MCw0NDYsNzB6IE0xNjguNiw1My41YzAtMTQuNiwxMS45LTI2LjUsMjYuNS0yNi41aDk2LjJjMTQuNiwwLDI2LjUsMTEuOSwyNi41LDI2LjVWNzBIMTY4LjZWNTMuNXogTTM5NC42LDQxNC4yICAgIGMwLDI0LjktMjAuMyw0NS4yLTQ1LjIsNDUuMkgxMzdjLTI0LjksMC00NS4yLTIwLjMtNDUuMi00NS4yVjk3aDMwMi45djMxNy4ySDM5NC42eiIgZmlsbD0iI0ZGRkZGRiIvPjxwYXRoIGQ9Ik0yNDMuMiw0MTFjNy41LDAsMTMuNS02LDEzLjUtMTMuNVYxNTguOWMwLTcuNS02LTEzLjUtMTMuNS0xMy41cy0xMy41LDYtMTMuNSwxMy41djIzOC41ICAgIEMyMjkuNyw0MDQuOSwyMzUuNyw0MTEsMjQzLjIsNDExeiIgZmlsbD0iI0ZGRkZGRiIvPjxwYXRoIGQ9Ik0xNTUuMSwzOTYuMWM3LjUsMCwxMy41LTYsMTMuNS0xMy41VjE3My43YzAtNy41LTYtMTMuNS0xMy41LTEzLjVzLTEzLjUsNi0xMy41LDEzLjV2MjA4LjkgICAgQzE0MS42LDM5MC4xLDE0Ny43LDM5Ni4xLDE1NS4xLDM5Ni4xeiIgZmlsbD0iI0ZGRkZGRiIvPjxwYXRoIGQ9Ik0zMzEuMywzOTYuMWM3LjUsMCwxMy41LTYsMTMuNS0xMy41VjE3My43YzAtNy41LTYtMTMuNS0xMy41LTEzLjVzLTEzLjUsNi0xMy41LDEzLjV2MjA4LjkgICAgQzMxNy44LDM5MC4xLDMyMy44LDM5Ni4xLDMzMS4zLDM5Ni4xeiIgZmlsbD0iI0ZGRkZGRiIvPjwvZz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+)}.ext-url-image{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiPjxnPjxnPjxnPjxwYXRoIGQ9Ik00ODAsMjg4djExMmMwLDQ0LjE4My0zNS44MTcsODAtODAsODBIMTEyYy00NC4xODMsMC04MC0zNS44MTctODAtODBWMTEyYzAtNDQuMTgzLDM1LjgxNy04MCw4MC04MGg5NlYwaC05NiAgICAgQzUwLjE0NCwwLDAsNTAuMTQ0LDAsMTEydjI4OGMwLDYxLjg1Niw1MC4xNDQsMTEyLDExMiwxMTJoMjg4YzYxLjg1NiwwLDExMi01MC4xNDQsMTEyLTExMlYyODhINDgweiIgZmlsbD0iI0ZGRkZGRiIvPjxwYXRoIGQ9Ik0xNzYsNDE2aDMyVjI4OGMwLTEyNS43NiwxMDcuNTItMTI4LDExMi0xMjhoMTA1LjQ0bC04NC42NCw4NC42NGwyMi41NiwyMi41NmwxMTItMTEyYzYuMjA0LTYuMjQxLDYuMjA0LTE2LjMxOSwwLTIyLjU2ICAgICBsLTExMi0xMTJsLTIyLjcyLDIyLjcybDg0LjgsODQuNjRIMzIwYy0xLjQ0LDAtMTQ0LDEuNzYtMTQ0LDE2MFY0MTZ6IiBmaWxsPSIjRkZGRkZGIi8+PC9nPjwvZz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+)}.download-image{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3MS4yIDQ3MS4yIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0NzEuMiA0NzEuMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+PGc+PGc+PHBhdGggZD0iTTQ1Ny43LDIzMC4xNWMtNy41LDAtMTMuNSw2LTEzLjUsMTMuNXYxMjIuOGMwLDMzLjQtMjcuMiw2MC41LTYwLjUsNjAuNUg4Ny41Yy0zMy40LDAtNjAuNS0yNy4yLTYwLjUtNjAuNXYtMTI0LjggICAgYzAtNy41LTYtMTMuNS0xMy41LTEzLjVzLTEzLjUsNi0xMy41LDEzLjV2MTI0LjhjMCw0OC4zLDM5LjMsODcuNSw4Ny41LDg3LjVoMjk2LjJjNDguMywwLDg3LjUtMzkuMyw4Ny41LTg3LjV2LTEyMi44ICAgIEM0NzEuMiwyMzYuMjUsNDY1LjIsMjMwLjE1LDQ1Ny43LDIzMC4xNXoiIGZpbGw9IiNGRkZGRkYiLz48cGF0aCBkPSJNMjI2LjEsMzQ2Ljc1YzIuNiwyLjYsNi4xLDQsOS41LDRzNi45LTEuMyw5LjUtNGw4NS44LTg1LjhjNS4zLTUuMyw1LjMtMTMuOCwwLTE5LjFjLTUuMy01LjMtMTMuOC01LjMtMTkuMSwwbC02Mi43LDYyLjggICAgVjMwLjc1YzAtNy41LTYtMTMuNS0xMy41LTEzLjVzLTEzLjUsNi0xMy41LDEzLjV2MjczLjlsLTYyLjgtNjIuOGMtNS4zLTUuMy0xMy44LTUuMy0xOS4xLDBjLTUuMyw1LjMtNS4zLDEzLjgsMCwxOS4xICAgIEwyMjYuMSwzNDYuNzV6IiBmaWxsPSIjRkZGRkZGIi8+PC9nPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48L3N2Zz4=)}.close-image{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3NS4yIDQ3NS4yIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0NzUuMiA0NzUuMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+PGc+PGc+PHBhdGggZD0iTTQwNS42LDY5LjZDMzYwLjcsMjQuNywzMDEuMSwwLDIzNy42LDBzLTEyMy4xLDI0LjctMTY4LDY5LjZTMCwxNzQuMSwwLDIzNy42czI0LjcsMTIzLjEsNjkuNiwxNjhzMTA0LjUsNjkuNiwxNjgsNjkuNiAgICBzMTIzLjEtMjQuNywxNjgtNjkuNnM2OS42LTEwNC41LDY5LjYtMTY4UzQ1MC41LDExNC41LDQwNS42LDY5LjZ6IE0zODYuNSwzODYuNWMtMzkuOCwzOS44LTkyLjcsNjEuNy0xNDguOSw2MS43ICAgIHMtMTA5LjEtMjEuOS0xNDguOS02MS43Yy04Mi4xLTgyLjEtODIuMS0yMTUuNywwLTI5Ny44QzEyOC41LDQ4LjksMTgxLjQsMjcsMjM3LjYsMjdzMTA5LjEsMjEuOSwxNDguOSw2MS43ICAgIEM0NjguNiwxNzAuOCw0NjguNiwzMDQuNCwzODYuNSwzODYuNXoiIGZpbGw9IiNGRkZGRkYiLz48cGF0aCBkPSJNMzQyLjMsMTMyLjljLTUuMy01LjMtMTMuOC01LjMtMTkuMSwwbC04NS42LDg1LjZMMTUyLDEzMi45Yy01LjMtNS4zLTEzLjgtNS4zLTE5LjEsMGMtNS4zLDUuMy01LjMsMTMuOCwwLDE5LjEgICAgbDg1LjYsODUuNmwtODUuNiw4NS42Yy01LjMsNS4zLTUuMywxMy44LDAsMTkuMWMyLjYsMi42LDYuMSw0LDkuNSw0czYuOS0xLjMsOS41LTRsODUuNi04NS42bDg1LjYsODUuNmMyLjYsMi42LDYuMSw0LDkuNSw0ICAgIGMzLjUsMCw2LjktMS4zLDkuNS00YzUuMy01LjMsNS4zLTEzLjgsMC0xOS4xbC04NS40LTg1LjZsODUuNi04NS42QzM0Ny42LDE0Ni43LDM0Ny42LDEzOC4yLDM0Mi4zLDEzMi45eiIgZmlsbD0iI0ZGRkZGRiIvPjwvZz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+)}.refresh-image{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ4OS43MTEgNDg5LjcxMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDg5LjcxMSA0ODkuNzExOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij48Zz48Zz48cGF0aCBkPSJNMTEyLjE1Niw5Ny4xMTFjNzIuMy02NS40LDE4MC41LTY2LjQsMjUzLjgtNi43bC01OC4xLDIuMmMtNy41LDAuMy0xMy4zLDYuNS0xMywxNGMwLjMsNy4zLDYuMywxMywxMy41LDEzICAgIGMwLjIsMCwwLjMsMCwwLjUsMGw4OS4yLTMuM2M3LjMtMC4zLDEzLTYuMiwxMy0xMy41di0xYzAtMC4yLDAtMC4zLDAtMC41di0wLjFsMCwwbC0zLjMtODguMmMtMC4zLTcuNS02LjYtMTMuMy0xNC0xMyAgICBjLTcuNSwwLjMtMTMuMyw2LjUtMTMsMTRsMi4xLDU1LjNjLTM2LjMtMjkuNy04MS00Ni45LTEyOC44LTQ5LjNjLTU5LjItMy0xMTYuMSwxNy4zLTE2MCw1Ny4xYy02MC40LDU0LjctODYsMTM3LjktNjYuOCwyMTcuMSAgICBjMS41LDYuMiw3LDEwLjMsMTMuMSwxMC4zYzEuMSwwLDIuMS0wLjEsMy4yLTAuNGM3LjItMS44LDExLjctOS4xLDkuOS0xNi4zQzM2LjY1NiwyMTguMjExLDU5LjA1NiwxNDUuMTExLDExMi4xNTYsOTcuMTExeiIgZmlsbD0iI0ZGRkZGRiIvPjxwYXRoIGQ9Ik00NjIuNDU2LDE5NS41MTFjLTEuOC03LjItOS4xLTExLjctMTYuMy05LjljLTcuMiwxLjgtMTEuNyw5LjEtOS45LDE2LjNjMTYuOSw2OS42LTUuNiwxNDIuNy01OC43LDE5MC43ICAgIGMtMzcuMywzMy43LTg0LjEsNTAuMy0xMzAuNyw1MC4zYy00NC41LDAtODguOS0xNS4xLTEyNC43LTQ0LjlsNTguOC01LjNjNy40LTAuNywxMi45LTcuMiwxMi4yLTE0LjdzLTcuMi0xMi45LTE0LjctMTIuMmwtODguOSw4ICAgIGMtNy40LDAuNy0xMi45LDcuMi0xMi4yLDE0LjdsOCw4OC45YzAuNiw3LDYuNSwxMi4zLDEzLjQsMTIuM2MwLjQsMCwwLjgsMCwxLjItMC4xYzcuNC0wLjcsMTIuOS03LjIsMTIuMi0xNC43bC00LjgtNTQuMSAgICBjMzYuMywyOS40LDgwLjgsNDYuNSwxMjguMyw0OC45YzMuOCwwLjIsNy42LDAuMywxMS4zLDAuM2M1NS4xLDAsMTA3LjUtMjAuMiwxNDguNy01Ny40ICAgIEM0NTYuMDU2LDM1Ny45MTEsNDgxLjY1NiwyNzQuODExLDQ2Mi40NTYsMTk1LjUxMXoiIGZpbGw9IiNGRkZGRkYiLz48L2c+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjwvc3ZnPg==)}.copy{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ4OC4zIDQ4OC4zIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODguMyA0ODguMzsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+PGc+PGc+PHBhdGggZD0iTTMxNC4yNSw4NS40aC0yMjdjLTIxLjMsMC0zOC42LDE3LjMtMzguNiwzOC42djMyNS43YzAsMjEuMywxNy4zLDM4LjYsMzguNiwzOC42aDIyN2MyMS4zLDAsMzguNi0xNy4zLDM4LjYtMzguNlYxMjQgICAgQzM1Mi43NSwxMDIuNywzMzUuNDUsODUuNCwzMTQuMjUsODUuNHogTTMyNS43NSw0NDkuNmMwLDYuNC01LjIsMTEuNi0xMS42LDExLjZoLTIyN2MtNi40LDAtMTEuNi01LjItMTEuNi0xMS42VjEyNCAgICBjMC02LjQsNS4yLTExLjYsMTEuNi0xMS42aDIyN2M2LjQsMCwxMS42LDUuMiwxMS42LDExLjZWNDQ5LjZ6IiBmaWxsPSIjRkZGRkZGIi8+PHBhdGggZD0iTTQwMS4wNSwwaC0yMjdjLTIxLjMsMC0zOC42LDE3LjMtMzguNiwzOC42YzAsNy41LDYsMTMuNSwxMy41LDEzLjVzMTMuNS02LDEzLjUtMTMuNWMwLTYuNCw1LjItMTEuNiwxMS42LTExLjZoMjI3ICAgIGM2LjQsMCwxMS42LDUuMiwxMS42LDExLjZ2MzI1LjdjMCw2LjQtNS4yLDExLjYtMTEuNiwxMS42Yy03LjUsMC0xMy41LDYtMTMuNSwxMy41czYsMTMuNSwxMy41LDEzLjVjMjEuMywwLDM4LjYtMTcuMywzOC42LTM4LjYgICAgVjM4LjZDNDM5LjY1LDE3LjMsNDIyLjM1LDAsNDAxLjA1LDB6IiBmaWxsPSIjRkZGRkZGIi8+PC9nPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48L3N2Zz4=)}"]
            }]
    }], null, { refresh: [{
            type: Output
        }], delete: [{
            type: Output
        }], navigate: [{
            type: Output
        }], download: [{
            type: Output
        }], close: [{
            type: Output
        }], fullscreen: [{
            type: Output
        }], customEmit: [{
            type: Output
        }], currentImage: [{
            type: Input
        }], buttonsConfig: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Component with clickable dots (small circles) to navigate between images inside the modal gallery.
 */
class DotsComponent extends AccessibleComponent {
    constructor() {
        super(...arguments);
        /**
         * Object of type `DotsConfig` to init DotsComponent's features.
         * For instance, it contains a param to show/hide this component.
         */
        this.dotsConfig = { visible: true };
        /**
         * Output to emit clicks on dots. The payload contains a number that represent
         * the index of the clicked dot.
         */
        this.clickDot = new EventEmitter();
    }
    /**
     * Method ´ngOnInit´ to build `configDots` applying a default value.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called only one time!!!
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        const defaultConfig = { visible: true };
        this.configDots = Object.assign(defaultConfig, this.dotsConfig);
    }
    /**
     * Method ´ngOnChanges´ to change `configDots` if the input dotsConfig is changed.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        /** @type {?} */
        const dotsConfigChanges = changes.dotsConfig;
        if (dotsConfigChanges && dotsConfigChanges.currentValue !== dotsConfigChanges.previousValue) {
            this.configDots = dotsConfigChanges.currentValue;
        }
    }
    /**
     * Method to check if an image is active (i.e. the current image).
     * It checks currentImage and images to prevent errors.
     * @param {?} index
     * @return {?} boolean true if is active (and input params are valid), false otherwise
     */
    isActive(index) {
        if (!this.currentImage || !this.images || this.images.length === 0) {
            return false;
        }
        /** @type {?} */
        let imageIndex;
        try {
            imageIndex = getIndex(this.currentImage, this.images);
        }
        catch (err) {
            console.error(`Internal error while trying to show the active 'dot'`, err);
            return false;
        }
        return index === imageIndex;
    }
    /**
     * Method called by events from keyboard and mouse.
     * @param {?} index
     * @param {?} event
     * @return {?}
     */
    onDotEvent(index, event) {
        /** @type {?} */
        const result = super.handleImageEvent(event);
        if (result === NEXT) {
            this.clickDot.emit(index);
        }
    }
    /**
     * Method used in the template to track ids in ngFor.
     * @param {?} index
     * @param {?} item
     * @return {?} number the id of the item
     */
    trackById(index, item) {
        return item.id;
    }
}
DotsComponent.ɵfac = /*@__PURE__*/ function () { let ɵDotsComponent_BaseFactory; return function DotsComponent_Factory(t) { return (ɵDotsComponent_BaseFactory || (ɵDotsComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(DotsComponent)))(t || DotsComponent); }; }();
DotsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DotsComponent, selectors: [["ks-dots"]], inputs: { dotsConfig: "dotsConfig", currentImage: "currentImage", images: "images", accessibilityConfig: "accessibilityConfig" }, outputs: { clickDot: "clickDot" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 3, consts: [[1, "dots-container", 3, "title"], [4, "ngIf"], ["class", "inside dot", "role", "navigation", 3, "ngClass", "tabindex", "click", "keyup", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["role", "navigation", 1, "inside", "dot", 3, "ngClass", "tabindex", "click", "keyup"]], template: function DotsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "nav", 0);
        ɵngcc0.ɵɵtemplate(1, DotsComponent_ng_container_1_Template, 2, 2, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("title", ctx.accessibilityConfig == null ? null : ctx.accessibilityConfig.dotsContainerTitle);
        ɵngcc0.ɵɵattribute("aria-label", ctx.accessibilityConfig == null ? null : ctx.accessibilityConfig.dotsContainerAriaLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.configDots || (ctx.configDots == null ? null : ctx.configDots.visible));
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc1.NgClass], styles: [".dots-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:center;margin-bottom:30px}.dots-container[_ngcontent-%COMP%] > .dot[_ngcontent-%COMP%]{background:#fff;border-radius:5px;height:10px;margin-left:4px;margin-right:4px;width:10px;cursor:pointer;opacity:.5}.dots-container[_ngcontent-%COMP%] > .dot[_ngcontent-%COMP%]:hover{opacity:.9;transition:opacity .5s}.dots-container[_ngcontent-%COMP%] > .dot.active[_ngcontent-%COMP%]{cursor:pointer;opacity:.9}@-webkit-keyframes fadein-semi-visible05{from{opacity:0}to{opacity:.5}}@keyframes fadein-semi-visible05{from{opacity:0}to{opacity:.5}}@-webkit-keyframes fadein-semi-visible09{from{opacity:0}to{opacity:.9}}@keyframes fadein-semi-visible09{from{opacity:0}to{opacity:.9}}"], changeDetection: 0 });
DotsComponent.propDecorators = {
    currentImage: [{ type: Input }],
    images: [{ type: Input }],
    dotsConfig: [{ type: Input }],
    accessibilityConfig: [{ type: Input }],
    clickDot: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DotsComponent, [{
        type: Component,
        args: [{
                selector: 'ks-dots',
                template: "<nav class=\"dots-container\" [attr.aria-label]=\"accessibilityConfig?.dotsContainerAriaLabel\"\n     [title]=\"accessibilityConfig?.dotsContainerTitle\">\n  <ng-container *ngIf=\"!configDots || configDots?.visible\">\n    <div class=\"inside dot\"\n         *ngFor=\"let img of images; trackBy: trackById; let index = index\"\n         [ngClass]=\"{'active': isActive(index)}\"\n         [attr.aria-label]=\"accessibilityConfig?.dotAriaLabel + ' ' + (index + 1)\"\n         [tabindex]=\"0\" role=\"navigation\"\n         (click)=\"onDotEvent(index, $event)\" (keyup)=\"onDotEvent(index, $event)\"></div>\n  </ng-container>\n</nav>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".dots-container{display:flex;flex-direction:row;justify-content:center;margin-bottom:30px}.dots-container>.dot{background:#fff;border-radius:5px;height:10px;margin-left:4px;margin-right:4px;width:10px;cursor:pointer;opacity:.5}.dots-container>.dot:hover{opacity:.9;transition:opacity .5s}.dots-container>.dot.active{cursor:pointer;opacity:.9}@-webkit-keyframes fadein-semi-visible05{from{opacity:0}to{opacity:.5}}@keyframes fadein-semi-visible05{from{opacity:0}to{opacity:.5}}@-webkit-keyframes fadein-semi-visible09{from{opacity:0}to{opacity:.9}}@keyframes fadein-semi-visible09{from{opacity:0}to{opacity:.9}}"]
            }]
    }], null, { dotsConfig: [{
            type: Input
        }], clickDot: [{
            type: Output
        }], currentImage: [{
            type: Input
        }], images: [{
            type: Input
        }], accessibilityConfig: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Component with image previews
 */
class PreviewsComponent extends AccessibleComponent {
    constructor() {
        super(...arguments);
        /**
         * Output to emit the clicked preview. The payload contains the `ImageEvent` associated to the clicked preview.
         */
        this.clickPreview = new EventEmitter();
        // /**
        //  * Output to emit the clicked arrow. The payload contains which arrow (left or right).
        //  */
        // @Output()
        // clickArrow: EventEmitter<InteractionEvent> = new EventEmitter<InteractionEvent>();
        /**
         * Enum of type `Action` that represents a mouse click on a button.
         * Declared here to be used inside the template.
         */
        this.clickAction = Action.CLICK;
        /**
         * Enum of type `Action` that represents a keyboard action.
         * Declared here to be used inside the template.
         */
        this.keyboardAction = Action.KEYBOARD;
        /**
         * Array of `InternalLibImage` exposed to the template. This field is initialized
         * applying transformations, default values and so on to the input of the same type.
         */
        this.previews = [];
        /**
         * Default preview's size object, also used in the template to apply default sizes to ksSize's directive.
         */
        this.defaultPreviewSize = { height: '50px', width: 'auto' };
        /**
         * Default preview's config object
         */
        this.defaultPreviewConfig = {
            visible: true,
            number: 3,
            arrows: true,
            clickable: true,
            // alwaysCenter: false, // TODO still not implemented
            size: this.defaultPreviewSize
        };
    }
    /**
     * Method ´ngOnInit´ to build `configPreview` applying a default value and also to
     * init the `previews` array.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called only one time!!!
     * @return {?}
     */
    ngOnInit() {
        this.configPreview = Object.assign({}, this.defaultPreviewConfig, this.previewConfig);
        // if number is <= 0 reset to default
        if (this.configPreview && this.configPreview.number && this.configPreview.number <= 0) {
            this.configPreview.number = this.defaultPreviewConfig.number;
        }
        // init previews based on currentImage and the full array of images
        this.initPreviews(this.currentImage, this.images);
    }
    /**
     * Method to check if an image is active (i.e. a preview image).
     * @param {?} preview
     * @return {?} boolean true if is active, false otherwise
     */
    isActive(preview) {
        if (!preview || !this.currentImage) {
            return false;
        }
        return preview.id === this.currentImage.id;
    }
    // TODO improve this method to simplify the sourcecode + remove duplicated codelines
    /**
     * Method ´ngOnChanges´ to update `previews` array.
     * Also, both `start` and `end` local variables will be updated accordingly.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called when any data-bound property of a directive changes!!!
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        /** @type {?} */
        const images = changes.images;
        /** @type {?} */
        const currentImage = changes.currentImage;
        /** @type {?} */
        let prev;
        /** @type {?} */
        let current;
        if (currentImage) {
            prev = currentImage.previousValue;
            current = currentImage.currentValue;
        }
        else {
            current = this.currentImage;
        }
        if (current && images && images.previousValue && images.currentValue) {
            // I'm in this if statement, if input images are changed (for instance, because I removed one of them with the 'delete button',
            // or because users changed the images array while modal gallery is still open).
            // In this case, I have to re-init previews, because the input array of images is changed.
            this.initPreviews(current, images.currentValue);
        }
        if (prev && current && prev.id !== current.id) {
            this.updatePreviews(prev, current);
        }
    }
    /**
     * Method called by events from both keyboard and mouse on a preview.
     * This will trigger the `clickpreview` output with the input preview as its payload.
     * @param {?} preview
     * @param {?} event
     * @param {?=} action
     * @return {?}
     */
    onImageEvent(preview, event, action = Action.NORMAL) {
        if (!this.configPreview || !this.configPreview.clickable) {
            return;
        }
        /** @type {?} */
        const result = super.handleImageEvent(event);
        if (result === NEXT || result === PREV) {
            this.clickPreview.emit(new ImageModalEvent(action, getIndex(preview, this.images)));
        }
    }
    /**
     * Method called by events from both keyboard and mouse on a navigation arrow.
     * It also emits an event to specify which arrow.
     * @param {?} direction
     * @param {?} event
     * @param {?=} action
     * @return {?}
     */
    onNavigationEvent(direction, event, action = Action.NORMAL) {
        /** @type {?} */
        const result = super.handleNavigationEvent(direction, event);
        if (result === NEXT) {
            // this.clickArrow.emit(<InteractionEvent>{ source: 'modal-previews', payload: DIRECTION_RIGHT, action: action });
            this.next();
        }
        else if (result === PREV) {
            // this.clickArrow.emit(<InteractionEvent>{ source: 'modal-previews', payload: DIRECTION_LEFT, action: action });
            this.previous();
        }
    }
    /**
     * Method used in the template to track ids in ngFor.
     * @param {?} index
     * @param {?} item
     * @return {?} number the id of the item
     */
    trackById(index, item) {
        return item.id;
    }
    /**
     * Private method to init previews based on the currentImage and the full array of images.
     * The current image in mandatory to show always the current preview (as highlighted).
     * @private
     * @param {?} currentImage
     * @param {?} images
     * @return {?}
     */
    initPreviews(currentImage, images) {
        /** @type {?} */
        let index;
        try {
            index = getIndex(currentImage, images);
        }
        catch (err) {
            throw err;
        }
        switch (index) {
            case 0:
                // first image
                this.setBeginningIndexesPreviews();
                break;
            case images.length - 1:
                // last image
                this.setEndIndexesPreviews();
                break;
            default:
                // other images
                this.setIndexesPreviews();
                break;
        }
        this.previews = images.filter((/**
         * @param {?} img
         * @param {?} i
         * @return {?}
         */
        (img, i) => i >= this.start && i < this.end));
    }
    /**
     * Private method to init both `start` and `end` to the beginning.
     * @private
     * @return {?}
     */
    setBeginningIndexesPreviews() {
        this.start = 0;
        this.end = Math.min((/** @type {?} */ (this.configPreview.number)), this.images.length);
    }
    /**
     * Private method to init both `start` and `end` to the end.
     * @private
     * @return {?}
     */
    setEndIndexesPreviews() {
        this.start = this.images.length - 1 - ((/** @type {?} */ (this.configPreview.number)) - 1);
        this.end = this.images.length;
    }
    /**
     * Private method to update both `start` and `end` based on the currentImage.
     * @private
     * @return {?}
     */
    setIndexesPreviews() {
        this.start = getIndex(this.currentImage, this.images) - Math.floor((/** @type {?} */ (this.configPreview.number)) / 2);
        this.end = getIndex(this.currentImage, this.images) + Math.floor((/** @type {?} */ (this.configPreview.number)) / 2) + 1;
    }
    /**
     * Private method to update the visible previews navigating to the right (next).
     * @private
     * @return {?}
     */
    next() {
        // check if nextImage should be blocked
        if (this.isPreventSliding(this.images.length - 1)) {
            return;
        }
        if (this.end === this.images.length) {
            return;
        }
        this.start++;
        this.end = Math.min(this.end + 1, this.images.length);
        this.previews = this.images.filter((/**
         * @param {?} img
         * @param {?} i
         * @return {?}
         */
        (img, i) => i >= this.start && i < this.end));
    }
    /**
     * Private method to update the visible previews navigating to the left (previous).
     * @private
     * @return {?}
     */
    previous() {
        // check if prevImage should be blocked
        if (this.isPreventSliding(0)) {
            return;
        }
        if (this.start === 0) {
            return;
        }
        this.start = Math.max(this.start - 1, 0);
        this.end = Math.min(this.end - 1, this.images.length);
        this.previews = this.images.filter((/**
         * @param {?} img
         * @param {?} i
         * @return {?}
         */
        (img, i) => i >= this.start && i < this.end));
    }
    /**
     * Private method to block/permit sliding between previews.
     * @private
     * @param {?} boundaryIndex
     * @return {?} boolean if true block sliding, otherwise not
     */
    isPreventSliding(boundaryIndex) {
        return !!this.slideConfig && this.slideConfig.infinite === false && getIndex(this.currentImage, this.images) === boundaryIndex;
    }
    /**
     * Private method to handle navigation changing the previews array and other variables.
     * @private
     * @param {?} prev
     * @param {?} current
     * @return {?}
     */
    updatePreviews(prev, current) {
        // to manage infinite sliding I have to reset both `start` and `end` at the beginning
        // to show again previews from the first image.
        // This happens when you navigate over the last image to return to the first one
        /** @type {?} */
        let prevIndex;
        /** @type {?} */
        let currentIndex;
        try {
            prevIndex = getIndex(prev, this.images);
            currentIndex = getIndex(current, this.images);
        }
        catch (err) {
            console.error('Cannot get previous and current image indexes in previews');
            throw err;
        }
        if (prevIndex === this.images.length - 1 && currentIndex === 0) {
            // first image
            this.setBeginningIndexesPreviews();
            this.previews = this.images.filter((/**
             * @param {?} img
             * @param {?} i
             * @return {?}
             */
            (img, i) => i >= this.start && i < this.end));
            return;
        }
        // the same for the opposite case, when you navigate back from the fist image to go to the last one.
        if (prevIndex === 0 && currentIndex === this.images.length - 1) {
            // last image
            this.setEndIndexesPreviews();
            this.previews = this.images.filter((/**
             * @param {?} img
             * @param {?} i
             * @return {?}
             */
            (img, i) => i >= this.start && i < this.end));
            return;
        }
        // otherwise manage standard scenarios
        if (prevIndex > currentIndex) {
            this.previous();
        }
        else if (prevIndex < currentIndex) {
            this.next();
        }
    }
}
PreviewsComponent.ɵfac = /*@__PURE__*/ function () { let ɵPreviewsComponent_BaseFactory; return function PreviewsComponent_Factory(t) { return (ɵPreviewsComponent_BaseFactory || (ɵPreviewsComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(PreviewsComponent)))(t || PreviewsComponent); }; }();
PreviewsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PreviewsComponent, selectors: [["ks-previews"]], inputs: { currentImage: "currentImage", images: "images", slideConfig: "slideConfig", previewConfig: "previewConfig", accessibilityConfig: "accessibilityConfig" }, outputs: { clickPreview: "clickPreview" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 3, consts: [[1, "previews-container", 3, "title"], [4, "ngIf"], ["role", "button", 1, "nav-left", 3, "tabindex", "click", "keyup"], ["aria-hidden", "true", 3, "title"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["role", "button", 1, "nav-right", 3, "tabindex", "click", "keyup"], ["ksSize", "", "role", "img", 3, "class", "src", "sizeConfig", "title", "alt", "tabindex", "click", "keyup", 4, "ngIf"], ["ksSize", "", "role", "img", 3, "src", "sizeConfig", "title", "alt", "tabindex", "click", "keyup"]], template: function PreviewsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "nav", 0);
        ɵngcc0.ɵɵtemplate(1, PreviewsComponent_ng_container_1_Template, 6, 14, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("title", ctx.accessibilityConfig == null ? null : ctx.accessibilityConfig.previewsContainerTitle);
        ɵngcc0.ɵɵattribute("aria-label", ctx.accessibilityConfig == null ? null : ctx.accessibilityConfig.previewsContainerAriaLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.configPreview == null ? null : ctx.configPreview.visible);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, SizeDirective], styles: ["@media only screen and (max-width:767px),only screen and (max-device-width:767px){.previews-container[_ngcontent-%COMP%], .previews-container[_ngcontent-%COMP%] > .nav-left[_ngcontent-%COMP%], .previews-container[_ngcontent-%COMP%] > .nav-right[_ngcontent-%COMP%], .previews-container[_ngcontent-%COMP%] > .preview-image[_ngcontent-%COMP%]{display:none}}@media only screen and (min-device-width:768px){.previews-container[_ngcontent-%COMP%]{align-items:center;-webkit-animation:.8s fadein-semi-visible08;animation:.8s fadein-semi-visible08;display:flex;flex-direction:row;justify-content:center;margin-bottom:15px}.previews-container[_ngcontent-%COMP%] > .preview-image[_ngcontent-%COMP%]{cursor:pointer;margin-left:2px;margin-right:2px;opacity:.7;height:50px}.previews-container[_ngcontent-%COMP%] > .preview-image.active[_ngcontent-%COMP%]{opacity:1}.previews-container[_ngcontent-%COMP%] > .preview-image.unclickable[_ngcontent-%COMP%]{cursor:not-allowed}.previews-container[_ngcontent-%COMP%] > .preview-image[_ngcontent-%COMP%]:hover{opacity:1;transition:opacity .5s}.previews-container[_ngcontent-%COMP%]   .nav[_ngcontent-%COMP%], .previews-container[_ngcontent-%COMP%] > .nav-left[_ngcontent-%COMP%], .previews-container[_ngcontent-%COMP%] > .nav-right[_ngcontent-%COMP%]{color:#919191;cursor:pointer;transition:.5s}.previews-container[_ngcontent-%COMP%]   .nav[_ngcontent-%COMP%]:hover, .previews-container[_ngcontent-%COMP%] > .nav-left[_ngcontent-%COMP%]:hover, .previews-container[_ngcontent-%COMP%] > .nav-right[_ngcontent-%COMP%]:hover{transform:scale(1.1)}.previews-container[_ngcontent-%COMP%] > .nav-left[_ngcontent-%COMP%]{margin-right:10px}.previews-container[_ngcontent-%COMP%] > .nav-right[_ngcontent-%COMP%]{margin-left:10px}}@-webkit-keyframes fadein-visible{from{opacity:0}to{opacity:1}}@keyframes fadein-visible{from{opacity:0}to{opacity:1}}@-webkit-keyframes fadein-semi-visible05{from{opacity:0}to{opacity:.5}}@keyframes fadein-semi-visible05{from{opacity:0}to{opacity:.5}}@-webkit-keyframes fadein-semi-visible08{from{opacity:0}to{opacity:.8}}@keyframes fadein-semi-visible08{from{opacity:0}to{opacity:.8}}@-webkit-keyframes fadein-semi-visible09{from{opacity:0}to{opacity:.9}}@keyframes fadein-semi-visible09{from{opacity:0}to{opacity:.9}}", _c10], changeDetection: 0 });
PreviewsComponent.propDecorators = {
    currentImage: [{ type: Input }],
    images: [{ type: Input }],
    slideConfig: [{ type: Input }],
    previewConfig: [{ type: Input }],
    accessibilityConfig: [{ type: Input }],
    clickPreview: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PreviewsComponent, [{
        type: Component,
        args: [{
                selector: 'ks-previews',
                template: "<nav class=\"previews-container\"\n     [attr.aria-label]=\"accessibilityConfig?.previewsContainerAriaLabel\"\n     [title]=\"accessibilityConfig?.previewsContainerTitle\">\n\n  <ng-container *ngIf=\"configPreview?.visible\">\n    <a class=\"nav-left\"\n       [attr.aria-label]=\"accessibilityConfig?.previewScrollPrevAriaLabel\"\n       [tabindex]=\"configPreview.arrows && start > 0 ? 0 : -1\" role=\"button\"\n       (click)=\"onNavigationEvent('left', $event)\" (keyup)=\"onNavigationEvent('left', $event)\">\n      <div class=\"inside {{configPreview.arrows && start > 0 ? 'left-arrow-preview-image' : 'empty-arrow-preview-image'}}\"\n           aria-hidden=\"true\"\n           [title]=\"accessibilityConfig?.previewScrollPrevTitle\"></div>\n    </a>\n\n    <ng-container *ngFor=\"let preview of previews; trackBy: trackById; let index = index\">\n      <img *ngIf=\"preview?.modal?.img\"\n           class=\"inside preview-image {{isActive(preview) ? 'active' : ''}}{{!configPreview.clickable ? ' unclickable' : ''}}\"\n           [src]=\"preview.plain?.img ? preview.plain.img : preview.modal.img\"\n           ksSize [sizeConfig]=\"{width: configPreview.size ? configPreview.size.width : defaultPreviewSize.width,\n                                 height: configPreview.size ? configPreview.size.height : defaultPreviewSize.height}\"\n           [attr.aria-label]=\"preview.modal.ariaLabel ? preview.modal.ariaLabel : ''\"\n           [title]=\"preview.modal.title ? preview.modal.title : ''\"\n           alt=\"{{preview.modal.alt ? preview.modal.alt : ''}}\"\n           [tabindex]=\"0\" role=\"img\"\n           (click)=\"onImageEvent(preview, $event, clickAction)\" (keyup)=\"onImageEvent(preview, $event, keyboardAction)\"/>\n    </ng-container>\n\n\n    <a class=\"nav-right\"\n       [attr.aria-label]=\"accessibilityConfig?.previewScrollNextAriaLabel\"\n       [tabindex]=\"configPreview.arrows && end < images.length ? 0 : -1\" role=\"button\"\n       (click)=\"onNavigationEvent('right', $event)\" (keyup)=\"onNavigationEvent('right', $event)\">\n      <div class=\"inside {{configPreview.arrows && end < images.length ? 'right-arrow-preview-image' : 'empty-arrow-preview-image'}}\"\n           aria-hidden=\"true\"\n           [title]=\"accessibilityConfig?.previewScrollNextTitle\"></div>\n    </a>\n  </ng-container>\n\n</nav>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["@media only screen and (max-width:767px),only screen and (max-device-width:767px){.previews-container,.previews-container>.nav-left,.previews-container>.nav-right,.previews-container>.preview-image{display:none}}@media only screen and (min-device-width:768px){.previews-container{align-items:center;-webkit-animation:.8s fadein-semi-visible08;animation:.8s fadein-semi-visible08;display:flex;flex-direction:row;justify-content:center;margin-bottom:15px}.previews-container>.preview-image{cursor:pointer;margin-left:2px;margin-right:2px;opacity:.7;height:50px}.previews-container>.preview-image.active{opacity:1}.previews-container>.preview-image.unclickable{cursor:not-allowed}.previews-container>.preview-image:hover{opacity:1;transition:opacity .5s}.previews-container .nav,.previews-container>.nav-left,.previews-container>.nav-right{color:#919191;cursor:pointer;transition:.5s}.previews-container .nav:hover,.previews-container>.nav-left:hover,.previews-container>.nav-right:hover{transform:scale(1.1)}.previews-container>.nav-left{margin-right:10px}.previews-container>.nav-right{margin-left:10px}}@-webkit-keyframes fadein-visible{from{opacity:0}to{opacity:1}}@keyframes fadein-visible{from{opacity:0}to{opacity:1}}@-webkit-keyframes fadein-semi-visible05{from{opacity:0}to{opacity:.5}}@keyframes fadein-semi-visible05{from{opacity:0}to{opacity:.5}}@-webkit-keyframes fadein-semi-visible08{from{opacity:0}to{opacity:.8}}@keyframes fadein-semi-visible08{from{opacity:0}to{opacity:.8}}@-webkit-keyframes fadein-semi-visible09{from{opacity:0}to{opacity:.9}}@keyframes fadein-semi-visible09{from{opacity:0}to{opacity:.9}}", ".arrow-preview-image,.empty-arrow-preview-image,.left-arrow-preview-image,.right-arrow-preview-image{width:15px;height:15px;opacity:.5}.empty-arrow-preview-image{background:#000;opacity:0}.left-arrow-preview-image{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3Ny4xNzUgNDc3LjE3NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDc3LjE3NSA0NzcuMTc1OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij48Zz48cGF0aCBkPSJNMTQ1LjE4OCwyMzguNTc1bDIxNS41LTIxNS41YzUuMy01LjMsNS4zLTEzLjgsMC0xOS4xcy0xMy44LTUuMy0xOS4xLDBsLTIyNS4xLDIyNS4xYy01LjMsNS4zLTUuMywxMy44LDAsMTkuMWwyMjUuMSwyMjUgICBjMi42LDIuNiw2LjEsNCw5LjUsNHM2LjktMS4zLDkuNS00YzUuMy01LjMsNS4zLTEzLjgsMC0xOS4xTDE0NS4xODgsMjM4LjU3NXoiIGZpbGw9IiNGRkZGRkYiLz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+);background-size:15px;transition:.5s}.left-arrow-preview-image:hover{transform:scale(1.2)}.right-arrow-preview-image{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3Ny4xNzUgNDc3LjE3NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDc3LjE3NSA0NzcuMTc1OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij48Zz48cGF0aCBkPSJNMzYwLjczMSwyMjkuMDc1bC0yMjUuMS0yMjUuMWMtNS4zLTUuMy0xMy44LTUuMy0xOS4xLDBzLTUuMywxMy44LDAsMTkuMWwyMTUuNSwyMTUuNWwtMjE1LjUsMjE1LjUgICBjLTUuMyw1LjMtNS4zLDEzLjgsMCwxOS4xYzIuNiwyLjYsNi4xLDQsOS41LDRjMy40LDAsNi45LTEuMyw5LjUtNGwyMjUuMS0yMjUuMUMzNjUuOTMxLDI0Mi44NzUsMzY1LjkzMSwyMzQuMjc1LDM2MC43MzEsMjI5LjA3NXogICAiIGZpbGw9IiNGRkZGRkYiLz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+);background-size:15px;transition:.5s}.right-arrow-preview-image:hover{transform:scale(1.2)}"]
            }]
    }], null, { clickPreview: [{
            type: Output
        }], currentImage: [{
            type: Input
        }], images: [{
            type: Input
        }], slideConfig: [{
            type: Input
        }], previewConfig: [{
            type: Input
        }], accessibilityConfig: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Component with the loading spinner
 */
class LoadingSpinnerComponent {
    constructor() {
        /**
         * Enum of type `LoadingType` to choose the standard loading spinner.
         * Declared here to be used inside the template.
         */
        this.loadingStandard = LoadingType.STANDARD;
        /**
         * Enum of type `LoadingType` to choose the bars loading spinner.
         * Declared here to be used inside the template.
         */
        this.loadingBars = LoadingType.BARS;
        /**
         * Enum of type `LoadingType` to choose the circular loading spinner.
         * Declared here to be used inside the template.
         */
        this.loadingCircular = LoadingType.CIRCULAR;
        /**
         * Enum of type `LoadingType` to choose the dots loading spinner.
         * Declared here to be used inside the template.
         */
        this.loadingDots = LoadingType.DOTS;
        /**
         * Enum of type `LoadingType` to choose the cube flipping loading spinner.
         * Declared here to be used inside the template.
         */
        this.loadingCubeFlipping = LoadingType.CUBE_FLIPPING;
        /**
         * Enum of type `LoadingType` to choose the circles loading spinner.
         * Declared here to be used inside the template.
         */
        this.loadingCircles = LoadingType.CIRCLES;
        /**
         * Enum of type `LoadingType` to choose the explosing squares loading spinner.
         * Declared here to be used inside the template.
         */
        this.loadingExplosingSquares = LoadingType.EXPLOSING_SQUARES;
    }
}
LoadingSpinnerComponent.ɵfac = function LoadingSpinnerComponent_Factory(t) { return new (t || LoadingSpinnerComponent)(); };
LoadingSpinnerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LoadingSpinnerComponent, selectors: [["ks-loading-spinner"]], inputs: { loadingConfig: "loadingConfig", accessibilityConfig: "accessibilityConfig" }, decls: 9, vars: 10, consts: [[3, "title"], [3, "ngSwitch"], [4, "ngSwitchCase"], [1, "cssload-loader"], [1, "cssload-inner", "cssload-one"], [1, "cssload-inner", "cssload-two"], [1, "cssload-inner", "cssload-three"], [1, "loader-bars"], [1, "loader-circular"], [1, "loader-dots"], [1, "cube-wrapper"], [1, "cube-folding"], [1, "leaf1"], [1, "leaf2"], [1, "leaf3"], [1, "leaf4"], ["id", "preloader"], ["id", "loader"], [1, "loader"]], template: function LoadingSpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementContainerStart(1, 1);
        ɵngcc0.ɵɵtemplate(2, LoadingSpinnerComponent_ng_container_2_Template, 5, 0, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(3, LoadingSpinnerComponent_ng_container_3_Template, 2, 0, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(4, LoadingSpinnerComponent_ng_container_4_Template, 2, 0, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(5, LoadingSpinnerComponent_ng_container_5_Template, 2, 0, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(6, LoadingSpinnerComponent_ng_container_6_Template, 7, 0, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(7, LoadingSpinnerComponent_ng_container_7_Template, 3, 0, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(8, LoadingSpinnerComponent_ng_container_8_Template, 6, 0, "ng-container", 2);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("title", ctx.accessibilityConfig == null ? null : ctx.accessibilityConfig.loadingSpinnerTitle);
        ɵngcc0.ɵɵattribute("aria-label", ctx.accessibilityConfig == null ? null : ctx.accessibilityConfig.loadingSpinnerAriaLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.loadingConfig.type);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.loadingStandard);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.loadingBars);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.loadingCircular);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.loadingDots);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.loadingCubeFlipping);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.loadingCircles);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.loadingExplosingSquares);
    } }, directives: [ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase], styles: [".cssload-loader[_ngcontent-%COMP%]{position:absolute;top:0;bottom:0;right:0;left:0;margin:auto;width:64px;height:64px;border-radius:50%;-o-border-radius:50%;-ms-border-radius:50%;-webkit-border-radius:50%;-moz-border-radius:50%;perspective:800px}.cssload-inner[_ngcontent-%COMP%]{position:absolute;width:100%;height:100%;box-sizing:border-box;-o-box-sizing:border-box;-ms-box-sizing:border-box;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;border-radius:50%;-o-border-radius:50%;-ms-border-radius:50%;-webkit-border-radius:50%;-moz-border-radius:50%}.cssload-inner.cssload-one[_ngcontent-%COMP%]{left:0;top:0;animation:.6s linear infinite cssload-rotate-one;-o-animation:.6s linear infinite cssload-rotate-one;-ms-animation:cssload-rotate-one .6s linear infinite;-webkit-animation:.6s linear infinite cssload-rotate-one;-moz-animation:.6s linear infinite cssload-rotate-one;border-bottom:3px solid rgba(255,255,255,.99)}.cssload-inner.cssload-two[_ngcontent-%COMP%]{right:0;top:0;animation:.6s linear infinite cssload-rotate-two;-o-animation:.6s linear infinite cssload-rotate-two;-ms-animation:cssload-rotate-two .6s linear infinite;-webkit-animation:.6s linear infinite cssload-rotate-two;-moz-animation:.6s linear infinite cssload-rotate-two;border-right:3px solid #fff}.cssload-inner.cssload-three[_ngcontent-%COMP%]{right:0;bottom:0;animation:.6s linear infinite cssload-rotate-three;-o-animation:.6s linear infinite cssload-rotate-three;-ms-animation:cssload-rotate-three .6s linear infinite;-webkit-animation:.6s linear infinite cssload-rotate-three;-moz-animation:.6s linear infinite cssload-rotate-three;border-top:3px solid #fff}@keyframes cssload-rotate-one{0%{transform:rotateX(35deg) rotateY(-45deg) rotateZ(0)}100%{transform:rotateX(35deg) rotateY(-45deg) rotateZ(360deg)}}@-webkit-keyframes cssload-rotate-one{0%{-webkit-transform:rotateX(35deg) rotateY(-45deg) rotateZ(0)}100%{-webkit-transform:rotateX(35deg) rotateY(-45deg) rotateZ(360deg)}}@keyframes cssload-rotate-two{0%{transform:rotateX(50deg) rotateY(10deg) rotateZ(0)}100%{transform:rotateX(50deg) rotateY(10deg) rotateZ(360deg)}}@-webkit-keyframes cssload-rotate-two{0%{-webkit-transform:rotateX(50deg) rotateY(10deg) rotateZ(0)}100%{-webkit-transform:rotateX(50deg) rotateY(10deg) rotateZ(360deg)}}@keyframes cssload-rotate-three{0%{transform:rotateX(35deg) rotateY(55deg) rotateZ(0)}100%{transform:rotateX(35deg) rotateY(55deg) rotateZ(360deg)}}@-webkit-keyframes cssload-rotate-three{0%{-webkit-transform:rotateX(35deg) rotateY(55deg) rotateZ(0)}100%{-webkit-transform:rotateX(35deg) rotateY(55deg) rotateZ(360deg)}}", ".loader-dots[_ngcontent-%COMP%]{position:absolute;top:0;bottom:0;right:0;left:0;color:#fefcff;font-size:10px;margin:auto;width:1em;height:1em;border-radius:50%;text-indent:-9999em;-webkit-animation:1.3s linear infinite load4;animation:1.3s linear infinite load4;transform:translateZ(0)}@-webkit-keyframes load4{0%,100%{box-shadow:0 -3em 0 .2em,2em -2em 0 0,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 0}12.5%{box-shadow:0 -3em 0 0,2em -2em 0 .2em,3em 0 0 0,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}25%{box-shadow:0 -3em 0 -.5em,2em -2em 0 0,3em 0 0 .2em,2em 2em 0 0,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}37.5%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 0,2em 2em 0 .2em,0 3em 0 0,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}50%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 0,0 3em 0 .2em,-2em 2em 0 0,-3em 0 0 -1em,-2em -2em 0 -1em}62.5%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 0,-2em 2em 0 .2em,-3em 0 0 0,-2em -2em 0 -1em}75%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 0,-3em 0 0 .2em,-2em -2em 0 0}87.5%{box-shadow:0 -3em 0 0,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 0,-3em 0 0 0,-2em -2em 0 .2em}}@keyframes load4{0%,100%{box-shadow:0 -3em 0 .2em,2em -2em 0 0,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 0}12.5%{box-shadow:0 -3em 0 0,2em -2em 0 .2em,3em 0 0 0,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}25%{box-shadow:0 -3em 0 -.5em,2em -2em 0 0,3em 0 0 .2em,2em 2em 0 0,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}37.5%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 0,2em 2em 0 .2em,0 3em 0 0,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}50%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 0,0 3em 0 .2em,-2em 2em 0 0,-3em 0 0 -1em,-2em -2em 0 -1em}62.5%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 0,-2em 2em 0 .2em,-3em 0 0 0,-2em -2em 0 -1em}75%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 0,-3em 0 0 .2em,-2em -2em 0 0}87.5%{box-shadow:0 -3em 0 0,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 0,-3em 0 0 0,-2em -2em 0 .2em}}", ".loader-bars[_ngcontent-%COMP%], .loader-bars[_ngcontent-%COMP%]:after, .loader-bars[_ngcontent-%COMP%]:before{background:#fefcff;-webkit-animation:1s ease-in-out infinite load1;animation:1s ease-in-out infinite load1;width:1em;height:4em}.loader-bars[_ngcontent-%COMP%]{position:absolute;top:0;bottom:0;right:0;left:0;color:#fefcff;text-indent:-9999em;margin:auto;font-size:11px;transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader-bars[_ngcontent-%COMP%]:after, .loader-bars[_ngcontent-%COMP%]:before{position:absolute;top:0;content:''}.loader-bars[_ngcontent-%COMP%]:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader-bars[_ngcontent-%COMP%]:after{left:1.5em}@-webkit-keyframes load1{0%,100%,80%{box-shadow:0 0;height:4em}40%{box-shadow:0 -2em;height:5em}}@keyframes load1{0%,100%,80%{box-shadow:0 0;height:4em}40%{box-shadow:0 -2em;height:5em}}", ".loader-circular[_ngcontent-%COMP%], .loader-circular[_ngcontent-%COMP%]:after{border-radius:50%;width:10em;height:10em}.loader-circular[_ngcontent-%COMP%]{position:absolute;top:0;bottom:0;right:0;left:0;margin:auto;font-size:10px;text-indent:-9999em;border-top:1.1em solid rgba(255,255,255,.2);border-right:1.1em solid rgba(255,255,255,.2);border-bottom:1.1em solid rgba(255,255,255,.2);border-left:1.1em solid #fff;transform:translateZ(0);-webkit-animation:1.1s linear infinite load8;animation:1.1s linear infinite load8}@-webkit-keyframes load8{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes load8{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}", ".cube-folding[_ngcontent-%COMP%]{width:50px;height:50px;display:inline-block;transform:rotate(45deg);font-size:0}.cube-folding[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{position:relative;width:25px;height:25px;transform:scale(1.1);display:inline-block}.cube-folding[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]::before{content:'';background-color:#fff;position:absolute;left:0;top:0;display:block;width:25px;height:25px;transform-origin:100% 100%;-webkit-animation:2.5s linear infinite both folding;animation:2.5s linear infinite both folding}.cube-folding[_ngcontent-%COMP%]   .leaf2[_ngcontent-%COMP%]{transform:rotateZ(90deg) scale(1.1)}.cube-folding[_ngcontent-%COMP%]   .leaf2[_ngcontent-%COMP%]::before{-webkit-animation-delay:.3s;animation-delay:.3s;background-color:#f2f2f2}.cube-folding[_ngcontent-%COMP%]   .leaf3[_ngcontent-%COMP%]{transform:rotateZ(270deg) scale(1.1)}.cube-folding[_ngcontent-%COMP%]   .leaf3[_ngcontent-%COMP%]::before{-webkit-animation-delay:.9s;animation-delay:.9s;background-color:#f2f2f2}.cube-folding[_ngcontent-%COMP%]   .leaf4[_ngcontent-%COMP%]{transform:rotateZ(180deg) scale(1.1)}.cube-folding[_ngcontent-%COMP%]   .leaf4[_ngcontent-%COMP%]::before{-webkit-animation-delay:.6s;animation-delay:.6s;background-color:#e6e6e6}@-webkit-keyframes folding{0%,10%{transform:perspective(140px) rotateX(-180deg);opacity:0}25%,75%{transform:perspective(140px) rotateX(0);opacity:1}100%,90%{transform:perspective(140px) rotateY(180deg);opacity:0}}@keyframes folding{0%,10%{transform:perspective(140px) rotateX(-180deg);opacity:0}25%,75%{transform:perspective(140px) rotateX(0);opacity:1}100%,90%{transform:perspective(140px) rotateY(180deg);opacity:0}}.cube-wrapper[_ngcontent-%COMP%]{position:fixed;left:50%;top:50%;margin-top:-50px;margin-left:-50px;width:100px;height:100px;text-align:center}@-webkit-keyframes text{100%{top:35px}}@keyframes text{100%{top:35px}}@-webkit-keyframes shadow{100%{bottom:-18px;width:100px}}@keyframes shadow{100%{bottom:-18px;width:100px}}", "#preloader[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:100%}#loader[_ngcontent-%COMP%]{display:block;position:relative;left:50%;top:50%;width:100px;height:100px;margin:-75px 0 0 -75px;border-radius:50%;border:3px solid transparent;border-top-color:#b4b4b4;-webkit-animation:2s linear infinite spin;animation:2s linear infinite spin}#loader[_ngcontent-%COMP%]:before{content:\"\";position:absolute;top:5px;left:5px;right:5px;bottom:5px;border-radius:50%;border:3px solid transparent;border-top-color:#d9d9d9;-webkit-animation:3s linear infinite spin;animation:3s linear infinite spin}#loader[_ngcontent-%COMP%]:after{content:\"\";position:absolute;top:15px;left:15px;right:15px;bottom:15px;border-radius:50%;border:3px solid transparent;border-top-color:#fff;-webkit-animation:1.5s linear infinite spin;animation:1.5s linear infinite spin}@-webkit-keyframes spin{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes spin{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}", "@-webkit-keyframes loader{0%,10%,100%{width:60px;height:60px}65%{width:150px;height:150px}}@keyframes loader{0%,10%,100%{width:60px;height:60px}65%{width:150px;height:150px}}@-webkit-keyframes loaderBlock{0%,30%{transform:rotate(0)}55%{background-color:#b4b4b4}100%{transform:rotate(90deg)}}@keyframes loaderBlock{0%,30%{transform:rotate(0)}55%{background-color:#b4b4b4}100%{transform:rotate(90deg)}}@-webkit-keyframes loaderBlockInverse{0%,20%{transform:rotate(0)}55%{background-color:#d9d9d9}100%{transform:rotate(-90deg)}}@keyframes loaderBlockInverse{0%,20%{transform:rotate(0)}55%{background-color:#d9d9d9}100%{transform:rotate(-90deg)}}.loader[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;width:60px;height:60px;transform:translate(-50%,-50%) rotate(45deg) translate3d(0,0,0);-webkit-animation:1.2s ease-in-out infinite loader;animation:1.2s ease-in-out infinite loader}.loader[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{position:absolute;display:block;width:40px;height:40px;background-color:#fff;-webkit-animation:1.2s ease-in-out infinite both loaderBlock;animation:1.2s ease-in-out infinite both loaderBlock}.loader[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-child(1){top:0;left:0}.loader[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-child(2){top:0;right:0;-webkit-animation:1.2s ease-in-out infinite both loaderBlockInverse;animation:1.2s ease-in-out infinite both loaderBlockInverse}.loader[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-child(3){bottom:0;left:0;-webkit-animation:1.2s ease-in-out infinite both loaderBlockInverse;animation:1.2s ease-in-out infinite both loaderBlockInverse}.loader[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-child(4){bottom:0;right:0}"], changeDetection: 0 });
LoadingSpinnerComponent.propDecorators = {
    loadingConfig: [{ type: Input }],
    accessibilityConfig: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoadingSpinnerComponent, [{
        type: Component,
        args: [{
                selector: 'ks-loading-spinner',
                template: "<div [attr.aria-label]=\"accessibilityConfig?.loadingSpinnerAriaLabel\"\n     [title]=\"accessibilityConfig?.loadingSpinnerTitle\">\n\n  <ng-container [ngSwitch]=\"loadingConfig.type\">\n    <ng-container *ngSwitchCase=\"loadingStandard\">\n      <div class=\"cssload-loader\">\n        <div class=\"cssload-inner cssload-one\"></div>\n        <div class=\"cssload-inner cssload-two\"></div>\n        <div class=\"cssload-inner cssload-three\"></div>\n      </div>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"loadingBars\">\n      <div class=\"loader-bars\">\n      </div>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"loadingCircular\">\n      <div class=\"loader-circular\">\n      </div>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"loadingDots\">\n      <div class=\"loader-dots\">\n      </div>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"loadingCubeFlipping\">\n      <div class=\"cube-wrapper\">\n        <div class=\"cube-folding\">\n          <span class=\"leaf1\"></span>\n          <span class=\"leaf2\"></span>\n          <span class=\"leaf3\"></span>\n          <span class=\"leaf4\"></span>\n        </div>\n      </div>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"loadingCircles\">\n      <div id=\"preloader\">\n        <div id=\"loader\"></div>\n      </div>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"loadingExplosingSquares\">\n      <div class=\"loader\">\n        <span></span>\n        <span></span>\n        <span></span>\n        <span></span>\n      </div>\n    </ng-container>\n    <!--<ng-container *ngSwitchDefault>-->\n    <!---->\n    <!--</ng-container>-->\n  </ng-container>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".cssload-loader{position:absolute;top:0;bottom:0;right:0;left:0;margin:auto;width:64px;height:64px;border-radius:50%;-o-border-radius:50%;-ms-border-radius:50%;-webkit-border-radius:50%;-moz-border-radius:50%;perspective:800px}.cssload-inner{position:absolute;width:100%;height:100%;box-sizing:border-box;-o-box-sizing:border-box;-ms-box-sizing:border-box;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;border-radius:50%;-o-border-radius:50%;-ms-border-radius:50%;-webkit-border-radius:50%;-moz-border-radius:50%}.cssload-inner.cssload-one{left:0;top:0;animation:.6s linear infinite cssload-rotate-one;-o-animation:.6s linear infinite cssload-rotate-one;-ms-animation:cssload-rotate-one .6s linear infinite;-webkit-animation:.6s linear infinite cssload-rotate-one;-moz-animation:.6s linear infinite cssload-rotate-one;border-bottom:3px solid rgba(255,255,255,.99)}.cssload-inner.cssload-two{right:0;top:0;animation:.6s linear infinite cssload-rotate-two;-o-animation:.6s linear infinite cssload-rotate-two;-ms-animation:cssload-rotate-two .6s linear infinite;-webkit-animation:.6s linear infinite cssload-rotate-two;-moz-animation:.6s linear infinite cssload-rotate-two;border-right:3px solid #fff}.cssload-inner.cssload-three{right:0;bottom:0;animation:.6s linear infinite cssload-rotate-three;-o-animation:.6s linear infinite cssload-rotate-three;-ms-animation:cssload-rotate-three .6s linear infinite;-webkit-animation:.6s linear infinite cssload-rotate-three;-moz-animation:.6s linear infinite cssload-rotate-three;border-top:3px solid #fff}@keyframes cssload-rotate-one{0%{transform:rotateX(35deg) rotateY(-45deg) rotateZ(0)}100%{transform:rotateX(35deg) rotateY(-45deg) rotateZ(360deg)}}@-webkit-keyframes cssload-rotate-one{0%{-webkit-transform:rotateX(35deg) rotateY(-45deg) rotateZ(0)}100%{-webkit-transform:rotateX(35deg) rotateY(-45deg) rotateZ(360deg)}}@keyframes cssload-rotate-two{0%{transform:rotateX(50deg) rotateY(10deg) rotateZ(0)}100%{transform:rotateX(50deg) rotateY(10deg) rotateZ(360deg)}}@-webkit-keyframes cssload-rotate-two{0%{-webkit-transform:rotateX(50deg) rotateY(10deg) rotateZ(0)}100%{-webkit-transform:rotateX(50deg) rotateY(10deg) rotateZ(360deg)}}@keyframes cssload-rotate-three{0%{transform:rotateX(35deg) rotateY(55deg) rotateZ(0)}100%{transform:rotateX(35deg) rotateY(55deg) rotateZ(360deg)}}@-webkit-keyframes cssload-rotate-three{0%{-webkit-transform:rotateX(35deg) rotateY(55deg) rotateZ(0)}100%{-webkit-transform:rotateX(35deg) rotateY(55deg) rotateZ(360deg)}}", ".loader-dots{position:absolute;top:0;bottom:0;right:0;left:0;color:#fefcff;font-size:10px;margin:auto;width:1em;height:1em;border-radius:50%;text-indent:-9999em;-webkit-animation:1.3s linear infinite load4;animation:1.3s linear infinite load4;transform:translateZ(0)}@-webkit-keyframes load4{0%,100%{box-shadow:0 -3em 0 .2em,2em -2em 0 0,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 0}12.5%{box-shadow:0 -3em 0 0,2em -2em 0 .2em,3em 0 0 0,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}25%{box-shadow:0 -3em 0 -.5em,2em -2em 0 0,3em 0 0 .2em,2em 2em 0 0,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}37.5%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 0,2em 2em 0 .2em,0 3em 0 0,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}50%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 0,0 3em 0 .2em,-2em 2em 0 0,-3em 0 0 -1em,-2em -2em 0 -1em}62.5%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 0,-2em 2em 0 .2em,-3em 0 0 0,-2em -2em 0 -1em}75%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 0,-3em 0 0 .2em,-2em -2em 0 0}87.5%{box-shadow:0 -3em 0 0,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 0,-3em 0 0 0,-2em -2em 0 .2em}}@keyframes load4{0%,100%{box-shadow:0 -3em 0 .2em,2em -2em 0 0,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 0}12.5%{box-shadow:0 -3em 0 0,2em -2em 0 .2em,3em 0 0 0,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}25%{box-shadow:0 -3em 0 -.5em,2em -2em 0 0,3em 0 0 .2em,2em 2em 0 0,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}37.5%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 0,2em 2em 0 .2em,0 3em 0 0,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em}50%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 0,0 3em 0 .2em,-2em 2em 0 0,-3em 0 0 -1em,-2em -2em 0 -1em}62.5%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 0,-2em 2em 0 .2em,-3em 0 0 0,-2em -2em 0 -1em}75%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 0,-3em 0 0 .2em,-2em -2em 0 0}87.5%{box-shadow:0 -3em 0 0,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 0,-3em 0 0 0,-2em -2em 0 .2em}}", ".loader-bars,.loader-bars:after,.loader-bars:before{background:#fefcff;-webkit-animation:1s ease-in-out infinite load1;animation:1s ease-in-out infinite load1;width:1em;height:4em}.loader-bars{position:absolute;top:0;bottom:0;right:0;left:0;color:#fefcff;text-indent:-9999em;margin:auto;font-size:11px;transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader-bars:after,.loader-bars:before{position:absolute;top:0;content:''}.loader-bars:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader-bars:after{left:1.5em}@-webkit-keyframes load1{0%,100%,80%{box-shadow:0 0;height:4em}40%{box-shadow:0 -2em;height:5em}}@keyframes load1{0%,100%,80%{box-shadow:0 0;height:4em}40%{box-shadow:0 -2em;height:5em}}", ".loader-circular,.loader-circular:after{border-radius:50%;width:10em;height:10em}.loader-circular{position:absolute;top:0;bottom:0;right:0;left:0;margin:auto;font-size:10px;text-indent:-9999em;border-top:1.1em solid rgba(255,255,255,.2);border-right:1.1em solid rgba(255,255,255,.2);border-bottom:1.1em solid rgba(255,255,255,.2);border-left:1.1em solid #fff;transform:translateZ(0);-webkit-animation:1.1s linear infinite load8;animation:1.1s linear infinite load8}@-webkit-keyframes load8{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes load8{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}", ".cube-folding{width:50px;height:50px;display:inline-block;transform:rotate(45deg);font-size:0}.cube-folding span{position:relative;width:25px;height:25px;transform:scale(1.1);display:inline-block}.cube-folding span::before{content:'';background-color:#fff;position:absolute;left:0;top:0;display:block;width:25px;height:25px;transform-origin:100% 100%;-webkit-animation:2.5s linear infinite both folding;animation:2.5s linear infinite both folding}.cube-folding .leaf2{transform:rotateZ(90deg) scale(1.1)}.cube-folding .leaf2::before{-webkit-animation-delay:.3s;animation-delay:.3s;background-color:#f2f2f2}.cube-folding .leaf3{transform:rotateZ(270deg) scale(1.1)}.cube-folding .leaf3::before{-webkit-animation-delay:.9s;animation-delay:.9s;background-color:#f2f2f2}.cube-folding .leaf4{transform:rotateZ(180deg) scale(1.1)}.cube-folding .leaf4::before{-webkit-animation-delay:.6s;animation-delay:.6s;background-color:#e6e6e6}@-webkit-keyframes folding{0%,10%{transform:perspective(140px) rotateX(-180deg);opacity:0}25%,75%{transform:perspective(140px) rotateX(0);opacity:1}100%,90%{transform:perspective(140px) rotateY(180deg);opacity:0}}@keyframes folding{0%,10%{transform:perspective(140px) rotateX(-180deg);opacity:0}25%,75%{transform:perspective(140px) rotateX(0);opacity:1}100%,90%{transform:perspective(140px) rotateY(180deg);opacity:0}}.cube-wrapper{position:fixed;left:50%;top:50%;margin-top:-50px;margin-left:-50px;width:100px;height:100px;text-align:center}@-webkit-keyframes text{100%{top:35px}}@keyframes text{100%{top:35px}}@-webkit-keyframes shadow{100%{bottom:-18px;width:100px}}@keyframes shadow{100%{bottom:-18px;width:100px}}", "#preloader{position:fixed;top:0;left:0;width:100%;height:100%}#loader{display:block;position:relative;left:50%;top:50%;width:100px;height:100px;margin:-75px 0 0 -75px;border-radius:50%;border:3px solid transparent;border-top-color:#b4b4b4;-webkit-animation:2s linear infinite spin;animation:2s linear infinite spin}#loader:before{content:\"\";position:absolute;top:5px;left:5px;right:5px;bottom:5px;border-radius:50%;border:3px solid transparent;border-top-color:#d9d9d9;-webkit-animation:3s linear infinite spin;animation:3s linear infinite spin}#loader:after{content:\"\";position:absolute;top:15px;left:15px;right:15px;bottom:15px;border-radius:50%;border:3px solid transparent;border-top-color:#fff;-webkit-animation:1.5s linear infinite spin;animation:1.5s linear infinite spin}@-webkit-keyframes spin{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes spin{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}", "@-webkit-keyframes loader{0%,10%,100%{width:60px;height:60px}65%{width:150px;height:150px}}@keyframes loader{0%,10%,100%{width:60px;height:60px}65%{width:150px;height:150px}}@-webkit-keyframes loaderBlock{0%,30%{transform:rotate(0)}55%{background-color:#b4b4b4}100%{transform:rotate(90deg)}}@keyframes loaderBlock{0%,30%{transform:rotate(0)}55%{background-color:#b4b4b4}100%{transform:rotate(90deg)}}@-webkit-keyframes loaderBlockInverse{0%,20%{transform:rotate(0)}55%{background-color:#d9d9d9}100%{transform:rotate(-90deg)}}@keyframes loaderBlockInverse{0%,20%{transform:rotate(0)}55%{background-color:#d9d9d9}100%{transform:rotate(-90deg)}}.loader{position:absolute;top:50%;left:50%;width:60px;height:60px;transform:translate(-50%,-50%) rotate(45deg) translate3d(0,0,0);-webkit-animation:1.2s ease-in-out infinite loader;animation:1.2s ease-in-out infinite loader}.loader span{position:absolute;display:block;width:40px;height:40px;background-color:#fff;-webkit-animation:1.2s ease-in-out infinite both loaderBlock;animation:1.2s ease-in-out infinite both loaderBlock}.loader span:nth-child(1){top:0;left:0}.loader span:nth-child(2){top:0;right:0;-webkit-animation:1.2s ease-in-out infinite both loaderBlockInverse;animation:1.2s ease-in-out infinite both loaderBlockInverse}.loader span:nth-child(3){bottom:0;left:0;-webkit-animation:1.2s ease-in-out infinite both loaderBlockInverse;animation:1.2s ease-in-out infinite both loaderBlockInverse}.loader span:nth-child(4){bottom:0;right:0}"]
            }]
    }], function () { return []; }, { loadingConfig: [{
            type: Input
        }], accessibilityConfig: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Component with the gallery of thumbs.
 * In receives an array of Images, a boolean to show/hide
 * the gallery (feature used by imagePointer) and a config
 * object to customize the behaviour of this component.
 * Also, it emits click events as outputs.
 */
class PlainGalleryComponent {
    constructor() {
        /**
         * Output to emit an event when an image is changed.
         */
        this.show = new EventEmitter();
        /**
         * Bi-dimensional array of `Image` object to store images to display as plain gallery.
         * [] by default.
         */
        this.imageGrid = [];
        /**
         * Boolean passed as input to `ks-wrap` directive to configure flex-wrap css property.
         * However it's not enough, because you need to limit the width using `widthStyle` public variable.
         * For more info check https://developer.mozilla.org/it/docs/Web/CSS/flex-wrap
         */
        this.wrapStyle = false;
        /**
         * String passed as input to `ks-wrap` directive to set width to be able to force overflow.
         * In this way, `wrapStyle` (flex-wrap css property) will be used as requested.
         */
        this.widthStyle = '';
        /**
         * Default image size object
         */
        this.defaultSize = { width: '50px', height: 'auto' };
        /**
         * Default layout config object
         * Note that length=-1 means infinity
         */
        this.defaultLayout = new LineLayout(this.defaultSize, { length: -1, wrap: false }, 'flex-start');
        /**
         * Default plain gallery config object
         */
        this.defaultPlainConfig = {
            strategy: PlainGalleryStrategy.ROW,
            layout: this.defaultLayout,
            advanced: { aTags: false, additionalBackground: '50% 50%/cover' }
        };
    }
    /**
     * Method ´ngOnChanges´ to update both `imageGrid` and`configPlainGallery`.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called when any data-bound property of a directive changes!!!
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        /** @type {?} */
        const imagesChange = changes.images;
        /** @type {?} */
        const configChange = changes.plainGalleryConfig;
        // I'm using !change.firstChange because the first time will be called both onInit and onChange and I don't
        // want to execute initialization two times.
        if (configChange &&
            !configChange.firstChange &&
            (configChange.previousValue !== configChange.currentValue || (!configChange.previousValue && !configChange.currentValue))) {
            this.configPlainGallery = this.initPlainGalleryConfig();
        }
        if (imagesChange && !imagesChange.firstChange && imagesChange.previousValue !== imagesChange.currentValue) {
            this.initImageGrid();
        }
    }
    /**
     * Method ´ngOnInit´ to init both `configPlainGallery` calling `initPlainGalleryConfig()`
     * and `imageGrid invoking `initImageGrid()`.
     * This is an Angular's lifecycle hook, so its called automatically by Angular itself.
     * In particular, it's called only one time!!!
     * @return {?}
     */
    ngOnInit() {
        this.configPlainGallery = this.initPlainGalleryConfig();
        this.initImageGrid();
    }
    /**
     * Method called when you click on an image of the plain (or inline) gallery.
     * This will emit the show event with the index number as payload.
     * @param {?} index
     * @return {?}
     */
    showModalGallery(index) {
        this.show.emit(index);
    }
    /**
     * Method called when you click on an image of the plain (or inline) gallery.
     * This will emit the show event with the image as payload.
     * @param {?} img
     * @return {?}
     */
    showModalGalleryByImage(img) {
        /** @type {?} */
        const index = this.images.findIndex((/**
         * @param {?} val
         * @return {?}
         */
        (val) => val && img && val.id === img.id));
        this.showModalGallery(index);
    }
    /**
     * Method to get `alt attribute`.
     * `alt` specifies an alternate text for an image, if the image cannot be displayed.
     * @param {?} image
     * @return {?} string alt description of the image
     */
    getAltPlainDescriptionByImage(image) {
        if (!image) {
            return '';
        }
        return image.plain && image.plain.description ? image.plain.description : `Image ${getIndex(image, this.images) + 1}`;
    }
    /**
     * Method to get the title for an image.
     * @param {?} image
     * @return {?} string the title of the input image
     */
    getTitleDisplay(image) {
        /** @type {?} */
        let description = '';
        if (image.plain && image.plain.description) {
            description = image.plain.description;
        }
        else if (image.modal && image.modal.description) {
            description = image.modal.description;
        }
        /** @type {?} */
        const currentIndex = getIndex(image, this.images);
        /** @type {?} */
        const prevDescription = 'Image ' + (currentIndex + 1) + '/' + this.images.length;
        /** @type {?} */
        let currImgDescription = description ? description : '';
        if (currImgDescription !== '') {
            currImgDescription = ' - ' + currImgDescription;
        }
        return prevDescription + currImgDescription;
    }
    /**
     * Method used in the template to track ids in ngFor.
     * @param {?} index
     * @param {?} item
     * @return {?} number the id of the item
     */
    trackById(index, item) {
        return item.id;
    }
    /**
     * Private method to build and return a `PlainGalleryConfig` object, proving also default values.
     * @throws an Error if layout and strategy aren't compatible
     * @private
     * @return {?} PlainGalleryConfig the plain gallery configuration
     */
    initPlainGalleryConfig() {
        /** @type {?} */
        const config = Object.assign({}, this.defaultPlainConfig, this.plainGalleryConfig);
        if (config.layout instanceof LineLayout) {
            if (config.strategy !== PlainGalleryStrategy.ROW && config.strategy !== PlainGalleryStrategy.COLUMN) {
                throw new Error('LineLayout requires either ROW or COLUMN strategy');
            }
            if (!config.layout || !config.layout.breakConfig) {
                throw new Error('Both layout and breakConfig must be valid');
            }
        }
        if (config.layout instanceof GridLayout) {
            if (config.strategy !== PlainGalleryStrategy.GRID) {
                throw new Error('GridLayout requires GRID strategy');
            }
            if (!config.layout || !config.layout.breakConfig) {
                throw new Error('Both layout and breakConfig must be valid');
            }
            // force wrap for grid layout
            config.layout.breakConfig.wrap = true;
        }
        if (config.layout instanceof AdvancedLayout) {
            if (config.strategy !== PlainGalleryStrategy.CUSTOM) {
                throw new Error('AdvancedLayout requires CUSTOM strategy');
            }
        }
        return config;
    }
    /**
     * Private method to init both `imageGrid` and other style variables,
     * based on the layout type.
     * @private
     * @return {?}
     */
    initImageGrid() {
        /** @type {?} */
        const config = this.configPlainGallery;
        // reset the array to prevent issues in case of GridLayout
        this.imageGrid = [];
        if (config.layout instanceof LineLayout) {
            /** @type {?} */
            const layout = config.layout;
            /** @type {?} */
            const row = this.images.filter((/**
             * @param {?} val
             * @param {?} i
             * @return {?}
             */
            (val, i) => i < layout.breakConfig.length || layout.breakConfig.length === -1));
            this.imageGrid = [row];
            this.size = config.layout.size;
            switch (config.strategy) {
                case PlainGalleryStrategy.ROW:
                    this.directionStyle = 'row';
                    break;
                case PlainGalleryStrategy.COLUMN:
                    this.directionStyle = 'column';
                    this.wrapStyle = layout.breakConfig.wrap;
                    break;
            }
            this.justifyStyle = layout.justify;
        }
        if (config.layout instanceof GridLayout) {
            /** @type {?} */
            const layout = config.layout;
            /** @type {?} */
            const count = Math.ceil(this.images.length / layout.breakConfig.length);
            /** @type {?} */
            let start = 0;
            /** @type {?} */
            let end = layout.breakConfig.length - 1;
            for (let j = 0; j < count; j++) {
                /** @type {?} */
                const row = this.images.filter((/**
                 * @param {?} val
                 * @param {?} i
                 * @return {?}
                 */
                (val, i) => i >= start && i <= end));
                this.imageGrid.push(row);
                start = end + 1;
                end = start + layout.breakConfig.length - 1;
            }
            this.size = config.layout.size;
            /** @type {?} */
            const pixels = +layout.size.width.replace('px', '');
            this.widthStyle = pixels * layout.breakConfig.length + pixels / 2 + 'px';
            this.wrapStyle = layout.breakConfig.wrap;
            this.directionStyle = 'row';
        }
        if (config.layout instanceof AdvancedLayout) {
            this.imageGrid = [this.images];
        }
    }
}
PlainGalleryComponent.ɵfac = function PlainGalleryComponent_Factory(t) { return new (t || PlainGalleryComponent)(); };
PlainGalleryComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PlainGalleryComponent, selectors: [["ks-plain-gallery"]], inputs: { images: "images", showGallery: "showGallery", plainGalleryConfig: "plainGalleryConfig", accessibilityConfig: "accessibilityConfig" }, outputs: { show: "show" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "plain-container", "ksWrap", "", "ksDirection", "", 3, "wrap", "width", "direction", "justify", "title", 4, "ngIf"], ["ksWrap", "", "ksDirection", "", 1, "plain-container", 3, "wrap", "width", "direction", "justify", "title"], [4, "ngFor", "ngForOf"], [4, "ngIf", "ngIfElse"], ["aTags", ""], ["class", "image", "ksSize", "", "role", "img", 3, "src", "sizeConfig", "title", "alt", "tabindex", "click", "keyup", 4, "ngIf"], ["ksSize", "", "role", "img", 1, "image", 3, "src", "sizeConfig", "title", "alt", "tabindex", "click", "keyup"], ["class", "a-tag-image", "ksATagBgImage", "", "ksSize", "", 3, "image", "style", "sizeConfig", "title", "tabindex", "click", "keyup", 4, "ngIf"], ["ksATagBgImage", "", "ksSize", "", 1, "a-tag-image", 3, "image", "sizeConfig", "title", "tabindex", "click", "keyup"]], template: function PlainGalleryComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PlainGalleryComponent_div_0_Template, 2, 7, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showGallery);
    } }, directives: [ɵngcc1.NgIf, WrapDirective, DirectionDirective, ɵngcc1.NgForOf, SizeDirective, ATagBgImageDirective], styles: [".plain-container[_ngcontent-%COMP%]{align-items:center;display:flex}.plain-container[_ngcontent-%COMP%]   .image[_ngcontent-%COMP%]{cursor:pointer;height:auto;width:50px;margin:2px}.plain-container[_ngcontent-%COMP%]   .a-tag-image[_ngcontent-%COMP%]{cursor:pointer;margin:2px}"], changeDetection: 0 });
PlainGalleryComponent.propDecorators = {
    images: [{ type: Input }],
    showGallery: [{ type: Input }],
    plainGalleryConfig: [{ type: Input }],
    accessibilityConfig: [{ type: Input }],
    show: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PlainGalleryComponent, [{
        type: Component,
        args: [{
                selector: 'ks-plain-gallery',
                template: "<div *ngIf=\"showGallery\"\n     class=\"plain-container\"\n     ksWrap [wrap]=\"wrapStyle\" [width]=\"widthStyle\"\n     ksDirection [direction]=\"directionStyle\" [justify]=\"justifyStyle\"\n     [attr.aria-label]=\"accessibilityConfig?.plainGalleryContentAriaLabel\"\n     [title]=\"accessibilityConfig?.plainGalleryContentTitle\">\n\n  <ng-container *ngFor=\"let imgRow of imageGrid; let i = index\">\n    <ng-container *ngFor=\"let imgCol of imgRow; let j = index\">\n\n      <ng-container *ngIf=\"!configPlainGallery.advanced?.aTags; else aTags\">\n        <img *ngIf=\"imgCol?.modal?.img\"\n             [src]=\"imgCol.plain?.img ? imgCol.plain.img : imgCol.modal.img\"\n             class=\"image\"\n             ksSize [sizeConfig]=\"{width: size?.width, height: size?.height}\"\n             [attr.aria-label]=\"imgCol.plain?.ariaLabel\"\n             [title]=\"imgCol.plain?.title ? imgCol.plain.title : getTitleDisplay(imgCol)\"\n             alt=\"{{imgCol.plain?.alt ? imgCol.plain.alt : getAltPlainDescriptionByImage(imgCol)}}\"\n             [tabindex]=\"0\" role=\"img\"\n             (click)=\"showModalGalleryByImage(imgCol)\" (keyup)=\"showModalGalleryByImage(imgCol)\"/>\n      </ng-container>\n\n      <!-- Add directive to set background with the image url as param to pass thumb or img-->\n      <!-- to do something like this <a style=\"background: url('path to image') 50% 50%/cover\">.-->\n      <ng-template #aTags>\n        <a *ngIf=\"imgCol?.modal?.img\"\n           class=\"a-tag-image\"\n           ksATagBgImage [image]=\"imgCol\" [style]=\"configPlainGallery.advanced?.additionalBackground\"\n           ksSize [sizeConfig]=\"{width: size?.width, height: size?.height}\"\n           [attr.aria-label]=\"imgCol.plain?.ariaLabel\"\n           [title]=\"imgCol.plain?.title ? imgCol.plain.title : getTitleDisplay(imgCol)\"\n           [tabindex]=\"0\"\n           (click)=\"showModalGallery(j)\" (keyup)=\"showModalGallery(j)\"></a>\n      </ng-template>\n\n    </ng-container>\n  </ng-container>\n\n</div>\n\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".plain-container{align-items:center;display:flex}.plain-container .image{cursor:pointer;height:auto;width:50px;margin:2px}.plain-container .a-tag-image{cursor:pointer;margin:2px}"]
            }]
    }], function () { return []; }, { show: [{
            type: Output
        }], images: [{
            type: Input
        }], showGallery: [{
            type: Input
        }], plainGalleryConfig: [{
            type: Input
        }], accessibilityConfig: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Array of all components.
 * @type {?}
 */
const COMPONENTS = [
    BackgroundComponent,
    PlainGalleryComponent,
    ModalGalleryComponent,
    CarouselComponent,
    CarouselPreviewsComponent,
    UpperButtonsComponent,
    DotsComponent,
    PreviewsComponent,
    CurrentImageComponent,
    LoadingSpinnerComponent,
    AccessibleComponent
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// to prevent bad scrolling behaviour on mobile phone with carousels.
// From @mohaxspb (https://github.com/Ks89/angular-modal-gallery/pull/187)
class KsHammerGestureConfig extends HammerGestureConfig {
    /**
     * @param {?} element
     * @return {?}
     */
    buildHammer(element) {
        return new Hammer(element, {
            touchAction: 'pan-y'
        });
    }
}
KsHammerGestureConfig.ɵfac = /*@__PURE__*/ function () { let ɵKsHammerGestureConfig_BaseFactory; return function KsHammerGestureConfig_Factory(t) { return (ɵKsHammerGestureConfig_BaseFactory || (ɵKsHammerGestureConfig_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(KsHammerGestureConfig)))(t || KsHammerGestureConfig); }; }();
KsHammerGestureConfig.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: KsHammerGestureConfig, factory: KsHammerGestureConfig.ɵfac });

/**
 * Module to import it in the root module of your application.
 */
class GalleryModule {
    /**
     * Importing with '.forRoot()' is deprecated. I'll provide a new way to do this in next releases.
     * Will be removed in 8.0.0 or 9.0.0
     * @param {?=} config
     * @return {?}
     */
    static forRoot(config) {
        return {
            ngModule: GalleryModule,
            providers: [
                {
                    provide: KEYBOARD_CONFIGURATION,
                    useValue: config ? config : {}
                },
                {
                    provide: KeyboardService,
                    useFactory: setupKeyboardService,
                    deps: [KEYBOARD_CONFIGURATION]
                }
            ]
        };
    }
}
GalleryModule.ɵfac = function GalleryModule_Factory(t) { return new (t || GalleryModule)(); };
GalleryModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: GalleryModule });
GalleryModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: KsHammerGestureConfig
        }
    ], imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GalleryModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [COMPONENTS, DIRECTIVES],
                exports: [ModalGalleryComponent, CarouselComponent],
                providers: [
                    {
                        provide: HAMMER_GESTURE_CONFIG,
                        useClass: KsHammerGestureConfig
                    }
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(GalleryModule, { declarations: function () { return [BackgroundComponent, PlainGalleryComponent, ModalGalleryComponent, CarouselComponent, CarouselPreviewsComponent, UpperButtonsComponent, DotsComponent, PreviewsComponent, CurrentImageComponent, LoadingSpinnerComponent, AccessibleComponent, ClickOutsideDirective, SizeDirective, KeyboardNavigationDirective, WrapDirective, DirectionDirective, ATagBgImageDirective, DescriptionDirective, MarginDirective, MaxSizeDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ModalGalleryComponent, CarouselComponent]; } }); })();
/**
 * Function to setup the keyboard service inside the `forRoot` method.
 * @param {?} injector
 * @return {?} KeyboardService an instance of the `KeyboardService`
 */
function setupKeyboardService(injector) {
    return new KeyboardService(injector);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { GalleryModule, Action, Image, ImageEvent, ImageModalEvent, DescriptionStrategy, ButtonsStrategy, ButtonType, GalleryService, LoadingType, KS_DEFAULT_ACCESSIBILITY_CONFIG, KS_DEFAULT_BTN_FULL_SCREEN, KS_DEFAULT_BTN_CLOSE, KS_DEFAULT_BTN_DELETE, KS_DEFAULT_BTN_DOWNLOAD, KS_DEFAULT_BTN_EXTURL, KS_DEFAULT_SIZE, LineLayout, GridLayout, AdvancedLayout, PlainGalleryStrategy, AccessibleComponent as ɵi, BackgroundComponent as ɵf, CarouselPreviewsComponent as ɵn, CarouselComponent as ɵe, COMPONENTS as ɵc, CurrentImageComponent as ɵh, LoadingSpinnerComponent as ɵr, DotsComponent as ɵp, ModalGalleryComponent as ɵd, PlainGalleryComponent as ɵg, PreviewsComponent as ɵq, UpperButtonsComponent as ɵo, ATagBgImageDirective as ɵy, ClickOutsideDirective as ɵt, DescriptionDirective as ɵz, DirectionDirective as ɵx, DIRECTIVES as ɵs, KeyboardNavigationDirective as ɵv, MarginDirective as ɵba, MaxSizeDirective as ɵbb, SizeDirective as ɵu, WrapDirective as ɵw, KsHammerGestureConfig as ɵa, setupKeyboardService as ɵb, IdValidatorService as ɵm, KEYBOARD_CONFIGURATION as ɵj, KeyboardService as ɵk };

//# sourceMappingURL=ks89-angular-modal-gallery.js.map